import React, { Component } from "react";
import { renderToString } from 'react-dom/server'
import { Row, Col, Button, Form, Modal, Toast, Card } from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import sha256 from "sha256";
// import SplitPane from "react-split-pane";
import { INVOICE_SECTIONS, RESIZE_DIRECTIONS } from "../../lib/config/enums";
import Ruler from "../../lib/plugins/ruler/Ruler";
import {
  createElement,
  createImageElement,
  companyPath,
  formatDate,
  repairKeyedElementMap,
  convertHtmlAlphaColors,
  resolveTableCellStyle,
  tableCellCss,
  getUnderlineCellClass,
  getRowCellBackground,
  FONT_FAMILIES,
  getListSpacing,
  getShapeBorderSide,
  getShapeBorderStyle,
  getLineShapeStyle,
  getLineRotation,
  SHAPE_BORDER_STYLES,
  getPageNumberSettings,
  getPageNumberStyle,
  formatPageNumber,
  getBadgeSettings,
  getBandsPageNumberStyle,
  getColumnFormat,
  isNumericColumnFormat,
} from "../../lib/global/helpers";
import BadgeSettings from "./new/BadgeSettings";
import Split from 'react-split-it';
import Properties from "./new/properties";
import Head from "./new/head";
import Items from "./new/items";
import Total from "./new/total";
import Foot from "./new/foot";
import HTMLTemplate from "./HTMLTemplate";
import TemplateElement from "./TemplateElement";
import ListLines from "./ListLines";
import { GetSchema, SaveTemplate } from "../../lib/api/data/Request";
import InvoicePreview from './InvoicePreview';
import ColorPicker from "../../lib/plugins/color-picker/ColorPicker";
import { QRCodeSVG } from "qrcode.react";

import { connect } from "react-redux";
import {
  updateProp,
  updateHead,
  updateItems,
  updateTotal,
  updateFoot,
  setSelectedElement,
  moveElement,
  resizeElement,
  setSectionHeight,
  removeHeaderImage,
  updateHeaderLogo,
  updateSplitSizes,
  updateElementStyle,
  updateSection,
  updateBands,
  updatePageFrame
} from "../../../redux/actions/TemplateActions";
import {
  BAND_TYPES,
  LAYOUT_MODES,
  getLayoutMode,
  getTemplateBands,
  getPageSizePx,
  convertToBands,
  convertToSections,
  toFallbackSections,
  createBand,
  createBandSection,
  getPageLayout,
  BAND_PLACEMENT,
  BAND_LINE_HEIGHT,
  getTableMetrics,
  getSetRowHeight,
  getTableBorderRadius,
  getPriceNotifyColours,
  BAND_TABLE_LINE_HEIGHT,
  SECTION_RULES,
  applySectionRule,
  getSectionRegion,
  getSectionRule,
  moveBand,
  CURRENT_DATE_TIME_FIELD,
  CURRENT_DATE_TIME_PATH,
  COLUMN_TOTAL_FIELD,
  COLUMN_TOTAL_PATH,
  CALCULATION_FIELD,
  CALCULATION_PATH,
  CALCULATION_OPS,
  readNumber,
  UNIT_TYPE_FIELDS,
  QUANTITY_COLUMNS,
  UNIT_LAYOUTS,
} from "../../lib/bands/bandModel";
import { renderBandsHtml } from "./HTMLBandTemplate";
import DetailRowLine from "./DetailRowLine";
import SectionSettings from "./new/SectionSettings";
import AddSectionDialog from "./new/AddSectionDialog";
import PageBorderSettings from "./new/PageBorderSettings";
import FieldLabel from "./new/FieldLabel";
import DetailRowSettings from "./new/DetailRowSettings";
import DateTimeTool, { DateTimePatternField } from "./new/DateTimeTool";
import ColumnTotalTool from "./new/ColumnTotalTool";
import { CalculationTool, CalculationEditor, describeTerms, calculationName } from "./new/CalculationTool";
import { FieldVisibility, GroupVisibility, describeCondition, hasCondition, NumberValue } from "./new/VisibilitySettings";
import { getStackOrder, arrangeOrder, ARRANGE } from "../../lib/global/layers";
import { GROUP_HIDE_RULES } from "../../lib/bands/bandLayout";
import ElementName, { defaultItemName, itemDisplayName } from "./new/ElementName";
import { hidesPricing, stripPricing, stripPricingFromClipboard } from "../../lib/config/templateTypes";
import { BandContentPanel } from "./new/foot";
import { BANDS_ENABLED } from "../../lib/config/features";

import { library } from "@fortawesome/fontawesome-svg-core";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HTMLHeaderTemplate from "./HTMLHeaderTemplate";
import HTMLFooterTemplate from "./HTMLFooterTemplate";
import HTMLTotalTemplate from "./HTMLTotalTemplate";

const iconList = Object.keys(Icons)
  .filter((key) => key !== "fas" && key !== "prefix")
  .map((icon) => Icons[icon]);

library.add(...iconList);

// Copied canvas elements are kept here so they can also be pasted into
// another template opened later in the same browser.
const ELEMENT_CLIPBOARD_KEY = "witmeg-template-element-clipboard";
// The stacking buttons in the Arrange section.
const ARRANGE_ACTIONS = [
  { action: ARRANGE.FRONT, icon: "angle-double-up", label: "Bring to front", keys: ["Mod", "Shift", "]"] },
  { action: ARRANGE.FORWARD, icon: "angle-up", label: "Bring forward", keys: ["Mod", "]"] },
  { action: ARRANGE.BACKWARD, icon: "angle-down", label: "Send backward", keys: ["Mod", "["] },
  { action: ARRANGE.BACK, icon: "angle-double-down", label: "Send to back", keys: ["Mod", "Shift", "["] },
];
// Element kinds that can be copied (the logo, company fields, document title
// and VAT summary exist once per template).
const COPYABLE_PATHS = ["elements", "shapes", "qrCodes", "images"];
const CANVAS_SECTIONS = ["head", "total", "foot"];
// How close (px) an element must come to an equal gap or the page centre
// for it to snap there.
const SMART_SNAP_THRESHOLD = 5;
// Line spacing range for text, as a multiple of the font size.
const LINE_HEIGHT_MIN = 0.5;
const LINE_HEIGHT_MAX = 4;
// Thickest a line shape can be made from the toolbar, px.
const LINE_THICKNESS_MAX = 20;
// Sample item rows the items band shows on the canvas in bands mode.
const BANDS_CANVAS_ROWS = 4;
// "Format" choices for data fields (spec §8.2), stored as `element.format`.
const TEXT_FORMAT_PRESETS = {
  none: { label: "As received", format: undefined },
  number0: { label: "Number: 1,234", format: { type: "number", decimals: 0, thousandsSeparator: true } },
  number2: { label: "Number: 1,234.50", format: { type: "number", decimals: 2, thousandsSeparator: true } },
  currency2: { label: "Currency: $1,234.50", format: { type: "currency", decimals: 2, thousandsSeparator: true, currencyPosition: "before" } },
  percent: { label: "Percentage: 12.50%", format: { type: "percentage", decimals: 2, thousandsSeparator: false } },
  dateSlash: { label: "Date: 05/10/2026", format: { type: "date", pattern: "DD/MM/YYYY" } },
  dateTime: { label: "Date: 05/10/2026 06:18", format: { type: "date", pattern: "DD/MM/YYYY HH:mm" } },
  dateLong: { label: "Date: 05 Oct 2026", format: { type: "date", pattern: "DD MMM YYYY" } },
  dateIso: { label: "Date: 2026-10-05", format: { type: "date", pattern: "YYYY-MM-DD" } },
};
const SECTION_LABELS = { head: "Header", total: "Total", foot: "Footer" };

const readElementClipboard = () => {
  try {
    const payload = JSON.parse(window.localStorage.getItem(ELEMENT_CLIPBOARD_KEY) || "null");
    return payload && payload.__type === "witmeg-template-elements" && payload.items?.length ? payload : null;
  } catch (err) {
    return null;
  }
};

// Below this window width the right-hand properties panel collapses on its
// own so the canvas keeps as much room as possible.
const PROPERTIES_PANEL_AUTO_COLLAPSE_WIDTH = 1280;

class NewTemplate extends Component {
  constructor(props) {
    super(props);

    //  console.log(this.props.properties);
    this.canvesWrapper = React.createRef();
    this.canves = React.createRef();

    this.headerContent = React.createRef();
    this.bodyContent = React.createRef();
    this.footerContent = React.createRef();

    // this.selectedElementResizeOn = false;
    // this.selectedElementMoveOn = false;

    this.elementRefs = new Map();
    this._elementRefs = {};
    this._elementDimensions = {};

    this.state = {
      selectedElementName: "",
      wrapper: {
        height: 0,
        width: 0,
      },
      showPageGridLines: false,
      showGridLines: true,
      showPointer: false,
      selectedSection: INVOICE_SECTIONS.PROPS,
      attributes: null,

      measureSpec: {},
      showAlert: false,
      showToolTips: false,
      showSaveConfirm: false,
      isSaving: false,
      isSaved: false,
      successMessage: "",
      errorMessage: "",
      splitSizes: [0.25, 0.55, 0.1, 0.1],
      tempLogo: null,
      selectedElementResizeOn: false,
      selectedElementMoveOn: false,
      activeStyles: {},
      hasCopiedLayout: false,
      showPasteConfirm: false,
      manuallyPositionedElements: new Set(),
      selectedElementIds: [],
      shapeBorderSide: "all",
      // Starts collapsed on narrow screens to leave room for the canvas.
      propertiesPanelCollapsed: window.innerWidth < PROPERTIES_PANEL_AUTO_COLLAPSE_WIDTH,
      // Number of elements on the element clipboard (0 = nothing to paste).
      copiedElementCount: readElementClipboard()?.items.length || 0,
      // Section last clicked on the canvas (element or empty space): where
      // Paste puts elements.
      pasteTargetSection: null,
      showShortcuts: false,
      showBadgeSettings: false,
      showAddSection: false,
      // Last deletion, so it can be undone: [{ ref, original }].
      lastDeleted: null,
    };

    this._setSelectedSection = this._setSelectedSection.bind(this);
    this._slideMouseDown = this._slideMouseDown.bind(this);
    this._slideMouseMove = this._slideMouseMove.bind(this);
    this._slideMouseUp = this._slideMouseUp.bind(this);
    this._selectElementFromChild = this._selectElementFromChild.bind(this);
    this._renderCompanyElements = this._renderCompanyElements.bind(this);
    this._renderVatSummary = this._renderVatSummary.bind(this);
    this.editIcons = {
      bold: {
        title: "Bold",
        property: "fontWeight",
        value: "bold",
        icon: "type-bold",
        isToggle: true
      },

      italic: {
        title: "Italic",
        property: "fontStyle",
        value: "italic",
        icon: "type-italic",
        isToggle: true
      },

      strikethrough: {
        title: "Strikethrough",
        property: "textDecoration",
        value: "line-through",
        icon: "type-strikethrough",
        isToggle: true
      },

      underline: {
        title: "Underline",
        property: "textDecoration",
        value: "underline",
        icon: "type-underline",
        isToggle: true
      },

      // Letter case, as CSS text-transform; shown as text since there are
      // no icons for these (as in the table's text styles).
      capitalize: {
        title: "Capitalize Each Word",
        property: "textTransform",
        value: "capitalize",
        label: "Aa",
        isToggle: true,
        offValue: "none"
      },

      uppercase: {
        title: "UPPERCASE",
        property: "textTransform",
        value: "uppercase",
        label: "AB",
        isToggle: true,
        offValue: "none"
      },

      h1: {
        title: "Header 1",
        property: "heading",
        value: "h1",
        icon: "type-h1",
        isHeading: true,
        isToggle: true,
        offValue: "normal"
      },

      h2: {
        title: "Header 2",
        property: "heading",
        value: "h2",
        icon: "type-h2",
        isHeading: true,
        isToggle: true,
        offValue: "normal"
      },

      h3: {
        title: "Header 3",
        property: "heading",
        value: "h3",
        icon: "type-h3",
        isHeading: true,
        isToggle: true,
        offValue: "normal"
      },

      alignStart: {
        title: "Align Start",
        property: "textAlign",
        value: "left",
        icon: "align-start",
        isToggle: true
      },

      alignCenter: {
        title: "Align Center",
        property: "textAlign",
        value: "center",
        icon: "align-center",
        isToggle: true
      },

      alignEnd: {
        title: "Align End",
        property: "textAlign",
        value: "right",
        icon: "align-end",
        isToggle: true
      },

      listBullet: {
        title: "Bullet List",
        property: "listStyleType",
        value: "disc",
        icon: "list-ul",
        isToggle: true,
        offValue: "none",
        isList: true
      },

      listNumbered: {
        title: "Numbered List",
        property: "listStyleType",
        value: "decimal",
        icon: "list-ol",
        isToggle: true,
        offValue: "none",
        isList: true
      },

      fontSizePlus: {
        title: "Increase font size",
        property: "fontSize",
        value: +1,
        icon: "plus",
        isIncrement: true,
      },

      fontSizeMinus: {
        title: "Decrease font size",
        property: "fontSize",
        value: -1,
        icon: "dash",
        isIncrement: true,
      },
    };

    // How the toolbar lays out editIcons: one group per kind of control,
    // separated by thin dividers.
    this.toolbarGroups = [
      ["bold", "italic", "underline", "strikethrough", "capitalize", "uppercase"],
      ["h1", "h2", "h3"],
      ["alignStart", "alignCenter", "alignEnd"],
      ["listBullet", "listNumbered"],
      ["fontSizeMinus", "fontSizePlus"],
    ];
  }

  _debugElementRefs = () => {
    console.log("=== DEBUG ELEMENT REFS ===");
    console.log("elementRefs Map size:", this.elementRefs.size);
    console.log("_elementRefs object keys:", Object.keys(this._elementRefs));
    console.log("_elementDimensions keys:", Object.keys(this._elementDimensions || {}));

    const companyPropsCount = this.props.properties.head.companyProps
      ? Object.keys(this.props.properties.head.companyProps).filter(key =>
        this.props.properties.head.companyProps[key]?.show
      ).length
      : 0;

    console.log("=== ELEMENT COUNTS ===");
    console.log("Regular elements in head:", Object.keys(this.props.properties.head.elements || {}).length);
    console.log("Company props (shown):", companyPropsCount);
    console.log("Total elements in total:", Object.keys(this.props.properties.total.elements || {}).length);
    console.log("Total elements in foot:", Object.keys(this.props.properties.foot.elements || {}).length);

    this.elementRefs.forEach((element, id) => {
      console.log(`Element ${id}:`, element);
    });
  };

  _registerElementRef = (elementId, domElement) => {
    if (domElement) {
      this.elementRefs.set(elementId, domElement);
      this._elementRefs[elementId] = domElement;

      if (!this._elementDimensions) {
        this._elementDimensions = {};
      }

      const rect = domElement.getBoundingClientRect();
      this._elementDimensions[elementId] = {
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        offsetWidth: domElement.offsetWidth,
        offsetHeight: domElement.offsetHeight
      };

      console.log(`Registered element: ${elementId}`, this._elementDimensions[elementId]);
    }
  };

  _unregisterElementRef = (elementId) => {
    this.elementRefs.delete(elementId);
    delete this._elementRefs[elementId];
    delete this._elementDimensions[elementId];
  };

  _getElementById = (id) => {
    return this.elementRefs.get(id) || this._elementRefs[id];
  };


  _getElementDimensions = (elementId) => {
    const domElement = this._getElementById(elementId);

    if (domElement) {
      const rect = domElement.getBoundingClientRect();
      const style = window.getComputedStyle(domElement);

      return {
        width: rect.width,
        height: rect.height,
        top: parseInt(style.top) || 0,
        left: parseInt(style.left) || 0
      };
    }

    const element = this._findElementInProps(elementId);
    if (element) {
      return {
        width: parseInt(element.style?.width) || 100,
        height: parseInt(element.style?.height) || 50,
        top: parseInt(element.style?.top) || 0,
        left: parseInt(element.style?.left) || 0
      };
    }

    return { width: 100, height: 50, top: 0, left: 0 };
  };

  _getElementDimensionsFromDOM = (elementId) => {
    const domElement = this._getElementById(elementId);

    if (domElement) {
      const rect = domElement.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(domElement);

      let elementHeight = rect.height;
      const elementWidth = rect.width;

      if (computedStyle.whiteSpace === 'pre-line' ||
        domElement.tagName === 'TEXTAREA' ||
        domElement.querySelector('textarea')) {
        const lineHeight = parseInt(computedStyle.lineHeight) || 16;
        const element = this._findElementInProps(elementId);
        if (element && element.text) {
          const lineCount = element.text.split('\n').length;
          elementHeight = Math.max(elementHeight, lineCount * lineHeight + 10);
        }
      }

      return {
        width: elementWidth,
        height: elementHeight,
        top: parseInt(computedStyle.top) || 0,
        left: parseInt(computedStyle.left) || 0
      };
    }

    return { width: 150, height: 30, top: 0, left: 0 };
  };
  _autoReorganizeElements = () => {
    const manuallyPositionedElements = this.state.manuallyPositionedElements;
    const newElements = [];

    if (this.props.properties.head.elements) {
      Object.keys(this.props.properties.head.elements).forEach(key => {
        const element = this.props.properties.head.elements[key];
        if (!manuallyPositionedElements.has(element.id)) {
          const hasDefaultPosition = !element.style ||
            (element.style.top === "40px" && element.style.left === "40px");

          if (hasDefaultPosition) {
            const dimensions = this._getElementDimensionsFromDOM(element.id);
            newElements.push({
              key,
              element: {
                ...element,
                style: {
                  ...element.style,
                  width: dimensions.width + "px",
                  height: dimensions.height + "px",
                  top: dimensions.top + "px",
                  left: dimensions.left + "px"
                }
              },
              isCompanyProp: false,
              dimensions
            });
          }
        }
      });
    }

    if (this.props.properties.head.companyProps) {
      Object.keys(this.props.properties.head.companyProps).forEach(key => {
        const prop = this.props.properties.head.companyProps[key];
        if (prop.show && !manuallyPositionedElements.has(prop.id)) {
          const hasDefaultPosition = !prop.style ||
            (prop.style.top === "40px" && prop.style.left === "40px");

          if (hasDefaultPosition) {
            const dimensions = this._getElementDimensionsFromDOM(prop.id);
            newElements.push({
              key,
              element: {
                ...prop,
                style: {
                  ...prop.style,
                  width: dimensions.width + "px",
                  height: dimensions.height + "px",
                  top: dimensions.top + "px",
                  left: dimensions.left + "px"
                }
              },
              isCompanyProp: true,
              dimensions
            });
          }
        }
      });
    }

    if (newElements.length === 0) {
      return;
    }

    setTimeout(() => {
      this._reorganizeOnlyNewElements(newElements, manuallyPositionedElements);
    }, 100);
  };

  _reorganizeOnlyNewElements = (newElements, manuallyPositionedElements) => {
    const START_X = 40;
    const START_Y = 40;
    const COLUMN_WIDTH = 200;
    const ELEMENTS_PER_COLUMN = 5;
    const MARGIN = 8;
    const MAX_Y = 600;
    const MAX_X = 800;

    const reorganized = {};
    const reorganizedCompanyProps = { ...this.props.properties.head.companyProps };

    const newElementKeys = new Set(newElements.map(n => n.key));
    const columnsMap = {};

    const seedElement = (el, isCompanyPropKey = null) => {
      if (!el || !el.style) return;

      const key = isCompanyPropKey;
      if (key && newElementKeys.has(key)) return;

      const top = parseInt(el.style.top) || 0;
      const left = parseInt(el.style.left) || 0;

      if (top === START_Y && left === START_X) return;

      const elW = parseInt(el.style.width) || 150;
      const elH = parseInt(el.style.height) || 30;

      const colIdx = Math.max(0, Math.round((left - START_X) / COLUMN_WIDTH));
      if (!columnsMap[colIdx]) columnsMap[colIdx] = [];
      columnsMap[colIdx].push({ top, bottom: top + elH, left, right: left + elW });
    };

    if (this.props.properties.head.elements) {
      Object.values(this.props.properties.head.elements).forEach(el => seedElement(el));
    }

    if (this.props.properties.head.companyProps) {
      Object.keys(this.props.properties.head.companyProps).forEach(key => {
        const prop = this.props.properties.head.companyProps[key];
        if (prop.show) seedElement(prop, key);
      });
    }

    Object.keys(columnsMap).forEach(col => {
      columnsMap[col].sort((a, b) => a.top - b.top);
    });

    newElements.forEach(({ key, element, isCompanyProp, dimensions }) => {
      const elHeight = (dimensions && dimensions.height > 0) ? dimensions.height : 30;
      const elWidth = (dimensions && dimensions.width > 0) ? dimensions.width : 150;

      let placed = false;

      for (let colIdx = 0; colIdx <= 20; colIdx++) {
        const colX = START_X + colIdx * COLUMN_WIDTH;
        if (colX + elWidth > MAX_X) break;

        if (!columnsMap[colIdx]) columnsMap[colIdx] = [];
        const col = columnsMap[colIdx];

        if (col.length >= ELEMENTS_PER_COLUMN) continue;

        let posY = null;

        if (col.length === 0) {
          posY = START_Y;
        } else if (col[0].top >= START_Y + elHeight + MARGIN) {
          posY = START_Y;
        } else {
          for (let i = 0; i < col.length - 1; i++) {
            const gapStart = col[i].bottom + MARGIN;
            const gapEnd = col[i + 1].top;
            if (gapEnd - gapStart >= elHeight + MARGIN) {
              posY = gapStart;
              break;
            }
          }
          if (posY === null) {
            const afterLast = col[col.length - 1].bottom + MARGIN;
            if (afterLast + elHeight <= MAX_Y) {
              posY = afterLast;
            }
          }
        }

        if (posY !== null) {
          const newStyle = {
            ...element.style,
            top: posY + "px",
            left: colX + "px",
          };

          col.push({
            top: posY,
            left: colX,
            right: colX + elWidth,
            bottom: posY + elHeight,
          });
          col.sort((a, b) => a.top - b.top);

          if (isCompanyProp) {
            reorganizedCompanyProps[key] = {
              ...reorganizedCompanyProps[key],
              style: newStyle,
            };
          } else {
            reorganized[key] = { ...element, style: newStyle };
          }

          placed = true;
          break;
        }
      }

      if (!placed) {
        console.warn("Could not place element, using fallback position", key);
        const newStyle = { ...element.style, top: START_Y + "px", left: START_X + "px" };
        if (isCompanyProp) {
          reorganizedCompanyProps[key] = { ...reorganizedCompanyProps[key], style: newStyle };
        } else {
          reorganized[key] = { ...element, style: newStyle };
        }
      }
    });

    const updatedHead = {
      ...this.props.properties.head,
      elements: {
        ...this.props.properties.head.elements,
        ...reorganized,
      },
      companyProps: reorganizedCompanyProps,
    };

    this.props.updateHead(updatedHead);
  };

  _reorganizeWithLayout = (allElements, elementIds) => {
    const reorganized = {};
    const reorganizedCompanyProps = { ...this.props.properties.head.companyProps };
    const placedElements = [];

    const ITEMS_PER_COLUMN = 4;
    const COLUMN_WIDTH = 200;
    const START_TOP = 40;
    const START_LEFT = 40;
    const VERTICAL_SPACING = 20;
    const HORIZONTAL_SPACING = 30;

    let currentTop = START_TOP;
    let currentLeft = START_LEFT;
    let itemsInCurrentColumn = 0;

    elementIds.forEach((elementId, index) => {
      let elementKey = null;
      let element = null;

      for (const key in allElements) {
        if (allElements[key].id === elementId) {
          elementKey = key;
          element = allElements[key];
          break;
        }
      }

      if (!element) return;

      const elementRef = this._getElementById(element.id);
      let elementWidth = 100;
      let elementHeight = 30;

      if (elementRef) {
        const rect = elementRef.getBoundingClientRect();
        elementWidth = rect.width;
        elementHeight = rect.height;
      }

      console.log(`Positioning ${elementKey} (${elementWidth}x${elementHeight})`);

      if (itemsInCurrentColumn >= ITEMS_PER_COLUMN) {
        currentLeft += COLUMN_WIDTH + HORIZONTAL_SPACING;
        currentTop = START_TOP;
        itemsInCurrentColumn = 0;
      }

      let positionFound = false;
      let verticalOffset = 0;

      while (!positionFound && verticalOffset < 1000) {
        positionFound = true;
        const testTop = currentTop + verticalOffset;

        const testElement = {
          id: element.id,
          style: {
            top: testTop + "px",
            left: currentLeft + "px",
            width: elementWidth + "px",
            height: elementHeight + "px"
          }
        };

        for (const placed of placedElements) {
          if (this._checkElementOverlap(testElement, placed)) {
            positionFound = false;
            verticalOffset += 5;
            break;
          }
        }

        if (positionFound) {
          currentTop = testTop;
        }
      }

      const updatedElement = {
        ...element,
        style: {
          ...element.style,
          top: currentTop + "px",
          left: currentLeft + "px"
        }
      };

      const isCompanyProp = this.props.properties.head.companyProps &&
        this.props.properties.head.companyProps[elementKey];

      if (isCompanyProp) {
        reorganizedCompanyProps[elementKey] = {
          ...reorganizedCompanyProps[elementKey],
          style: updatedElement.style
        };
      } else {
        reorganized[elementKey] = updatedElement;
      }

      placedElements.push({
        id: element.id,
        style: {
          top: currentTop + "px",
          left: currentLeft + "px",
          width: elementWidth + "px",
          height: elementHeight + "px"
        }
      });

      currentTop += elementHeight + VERTICAL_SPACING;
      itemsInCurrentColumn++;

      console.log(`Placed ${elementKey} at (${currentTop - elementHeight - VERTICAL_SPACING}, ${currentLeft})`);
    });

    const updatedHead = {
      ...this.props.properties.head,
      elements: reorganized,
      companyProps: reorganizedCompanyProps
    };

    this.props.updateHead(updatedHead);
    console.log(`Auto-reorganization complete! Placed ${elementIds.length} elements`);
  };

  _autoReorganizeTotalElements = () => {
    console.log("Auto-reorganizing Total elements...");

    const allElements = {};
    const elementIds = [];

    if (this.props.properties.total.elements) {
      Object.keys(this.props.properties.total.elements).forEach(key => {
        const element = this.props.properties.total.elements[key];
        const isAtDefault = !element.style ||
          (element.style.top === "40px" && element.style.left === "40px");
        if (isAtDefault) {
          allElements[key] = element;
          elementIds.push(element.id);
        }
      });
    }

    if (this.props.properties.total.VatSummary &&
      Object.keys(this.props.properties.total.VatSummary).length > 0) {
      allElements['VatSummary'] = this.props.properties.total.VatSummary;
      elementIds.push(this.props.properties.total.VatSummary.id);
    }

    if (elementIds.length === 0) return;

    setTimeout(() => {
      const missingRefs = elementIds.filter(id => !this._getElementById(id));
      if (missingRefs.length > 0) {
        setTimeout(() => this._autoReorganizeTotalElements(), 100);
        return;
      }

      this._reorganizeTotalWithLayout(allElements, elementIds);
    }, 100);
  };

  _reorganizeTotalWithLayout = (allElements, elementIds) => {
    const reorganized = {};

    const ITEMS_PER_COLUMN = 2;
    const COLUMN_WIDTH = 180;
    const START_X = 40;
    const START_Y = 40;
    const ROW_HEIGHT = 35;
    const COLUMN_SPACING = 30;

    let currentColumn = 0;
    let currentRow = 0;

    elementIds.forEach((elementId, index) => {
      let elementKey = null;
      let element = null;

      for (const key in allElements) {
        if (allElements[key].id === elementId) {
          elementKey = key;
          element = allElements[key];
          break;
        }
      }

      if (!element) return;

      const column = Math.floor(index / ITEMS_PER_COLUMN);
      const row = index % ITEMS_PER_COLUMN;

      const x = START_X + (column * (COLUMN_WIDTH + COLUMN_SPACING));
      const y = START_Y + (row * ROW_HEIGHT);

      const updatedElement = {
        ...element,
        style: {
          ...element.style,
          top: `${y}px`,
          left: `${x}px`
        }
      };

      reorganized[elementKey] = updatedElement;
    });

    const updatedTotal = {
      ...this.props.properties.total
    };

    const updatedElements = {};
    Object.keys(reorganized).forEach(key => {
      if (key === 'VatSummary') {
        updatedTotal.VatSummary = reorganized[key];
      } else {
        updatedElements[key] = reorganized[key];
      }
    });

    updatedTotal.elements = updatedElements;

    this.props.updateTotal(updatedTotal);
    console.log(`Auto-reorganization of Total complete!`);
  };

  _autoReorganizeFootElements = () => {
    console.log("Auto-reorganizing Foot elements...");

    const allElements = {};
    const elementIds = [];

    if (this.props.properties.foot.elements) {
      Object.keys(this.props.properties.foot.elements).forEach(key => {
        const element = this.props.properties.foot.elements[key];
        const isAtDefault = !element.style ||
          (element.style.top === "40px" && element.style.left === "40px");
        if (isAtDefault) {
          allElements[key] = element;
          elementIds.push(element.id);
        }
      });
    }

    if (elementIds.length === 0) return;

    setTimeout(() => {
      const missingRefs = elementIds.filter(id => !this._getElementById(id));
      if (missingRefs.length > 0) {
        setTimeout(() => this._autoReorganizeFootElements(), 100);
        return;
      }

      this._reorganizeFootWithLayout(allElements, elementIds);
    }, 100);
  };

  _reorganizeFootWithLayout = (allElements, elementIds) => {
    const reorganized = {};

    const ITEMS_PER_ROW = 3;
    const ITEM_WIDTH = 200;
    const START_X = 40;
    const START_Y = 20;
    const HORIZONTAL_SPACING = 20;
    const VERTICAL_SPACING = 30;

    elementIds.forEach((elementId, index) => {
      let elementKey = null;
      let element = null;

      for (const key in allElements) {
        if (allElements[key].id === elementId) {
          elementKey = key;
          element = allElements[key];
          break;
        }
      }

      if (!element) return;

      const row = Math.floor(index / ITEMS_PER_ROW);
      const col = index % ITEMS_PER_ROW;

      const x = START_X + (col * (ITEM_WIDTH + HORIZONTAL_SPACING));
      const y = START_Y + (row * VERTICAL_SPACING);

      const updatedElement = {
        ...element,
        style: {
          ...element.style,
          top: `${y}px`,
          left: `${x}px`
        }
      };

      reorganized[elementKey] = updatedElement;
    });

    const updatedFoot = {
      ...this.props.properties.foot,
      elements: reorganized
    };

    this.props.updateFoot(updatedFoot);
    console.log(`Auto-reorganization of Footer complete!`);
  };

  _findElementInProps = (elementId) => {
    const sections = ['head', 'total', 'foot'];

    for (const section of sections) {
      const elements = this.props.properties[section]?.elements || {};
      for (const key in elements) {
        if (elements[key].id === elementId) {
          return elements[key];
        }
      }

      if (section === 'head' && this.props.properties.head.companyProps) {
        const companyProps = this.props.properties.head.companyProps;
        for (const key in companyProps) {
          if (companyProps[key].id === elementId) {
            return companyProps[key];
          }
        }
      }
    }

    return null;
  };

  _checkElementOverlap = (element1, element2) => {
    if (!element1 || !element2) return false;

    const dim1 = this._getElementDimensions(element1.id || element1);
    const dim2 = this._getElementDimensions(element2.id || element2);

    console.log(`Checking overlap: Element1 at (${dim1.left}, ${dim1.top}) [${dim1.width}x${dim1.height}] vs Element2 at (${dim2.left}, ${dim2.top}) [${dim2.width}x${dim2.height}]`);

    const margin = 5;

    const overlap = !(
      dim1.left + dim1.width + margin < dim2.left ||
      dim2.left + dim2.width + margin < dim1.left ||
      dim1.top + dim1.height + margin < dim2.top ||
      dim2.top + dim2.height + margin < dim1.top
    );

    if (overlap) {
      console.log("OVERLAP DETECTED!");
    }

    return overlap;
  };

  _reorganizeElements = () => {
    const allElements = {};

    if (this.props.properties.head.elements) {
      Object.assign(allElements, this.props.properties.head.elements);
    }

    if (this.props.properties.head.companyProps) {
      Object.keys(this.props.properties.head.companyProps).forEach(key => {
        const prop = this.props.properties.head.companyProps[key];
        if (prop.show) {
          allElements[key] = prop;
        }
      });
    }

    const elementKeys = Object.keys(allElements);
    console.log(`Found ${elementKeys.length} total elements to reorganize (including company props)`);

    if (elementKeys.length === 0) {
      console.log("No elements to reorganize");
      return;
    }

    if (this.elementRefs.size === 0 && Object.keys(this._elementRefs).length === 0) {
      console.log("No element refs available yet. Elements might not be mounted.");

      setTimeout(() => {
        console.log("Retrying after delay...");
        this._reorganizeElements();
      }, 1000);
      return;
    }

    console.log("Element refs available:", this.elementRefs.size);

    setTimeout(() => {
      const reorganized = {};
      const reorganizedCompanyProps = { ...this.props.properties.head.companyProps };
      const placedElements = [];

      const offsetPx = 30;
      const columnWidth = 200;
      const maxRowsPerColumn = 10;
      const maxColumns = 3;

      let currentTop = 40;
      let currentLeft = 40;
      let columnIndex = 0;
      let rowIndex = 0;

      elementKeys.forEach((key, index) => {
        const element = allElements[key];

        const elementRef = this._getElementById(element.id);
        let elementWidth = 100;
        let elementHeight = 50;

        if (elementRef) {
          const rect = elementRef.getBoundingClientRect();
          elementWidth = rect.width;
          elementHeight = rect.height;
        }

        console.log(`Element ${key} (${element.id}): ${elementWidth}x${elementHeight}`);

        let positionFound = false;
        let attempts = 0;
        const maxAttempts = 100;

        while (!positionFound && attempts < maxAttempts) {
          positionFound = true;

          for (const placed of placedElements) {
            const testElement = {
              id: element.id,
              style: {
                top: currentTop + "px",
                left: currentLeft + "px",
                width: elementWidth + "px",
                height: elementHeight + "px"
              }
            };

            if (this._checkElementOverlap(testElement, placed)) {
              positionFound = false;

              currentTop += offsetPx;
              rowIndex++;

              if (rowIndex >= maxRowsPerColumn) {
                currentTop = 40;
                currentLeft += columnWidth;
                rowIndex = 0;
                columnIndex++;

                if (columnIndex >= maxColumns) {
                  currentLeft = 40;
                  currentTop += offsetPx * 20;
                  columnIndex = 0;
                  rowIndex = 0;
                }
              }

              break;
            }
          }

          attempts++;
          if (attempts >= maxAttempts) {
            console.warn(`Force placing element ${key} at (${currentTop}, ${currentLeft})`);
            positionFound = true;
          }
        }

        const updatedElement = {
          ...element,
          style: {
            ...element.style,
            top: currentTop + "px",
            left: currentLeft + "px"
          }
        };

        if (this.props.properties.head.companyProps &&
          this.props.properties.head.companyProps[key]) {
          reorganizedCompanyProps[key] = {
            ...reorganizedCompanyProps[key],
            style: updatedElement.style
          };
        } else {
          reorganized[key] = updatedElement;
        }

        placedElements.push({
          id: element.id,
          style: {
            top: currentTop + "px",
            left: currentLeft + "px",
            width: elementWidth + "px",
            height: elementHeight + "px"
          }
        });

        console.log(`Placed element ${key} at (${currentTop}, ${currentLeft})`);

        currentTop += elementHeight + offsetPx;
        rowIndex++;

        if (rowIndex >= maxRowsPerColumn) {
          currentTop = 40;
          currentLeft += columnWidth;
          rowIndex = 0;
          columnIndex++;

          if (columnIndex >= maxColumns) {
            currentLeft = 40;
            currentTop += offsetPx * 20;
            columnIndex = 0;
            rowIndex = 0;
          }
        }
      });

      const properties = {
        ...this.props.properties.head,
        elements: reorganized,
        companyProps: reorganizedCompanyProps
      };

      this.props.updateHead(properties);

      console.log("Reorganization complete!");

    }, 500);
  };
  _setColumnTextAlign = () => {
    const items = this.props.properties.items.items;
    let needsUpdate = false;
    const updatedItems = { ...items };

    Object.keys(updatedItems).forEach(key => {
      if (updatedItems[key] && !updatedItems[key].textAlign) {
        updatedItems[key] = {
          ...updatedItems[key],
          textAlign: 'left'
        };
        needsUpdate = true;
      }
    });

    if (needsUpdate) {
      const updatedItemsSection = {
        ...this.props.properties.items,
        items: updatedItems
      };
      this.props.updateItems(updatedItemsSection);
    }
  };
  componentDidMount() {
    // What the opened template already has, so only later additions count
    // as new (see componentDidUpdate).
    this._sectionItems = this._collectSectionItems();

    // One-time cleanup for templates saved before a fix to how multi-level
    // element names (e.g. "A.B.City") were flattened into map keys: repairs
    // any entries left under a stale/mismatched key or emptied out by a
    // failed move, so future drags on these elements persist correctly.
    const repairedHeadElements = repairKeyedElementMap(this.props.properties.head.elements);
    if (repairedHeadElements !== this.props.properties.head.elements) {
      this.props.updateHead({ ...this.props.properties.head, elements: repairedHeadElements });
    }
    const repairedTotalElements = repairKeyedElementMap(this.props.properties.total.elements);
    if (repairedTotalElements !== this.props.properties.total.elements) {
      this.props.updateTotal({ ...this.props.properties.total, elements: repairedTotalElements });
    }
    const repairedFootElements = repairKeyedElementMap(this.props.properties.foot.elements);
    if (repairedFootElements !== this.props.properties.foot.elements) {
      this.props.updateFoot({ ...this.props.properties.foot, elements: repairedFootElements });
    }

    GetSchema().then((response) => {
      if (response.isSuccess)
        this.setState(
          {
            attributes: response.data.Result,
          },
          function (e) {
            if (
              Object.keys(this.props.properties.head.companyProps).length === 0
            ) {
              var ele = {};
              for (const prop in this.state.attributes[companyPath()]
                .Properties) {
                var element = createElement(companyPath() + "." + prop);
                ele[prop] = {
                  show: false,
                  name: element.name,
                  text: element.text,
                  style: element.style,
                  data: element.data,
                  id: element.id,
                };
              }

              var properties = {
                ...this.props.properties.head,
                companyProps: ele,
              };
              this.props.updateHead(properties);

              const hasExistingElements =
                Object.keys(this.props.properties.head.elements || {}).length > 0 ||
                Object.keys(this.props.properties.total.elements || {}).length > 0 ||
                Object.keys(this.props.properties.foot.elements || {}).length > 0;

              if (!hasExistingElements) {
                setTimeout(() => {
                  this._autoReorganizeElements();
                  this._autoReorganizeTotalElements();
                  this._autoReorganizeFootElements();
                }, 500);
              }
            }
          }
        );
      else {
        this.setState({ errorMessage: response.message });
      }
    });

    this._setColumnTextAlign();

    let totalheight = this.props.heights.head + this.props.heights.body + this.props.heights.total + this.props.heights.foot
    this.setState({
      isEdited: false,
      wrapper: {
        height: this.canvesWrapper.offsetHeight,
        width: this.canvesWrapper.offsetWidth,
      },

      sliderHeadMousedown: false,
      sliderBodyMouseDown: false,
      sliderTotalMouseDown: false,
      splitSizes: [this.props.heights.head / totalheight, this.props.heights.body / totalheight, this.props.heights.total / totalheight, this.props.heights.foot / totalheight]
    });

    // Keep the Paste button's enabled state in sync with whether the
    // clipboard actually holds a copied layout right now — checked on load
    // and again whenever the window regains focus (e.g. after copying in
    // another tab), since the clipboard can change outside this session.
    this._checkClipboardForLayout();
    window.addEventListener("focus", this._checkClipboardForLayout);
    window.addEventListener("keydown", this._onGroupShortcutKeyDown);
    window.addEventListener("keydown", this._onArrangeShortcutKeyDown);
    window.addEventListener("keydown", this._onClipboardKeyDown);
    window.addEventListener("keydown", this._onDeleteKeyDown);
    window.addEventListener("keydown", this._onHelpKeyDown);
    this._wasNarrowWindow = window.innerWidth < PROPERTIES_PANEL_AUTO_COLLAPSE_WIDTH;
    window.addEventListener("resize", this._onWindowResize);
    // Lock the page behind the editor so only the editor's own areas scroll.
    document.documentElement.classList.add("template-editor-open");
  }

  componentWillUnmount() {
    window.removeEventListener("focus", this._checkClipboardForLayout);
    window.removeEventListener("keydown", this._onGroupShortcutKeyDown);
    window.removeEventListener("keydown", this._onArrangeShortcutKeyDown);
    window.removeEventListener("keydown", this._onClipboardKeyDown);
    window.removeEventListener("keydown", this._onDeleteKeyDown);
    window.removeEventListener("keydown", this._onHelpKeyDown);
    window.removeEventListener("resize", this._onWindowResize);
    document.documentElement.classList.remove("template-editor-open");
    if (this._resizeFrame) window.cancelAnimationFrame(this._resizeFrame);
  }



  _setMeasureSpec = (value) => {
    this.setState({ measureSpec: value });
  };

  _changeProprtyProp = function (name, obj) {
    this.setState(
      {
        properties: {
          ...this.props.properties,
          [name]: obj,
        },
        isEdited: true,
      },
      function () {
        //console.log(name, obj, this.props.properties);
      }
    );
  };

  _selectElementFromChild = function (id) {
    var ele = document.getElementById(id);
    ele.click();
  };

  _setSelectedSection(obj) {
    this.setState({ selectedSection: obj });
  }

  // Canvas page-number marker → switch to the Properties tab and bring the
  // page-number settings into view, briefly highlighting them.
  _openPageNumberSettings = () => {
    this.setState({ selectedSection: INVOICE_SECTIONS.PROPS }, () => {
      const settings = document.getElementById("page-number-settings");
      if (!settings) return;
      settings.scrollIntoView({ behavior: "smooth", block: "center" });
      settings.classList.remove("is-highlighted");
      // Restart the highlight animation if it's clicked again.
      void settings.offsetWidth;
      settings.classList.add("is-highlighted");
    });
  };

  _slideMouseDown = function (e, obj) {
    if (obj == "head")
      this.setState({
        sliderHeadMousedown: true,
        sliderBodyMouseDown: false,
        sliderTotalMouseDown: false,
      });
    else if (obj == "body")
      this.setState({
        sliderHeadMousedown: false,
        sliderBodyMouseDown: true,
        sliderTotalMouseDown: false,
      });
    else if (obj == "total")
      this.setState({
        sliderHeadMousedown: false,
        sliderBodyMouseDown: false,
        sliderTotalMouseDown: true,
      });
  };

  _slideMouseMove = function (e) {
    if (
      this.state.sliderHeadMousedown ||
      this.state.sliderBodyMouseDown ||
      this.state.sliderTotalMouseDown
    ) {
      let currentTargetRect = this.canves.getBoundingClientRect();
      var arrowY = e.clientY - currentTargetRect.top;

      var height = (arrowY / this.canves.offsetHeight) * 100;
      height = height < 0 ? 0 : height;

      var head_h = this.props.heights.head;
      var body_h = this.props.heights.body;
      var totl_h = this.props.heights.total;
      var foot_h = this.props.heights.foot;

      var head_new_h = head_h;
      var body_new_h = body_h;
      var totl_new_h = totl_h;
      var foot_new_h = foot_h;
      var diff = 0;

      //console.log(this.canves.offset);

      if (this.state.sliderHeadMousedown) {
        diff = height - head_h;
        head_new_h = height;
        body_new_h = body_h - diff;
      } else if (this.state.sliderBodyMouseDown) {
        height -= head_h;
        diff = height - body_h;
        body_new_h = height;
        totl_new_h = totl_h - diff;
      } else if (this.state.sliderTotalMouseDown) {
        height -= body_h + head_h;
        diff = height - totl_h;
        totl_new_h = height;
        foot_new_h = foot_h - diff;
      }

      this.props.setSectionHeight(
        head_new_h,
        body_new_h,
        totl_new_h,
        foot_new_h
      );
    }
  };

  _slideMouseUp = function (e) {
    this.setState({
      sliderHeadMousedown: false,
      sliderBodyMouseDown: false,
      sliderTotalMouseDown: false,
    });
  };

  _updateActiveStyles = (element) => {
    if (!element || !element.style) {
      this.setState({ activeStyles: {} });
      return;
    }

    const activeStyles = {};
    const { style } = element;

    activeStyles.bold = style.fontWeight === "bold";

    activeStyles.italic = style.fontStyle === "italic";

    activeStyles.underline = style.textDecoration === "underline";

    activeStyles.strikethrough = style.textDecoration === "line-through";

    activeStyles.capitalize = style.textTransform === "capitalize";
    activeStyles.uppercase = style.textTransform === "uppercase";

    if (style.textAlign === "left") activeStyles.alignStart = true;
    if (style.textAlign === "center") activeStyles.alignCenter = true;
    if (style.textAlign === "right") activeStyles.alignEnd = true;

    if (style.listStyleType === "disc") activeStyles.listBullet = true;
    if (style.listStyleType === "decimal") activeStyles.listNumbered = true;

    if (style.fontSize === "24pt" && style.fontWeight === "bold") {
      activeStyles.h1 = true;
    } else if (style.fontSize === "20pt" && style.fontWeight === "bold") {
      activeStyles.h2 = true;
    } else if (style.fontSize === "16pt" && style.fontWeight === "bold") {
      activeStyles.h3 = true;
    }

    this.setState({ activeStyles });
  };

  _handleStyleUpdate = (property, value, isIncrement = false, isHeading = false, isToggle = false, offValue = null, isList = false) => {
    console.log("toggleValue11: ", value);
    console.log("offValue: ", offValue);
    console.log("isToggle: ", isToggle)
    console.log("property: ", property)
    const { selectedElement } = this.props;
    console.log("selectedElement :", selectedElement)
    const { section, path, index } = selectedElement;

    if (this._isMultiSelection()) {
      this._handleGroupStyleUpdate(property, value, isIncrement, isHeading, isToggle, offValue);
      return;
    }

    if (!section || !path) return;

    if (path === "documentTitle" || path === "VatSummary") {
      this._handleSpecialElementStyleUpdate(section, path, property, value, isIncrement, isHeading, isToggle, offValue, isList);
      return;
    }

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    console.log("currentElement: ", currentElement);

    let newValue = value;
    // if (isList && isToggle && selectedElement?.element?.data !== "customText" && path !== "companyProps" && path === "documentTitle") {
    //   const currentListStyle = currentElement.style?.listStyleType;
    //   const toggleValue = currentListStyle === value ? offValue : value;

    //   const updatedElement = {
    //     ...currentElement,
    //     style: {
    //       ...currentElement.style,
    //       listStyleType: toggleValue,
    //       display: toggleValue !== "none" ? "list-item" : "block",
    //       marginLeft: toggleValue !== "none" ? "20px" : "0px",
    //     }
    //   };

    //   const domElement = document.getElementById(currentElement.id);
    //   if (domElement) {
    //     domElement.style.listStyleType = toggleValue;
    //     domElement.style.display = toggleValue !== "none" ? "list-item" : "block";
    //     domElement.style.marginLeft = toggleValue !== "none" ? "20px" : "0px";
    //   }

    //   this._updateElementInState(section, path, index, updatedElement);
    //   this._updateActiveStyles(updatedElement);
    //   return;
    // }
    if (isHeading && isToggle) {
      const headingStyles = {
        h1: {
          fontWeight: "bold",
          fontSize: "24pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h2: {
          fontWeight: "bold",
          fontSize: "20pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h3: {
          fontWeight: "bold",
          fontSize: "16pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        normal: {
          fontWeight: "normal",
          fontSize: this.props.properties.prop.fontSize + "pt",
          textDecoration: "none",
          fontStyle: "normal"
        }
      };

      const currentIsHeading =
        (currentElement.style?.fontSize === "24pt" && value === "h1") ||
        (currentElement.style?.fontSize === "20pt" && value === "h2") ||
        (currentElement.style?.fontSize === "16pt" && value === "h3");

      const toggleValue = currentIsHeading ? offValue : value;
      console.log("toggleValue: ", toggleValue);
      const headingStyle = headingStyles[toggleValue];

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          ...headingStyle
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        Object.keys(headingStyle).forEach(prop => {
          domElement.style[prop] = headingStyle[prop];
        });
      }

      this._updateElementInState(section, path, index, updatedElement);
      this._updateActiveStyles(updatedElement);
      return;
    }
    if (isToggle) {
      const currentValue = currentElement.style?.[property];
      let toggleValue;

      if (property === "textDecoration") {
        const hasValue = currentValue === value ||
          (currentValue && currentValue.includes(value));
        toggleValue = hasValue ? offValue : value;
      } else {
        toggleValue = currentValue === value ? offValue : value;
      }

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          [property]: toggleValue
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        domElement.style[property] = toggleValue;
      }

      this._updateElementInState(section, path, index, updatedElement);

      this._updateActiveStyles(updatedElement);
      return;
    }
    if (isIncrement && property === "fontSize") {
      let currentSize = 10;

      if (currentElement.style?.fontSize) {
        currentSize = this._parseFontSize(currentElement.style.fontSize);
      }
      else if (this.props.properties[section]?.font?.fontSize) {
        currentSize = this._parseFontSize(this.props.properties[section].font.fontSize);
      }
      else if (this.props.properties.prop?.fontSize) {
        currentSize = this._parseFontSize(this.props.properties.prop.fontSize);
      }

      newValue = (currentSize + value) + "pt";
    } else if (property === "fontSize" && !isIncrement) {
      newValue = value.toString().endsWith("pt") || value.toString().endsWith("px") ? value : value + "pt";
    }

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        [property]: isIncrement ? newValue : value
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style[property] = isIncrement ? newValue : value;
    }

    this._updateElementInState(section, path, index, updatedElement);

    if (property === "textAlign") {
      this._updateActiveStyles(updatedElement);
    }

    // switch (section) {
    //   case 'head':
    //     this.props.updateHead({
    //       ...this.props.properties.head,
    //       [path]: {
    //         ...this.props.properties.head[path],
    //         [index]: updatedElement
    //       }
    //     });
    //     break;

    //   case 'total':
    //     this.props.updateTotal({
    //       ...this.props.properties.total,
    //       [path]: {
    //         ...this.props.properties.total[path],
    //         [index]: updatedElement
    //       }
    //     });
    //     break;

    //   case 'foot':
    //     this.props.updateFoot({
    //       ...this.props.properties.foot,
    //       [path]: {
    //         ...this.props.properties.foot[path],
    //         [index]: updatedElement
    //       }
    //     });
    //     break;

    //   default:
    //     break;
    // }
  };

  _handleLinkUpdate = (value) => {
    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    if (!section || !path) return;
    if (path === "documentTitle" || path === "VatSummary") return;

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const updatedElement = {
      ...currentElement,
      link: value
    };

    this._updateElementInState(section, path, index, updatedElement);
  };

  _getSelectedElementLink = () => {
    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement || {};

    if (!section || !path || path === "documentTitle" || path === "VatSummary" || path === "qrCodes" || path === "images") return null;

    const currentElement = this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return null;

    return currentElement.link || "";
  };

  // Re-measures the canvas column for the rulers after its size changed.
  _measureCanvasWrapper = () => {
    window.requestAnimationFrame(() => {
      if (!this.canvesWrapper) return;
      this.setState({
        wrapper: {
          height: this.canvesWrapper.offsetHeight,
          width: this.canvesWrapper.offsetWidth,
        },
      });
    });
  };

  _setPropertiesPanelCollapsed = (collapsed) => {
    this.setState({ propertiesPanelCollapsed: collapsed }, this._measureCanvasWrapper);
  };

  // Collapses the properties panel when the window becomes narrow and
  // re-opens it when it becomes wide again. Only reacts when the window
  // crosses the threshold, so opening/closing it by hand is respected.
  _onWindowResize = () => {
    if (this._resizeFrame) return;
    this._resizeFrame = window.requestAnimationFrame(() => {
      this._resizeFrame = null;
      const isNarrow = window.innerWidth < PROPERTIES_PANEL_AUTO_COLLAPSE_WIDTH;
      const wasNarrow = this._wasNarrowWindow ?? (window.innerWidth < PROPERTIES_PANEL_AUTO_COLLAPSE_WIDTH);
      this._wasNarrowWindow = isNarrow;

      if (isNarrow !== wasNarrow && this.state.propertiesPanelCollapsed !== isNarrow) {
        this._setPropertiesPanelCollapsed(isNarrow);
      } else {
        this._measureCanvasWrapper();
      }
    });
  };

  //#region Keyboard shortcut labels + cheat sheet
  // Shortcut keys are shown on the Arrange buttons; the full list is in a
  // cheat sheet opened from the "?" button in the panel header or the ? key.

  _isMacPlatform = () => /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent || "");

  // ["Mod", "Shift", "G"] -> "Ctrl+Shift+G" (or "⇧⌘G" on a Mac).
  _formatShortcut = (keys) => {
    const mac = this._isMacPlatform();
    const names = { Mod: mac ? "⌘" : "Ctrl", Shift: mac ? "⇧" : "Shift", Alt: mac ? "⌥" : "Alt" };
    const parts = keys.map((key) => names[key] || key);
    if (!mac) return parts.join("+");
    // Mac convention: modifiers in ⌥⇧⌘ order, no separators.
    const order = ["⌥", "⇧", "⌘"];
    const mods = parts.filter((p) => order.includes(p)).sort((a, b) => order.indexOf(a) - order.indexOf(b));
    const rest = parts.filter((p) => !order.includes(p));
    return mods.join("") + rest.join("+");
  };

  _getShortcutGroups = () => [
    {
      title: "Selection",
      items: [
        { combos: [["Click"]], label: "Select an element (selects its whole group if grouped)" },
        { combos: [["Alt", "Click"]], label: "Select one element inside a group" },
        { combos: [["Mod", "Click"], ["Shift", "Click"]], label: "Add to or remove from the selection" },
      ],
    },
    {
      title: "Edit",
      items: [
        { combos: [["Mod", "C"]], label: "Copy" },
        { combos: [["Mod", "V"]], label: "Paste into the section last clicked" },
        { combos: [["Mod", "D"]], label: "Duplicate in the same section" },
        { combos: [["Delete"], ["Backspace"]], label: "Delete the selection" },
        { combos: [["Mod", "Z"]], label: "Undo the last delete" },
      ],
    },
    {
      title: "Arrange",
      items: [
        { combos: [["Mod", "G"]], label: "Group the selection" },
        { combos: [["Mod", "Shift", "G"]], label: "Ungroup" },
        { combos: [["Mod", "Shift", "]"]], label: "Bring to front" },
        { combos: [["Mod", "]"]], label: "Bring forward" },
        { combos: [["Mod", "["]], label: "Send backward" },
        { combos: [["Mod", "Shift", "["]], label: "Send to back" },
      ],
    },
    {
      title: "Help",
      items: [{ combos: [["?"]], label: "Show this list" }],
    },
  ];

  _onHelpKeyDown = (e) => {
    if (e.key !== "?" || e.ctrlKey || e.metaKey || e.altKey) return;
    const target = e.target;
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT" || target.isContentEditable)) return;
    e.preventDefault();
    this.setState({ showShortcuts: !this.state.showShortcuts });
  };

  // An Arrange button; its shortcut shows in the tooltip on hover.
  _renderActionRow = ({ icon, label, keys, onClick, disabled, danger, title }) => (
    <button
      type="button"
      className={"btn btn-sm " + (danger ? "btn-outline-danger" : "btn-outline-secondary")}
      title={(title || label) + (keys ? ` (${this._formatShortcut(keys)})` : "")}
      disabled={disabled}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={icon} className="me-1" />
      {label}
    </button>
  );

  _renderShortcutsModal = () => {
    const mac = this._isMacPlatform();
    const renderCombo = (combo, i) => (
      <span key={i} className="shortcuts-combo">
        {combo.map((key, k) => (
          <React.Fragment key={k}>
            {k > 0 && !mac && <span className="shortcuts-plus">+</span>}
            <kbd>{this._formatShortcut([key])}</kbd>
          </React.Fragment>
        ))}
      </span>
    );

    return (
      <Modal
        show={this.state.showShortcuts}
        onHide={() => this.setState({ showShortcuts: false })}
        centered
        dialogClassName="shortcuts-modal"
        backdropClassName="preview-modal-backdrop"
        style={{ zIndex: 10700 }}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">Keyboard shortcuts</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this._getShortcutGroups().map((group) => (
            <div key={group.title} className="shortcuts-group">
              <div className="shortcuts-group-title">{group.title}</div>
              {group.items.map((item) => (
                <div key={item.label} className="shortcuts-row">
                  <span className="shortcuts-label">{item.label}</span>
                  <span className="shortcuts-keys">
                    {item.combos.map((combo, i) => (
                      <React.Fragment key={i}>
                        {i > 0 && <span className="shortcuts-or">or</span>}
                        {renderCombo(combo, i)}
                      </React.Fragment>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          ))}
        </Modal.Body>
      </Modal>
    );
  };
  //#endregion

  // Short description of the selection for the properties panel header.
  _getSelectionSummary = () => {
    const refs = this._getSelectionRefs();
    if (refs.length > 1) return this._renderSelectionList(refs);

    const ref = refs[0] || this._getElementRefFromDom(document.getElementById(this.state.selectedElementName));
    if (!ref) return "Selected element";

    const key = ref.key || "";
    const typeByPath = {
      shapes: key.startsWith("line") ? "Line" : key.startsWith("circle") ? "Circle" : "Rectangle",
      qrCodes: "QR code",
      images: "Image",
      logo: "Logo",
      documentTitle: "Document title",
      VatSummary: "VAT summary",
      companyProps: "Company field",
      elements: "Text",
    };
    const type = typeByPath[ref.path] || "Element";
    const data = this._getElementDataByRef(ref);
    if ((ref.path === "shapes" || ref.path === "qrCodes") && data) {
      return (
        <>
          {type}
          <span className="text-muted fw-normal"> · </span>
          <ElementName
            className="fw-normal"
            label={data.label}
            fallback={defaultItemName(ref.path, ref.key)}
            onRename={(label) => this._renameRef(ref, label)}
          />
        </>
      );
    }
    const name = data?.name;

    return (
      <>
        {type}
        {name && <span className="text-muted fw-normal"> · {name}</span>}
      </>
    );
  };

  // ---- Font family (text elements) ----
  // "" means "use the section's default font" (no fontFamily on the element).

  _getSelectedElementFontFamily = () => this._getPrimaryElementData()?.style?.fontFamily || "";

  _getSelectedSectionFontFamily = () => {
    const ref = this._getElementRefFromDom(document.getElementById(this.state.selectedElementName));
    return (ref && this.props.properties[ref.section]?.font?.fontFamily) || "Inter";
  };

  _handleFontFamilyUpdate = (fontFamily) => {
    this._applyToSelection(this._canRefHaveText, (el) => {
      const style = { ...(el.style || {}) };
      if (fontFamily) style.fontFamily = fontFamily;
      else delete style.fontFamily;
      return { ...el, style };
    });
  };

  // ---- List spacing (bulleted/numbered text) ----

  _getPrimaryElementData = () => {
    const ref = this._getElementRefFromDom(document.getElementById(this.state.selectedElementName));
    return ref ? this._getElementDataByRef(ref) : null;
  };

  _isListElement = (data) => !!data?.style?.listStyleType && data.style.listStyleType !== "none";

  _selectedElementHasList = () => this._isListElement(this._getPrimaryElementData());

  _handleListSpacingUpdate = (value) => {
    const spacing = Math.max(0, parseFloat(value) || 0);
    // Applies to the selected element and, in a multi-selection, every other
    // selected element that is a list.
    this._applyToSelection(
      (ref) => this._canRefHaveText(ref) && this._isListElement(this._getElementDataByRef(ref)),
      (el) => ({ ...el, listSpacing: spacing })
    );
  };

  // Whether the toolbar's second row (input fields) has anything to show for
  // the selected element.
  _selectedElementHasToolbarFields = () => (
    this._selectedElementHasList() ||
    this._isSelectedElementShape() ||
    this._canSelectedElementHaveFontColor() ||
    this._isSelectedElementLine() ||
    this._isSelectedElementGenerateModeQRCode() ||
    this._getSelectedElementLink() !== null ||
    ((BANDS_ENABLED || this._isBandsMode()) && this._canSelectedElementKeepInRow())
  );

  _isSelectedElementLine = () => {
    const { selectedElement } = this.props;
    const { path, index } = selectedElement || {};
    return path === "shapes" && !!index && index.startsWith("line");
  };

  _isSelectedElementShape = () => {
    const { selectedElement } = this.props;
    return selectedElement?.path === "shapes";
  };

  // Everything placed on the canvas can keep in row (docs/bands-spec.md
  // §5.2): text, the logo, the document title, the VAT summary, images, QR
  // codes and shapes, but not a section's own border ("border").
  _canRefKeepInRow = (ref) => !!ref && (
    ["elements", "companyProps", "logo", "documentTitle", "VatSummary", "images", "qrCodes"].includes(ref.path) ||
    (ref.path === "shapes" && !!ref.key && ref.key !== "border")
  );

  _canSelectedElementKeepInRow = () =>
    this._canRefKeepInRow(this._getElementRefFromDom(document.getElementById(this.state.selectedElementName)));

  _getSelectedShapeColor = (field, sectionFallbackField) => {
    if (!this._isSelectedElementShape()) return null;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return null;

    const sectionDefault = this.props.properties[section]?.shapes?.border?.[sectionFallbackField];
    return currentElement[field] || sectionDefault || "#333333FF";
  };

  _handleShapeColorUpdate = (field, hex) => {
    if (!this._isSelectedElementShape()) return;

    if (this._isMultiSelection()) {
      this._applyToSelection((ref) => ref.path === "shapes", (el) => ({ ...el, [field]: hex }));
      return;
    }

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const updatedElement = {
      ...currentElement,
      [field]: hex
    };

    this._updateElementInState(section, path, index, updatedElement);
  };

  // ---- Shape borders (box/circle): "all" sides or one side at a time ----

  _isSelectedElementBox = () => {
    const { selectedElement } = this.props;
    const { path, index } = selectedElement || {};
    return path === "shapes" && !!index && index.startsWith("box");
  };

  _getSelectedShapeBorder = () => {
    const { section, path, index } = this.props.selectedElement || {};
    const shape = this.props.properties[section]?.[path]?.[index];
    if (!shape) return null;
    return getShapeBorderSide(shape, this.props.properties[section]?.shapes?.border, this.state.shapeBorderSide);
  };

  // field: "color" | "width". "all" sets the shape-wide value and clears that
  // field from every side override, so every side gets it.
  _handleShapeBorderUpdate = (field, value) => {
    const side = this.state.shapeBorderSide;
    const shapeField = { color: "borderColor", width: "borderWidth", style: "borderStyle" }[field];

    const update = (el) => {
      if (side === "all") {
        const borderSides = {};
        Object.keys(el.borderSides || {}).forEach((s) => {
          const { [field]: _removed, ...rest } = el.borderSides[s] || {};
          if (Object.keys(rest).length) borderSides[s] = rest;
        });
        return { ...el, [shapeField]: value, borderSides };
      }
      return {
        ...el,
        borderSides: {
          ...(el.borderSides || {}),
          [side]: { ...((el.borderSides || {})[side] || {}), [field]: value },
        },
      };
    };

    const isBorderShape = (ref) => ref.path === "shapes" && !(ref.key || "").startsWith("line");

    if (this._isMultiSelection()) {
      this._applyToSelection(isBorderShape, update);
      return;
    }

    const { section, path, index } = this.props.selectedElement;
    const current = this.props.properties[section]?.[path]?.[index];
    if (!current) return;
    this._updateElementInState(section, path, index, update(current));
  };

  // Border style (solid/dashed/dotted). Lines have a single style; boxes and
  // circles follow the All/Top/Right/Bottom/Left side picker.
  _getSelectedShapeBorderStyle = () => {
    const { section, path, index } = this.props.selectedElement || {};
    const shape = this.props.properties[section]?.[path]?.[index];
    if (!shape) return "solid";
    const side = this._isSelectedElementLine() ? "all" : this.state.shapeBorderSide;
    return getShapeBorderSide(shape, this.props.properties[section]?.shapes?.border, side).style;
  };

  _handleShapeBorderStyleUpdate = (value) => {
    if (!this._isSelectedElementLine()) {
      this._handleShapeBorderUpdate("style", value);
      return;
    }

    const update = (el) => ({ ...el, borderStyle: value });
    if (this._isMultiSelection()) {
      this._applyToSelection((ref) => ref.path === "shapes" && (ref.key || "").startsWith("line"), update);
      return;
    }

    const { section, path, index } = this.props.selectedElement;
    const current = this.props.properties[section]?.[path]?.[index];
    if (!current) return;
    this._updateElementInState(section, path, index, update(current));
  };

  _getSelectedShapeRadius = () => {
    const { section, path, index } = this.props.selectedElement || {};
    const shape = this.props.properties[section]?.[path]?.[index];
    return shape ? (parseInt(shape.style?.borderRadius, 10) || 0) : 0;
  };

  _handleShapeRadiusUpdate = (value) => {
    const radius = Math.max(0, parseInt(value, 10) || 0);
    const update = (el) => ({ ...el, style: { ...el.style, borderRadius: radius + "px" } });

    if (this._isMultiSelection()) {
      this._applyToSelection((ref) => ref.path === "shapes" && (ref.key || "").startsWith("box"), update);
      return;
    }

    const { section, path, index } = this.props.selectedElement;
    const current = this.props.properties[section]?.[path]?.[index];
    if (!current) return;
    this._updateElementInState(section, path, index, update(current));
  };

  // Padding of a box: a guide for placing things inside it (elements snap to
  // it, see _getShapeSnapGuides). It doesn't change how the box looks.
  _getSelectedShapePadding = () => {
    const { section, path, index } = this.props.selectedElement || {};
    const shape = this.props.properties[section]?.[path]?.[index];
    return shape ? (parseInt(shape.padding, 10) || 0) : 0;
  };

  _handleShapePaddingUpdate = (value) => {
    const padding = Math.max(0, parseInt(value, 10) || 0);
    const update = (el) => {
      const next = { ...el };
      if (padding > 0) next.padding = padding;
      else delete next.padding;
      return next;
    };

    if (this._isMultiSelection()) {
      this._applyToSelection((ref) => ref.path === "shapes" && (ref.key || "").startsWith("box"), update);
      return;
    }

    const { section, path, index } = this.props.selectedElement;
    const current = this.props.properties[section]?.[path]?.[index];
    if (!current) return;
    this._updateElementInState(section, path, index, update(current));
  };

  _handleLineWidthUpdate = (value) => {
    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    if (!this._isSelectedElementLine()) return;

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const width = Math.max(1, parseInt(value, 10) || 0);

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        width: width + "px"
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style.width = width + "px";
    }

    this._updateElementInState(section, path, index, updatedElement);
  };

  // A line's thickness is its height (solid lines are a filled bar,
  // dashed/dotted ones a top border that thick; see getLineShapeStyle).
  _handleLineThicknessUpdate = (value) => {
    if (!this._isSelectedElementLine()) return;
    const thickness = Math.min(LINE_THICKNESS_MAX, Math.max(1, parseInt(value, 10) || 0));
    const setThickness = (el) => ({ ...el, style: { ...el.style, height: thickness + "px" } });

    if (this._isMultiSelection()) {
      this._applyToSelection((ref) => ref.path === "shapes" && String(ref.key || "").startsWith("line"), setThickness);
      return;
    }

    const { section, path, index } = this.props.selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return;
    this._updateElementInState(section, path, index, setThickness(currentElement));
  };

  _getSelectedElementLineThickness = () => {
    if (!this._isSelectedElementLine()) return null;
    const { section, path, index } = this.props.selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];
    return parseInt(currentElement?.style?.height, 10) || 2;
  };

  _getSelectedElementLineWidth = () => {
    if (!this._isSelectedElementLine()) return null;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return null;

    return parseInt(currentElement.style?.width, 10) || "";
  };

  _canSelectedElementHaveFontColor = () => {
    const { selectedElement } = this.props;
    const { section, path } = selectedElement || {};
    return !!section && !!path && path !== "shapes" && path !== "logo" && path !== "qrCodes" && path !== "images";
  };

  // Currency toggle only applies to a "value" the user has added to the
  // canvas (a merge-bound text element or a company-info field) — not
  // shapes/logo/QR (no text), and not documentTitle/VatSummary (a heading
  // and a whole table, not a single prefixable value).
  _canSelectedElementHaveCurrency = () => {
    const { selectedElement } = this.props;
    const { section, path } = selectedElement || {};
    return !!section && !!path && (path === "elements" || path === "companyProps");
  };

  _getSelectedElementCurrency = () => {
    if (!this._canSelectedElementHaveCurrency()) return false;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];

    return !!currentElement?.showCurrency;
  };

  _handleCurrencyToggle = (checked) => {
    if (!this._canSelectedElementHaveCurrency()) return;

    if (this._isMultiSelection()) {
      this._applyToSelection(
        (ref) => ref.path === "elements" || ref.path === "companyProps",
        (el) => ({ ...el, showCurrency: checked })
      );
      return;
    }

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const updatedElement = {
      ...currentElement,
      showCurrency: checked
    };

    this._updateElementInState(section, path, index, updatedElement);
  };

  // Badge / colour rules apply to the same values as the currency toggle.
  // The selected text element when exactly one is selected, for the Text
  // field; the date & time element is left out (its text is its format).
  _getSelectedTextElement = () => {
    if (this._isMultiSelection()) return null;
    const { section, path, index } = this.props.selectedElement || {};
    if (path !== "elements") return null;
    const element = this.props.properties[section]?.elements?.[index];
    return element && element.data !== CURRENT_DATE_TIME_FIELD ? element : null;
  };

  // Text wraps at the box's width unless its style is "pre" (or "nowrap"):
  // then each line stays on one line, and typed line breaks still count.
  _isTextWrapped = (element) => !["pre", "nowrap"].includes(element?.style?.whiteSpace);

  _setSelectedTextWrap = (wrap) => {
    this._applyToSelection(
      (ref) => ref.path === "elements" || ref.path === "companyProps",
      (el) => ({ ...el, style: { ...(el.style || {}), whiteSpace: wrap ? "pre-line" : "pre" } })
    );
  };

  _isCustomTextElement = (element) =>
    element.data === "customText" || String(element.name || "").includes("Custom-Text-");

  // Same rules as the section panel: custom text keeps its line breaks, a
  // data field stays on one line.
  _handleSelectedTextChange = (value) => {
    const element = this._getSelectedTextElement();
    if (!element) return;
    const text = this._isCustomTextElement(element) ? value : value.replace(/\n/g, " ");
    this._applyToSelection((ref) => ref.path === "elements", (el) => ({ ...el, text }));
  };

  _getSelectedBadgeElement = () => {
    if (!this._canSelectedElementHaveCurrency()) return null;
    const { section, path, index } = this.props.selectedElement;
    return this.props.properties[section]?.[path]?.[index] || null;
  };

  _handleBadgeToggle = (checked) => {
    if (!this._canSelectedElementHaveCurrency()) return;

    const withBadge = (el) => ({ ...el, badge: { ...getBadgeSettings(el), enabled: checked } });

    if (this._isMultiSelection()) {
      this._applyToSelection(
        (ref) => ref.path === "elements" || ref.path === "companyProps",
        withBadge
      );
      return;
    }

    const currentElement = this._getSelectedBadgeElement();
    if (!currentElement) return;

    const { section, path, index } = this.props.selectedElement;
    this._updateElementInState(section, path, index, withBadge(currentElement));
  };

  _handleBadgeChange = (badge) => {
    const currentElement = this._getSelectedBadgeElement();
    if (!currentElement) return;

    const { section, path, index } = this.props.selectedElement;
    this._updateElementInState(section, path, index, { ...currentElement, badge });
  };

  _renderBadgeSettingsModal = () => {
    const element = this.state.showBadgeSettings ? this._getSelectedBadgeElement() : null;
    if (!element) return null;

    return (
      <BadgeSettings
        show
        element={element}
        fontColor={this._getSelectedElementFontColor() || this.props.properties.prop.fontColor}
        onChange={this._handleBadgeChange}
        onHide={() => this.setState({ showBadgeSettings: false })}
      />
    );
  };

  _isSelectedElementQRCode = () => {
    const { selectedElement } = this.props;
    return selectedElement?.path === "qrCodes";
  };

  _isSelectedElementGenerateModeQRCode = () => {
    if (!this._isSelectedElementQRCode()) return false;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];

    return (currentElement?.qrMode || "generate") === "generate";
  };

  _handleQRValueUpdate = (value) => {
    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    if (!this._isSelectedElementQRCode()) return;

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const updatedElement = {
      ...currentElement,
      qrValue: value
    };

    this._updateElementInState(section, path, index, updatedElement);
  };

  _getSelectedElementQRValue = () => {
    if (!this._isSelectedElementQRCode()) return null;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;
    const currentElement = this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return null;

    return currentElement.qrValue || "";
  };

  _handleFontColorUpdate = (hex) => {
    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    if (!this._canSelectedElementHaveFontColor()) return;

    if (this._isMultiSelection()) {
      this._applyToSelection(this._canRefHaveText, (el) => ({ ...el, style: { ...el.style, color: hex } }));
      return;
    }

    if (path === "documentTitle" || path === "VatSummary") {
      const currentElement = this.props.properties[section][path];
      if (!currentElement) return;

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          color: hex
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        domElement.style.color = hex;
      }

      this._updateSection(section, { ...this.props.properties[section], [path]: updatedElement });
      return;
    }

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        color: hex
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style.color = hex;
    }

    this._updateElementInState(section, path, index, updatedElement);
  };

  _getSelectedElementFontColor = () => {
    if (!this._canSelectedElementHaveFontColor()) return null;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    const currentElement = (path === "documentTitle" || path === "VatSummary")
      ? this.props.properties[section]?.[path]
      : this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return null;

    const sectionFont = this.props.properties[section]?.font;
    const defaultFontColor = this.props.properties.prop?.fontColor || "#333333";

    return currentElement.style?.color || sectionFont?.color || defaultFontColor;
  };

  _getSelectedElementFontSize = () => {
    if (!this._canSelectedElementHaveFontColor()) return null;

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    const currentElement = (path === "documentTitle" || path === "VatSummary")
      ? this.props.properties[section]?.[path]
      : this.props.properties[section]?.[path]?.[index];
    if (!currentElement) return null;

    const sectionFont = this.props.properties[section]?.font;
    const defaultFontSize = this.props.properties.prop?.fontSize || 10;

    const rawSize = currentElement.style?.fontSize;
    if (rawSize) return parseInt(rawSize, 10) || defaultFontSize;
    if (sectionFont?.fontSize) return parseInt(sectionFont.fontSize, 10) || defaultFontSize;
    return defaultFontSize;
  };

  _handleFontSizeUpdate = (value) => {
    if (!this._canSelectedElementHaveFontColor()) return;

    const size = parseInt(value, 10);
    if (!size || size < 1) return;
    const fontSize = size + "pt";

    if (this._isMultiSelection()) {
      this._applyToSelection(this._canRefHaveText, (el) => ({ ...el, style: { ...el.style, fontSize } }));
      return;
    }

    const { selectedElement } = this.props;
    const { section, path, index } = selectedElement;

    if (path === "documentTitle" || path === "VatSummary") {
      const currentElement = this.props.properties[section][path];
      if (!currentElement) return;

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          fontSize
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        domElement.style.fontSize = fontSize;
      }

      this._updateSection(section, { ...this.props.properties[section], [path]: updatedElement });
      return;
    }

    const currentElement = this.props.properties[section][path][index];
    if (!currentElement) return;

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        fontSize
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style.fontSize = fontSize;
    }

    this._updateElementInState(section, path, index, updatedElement);
  };

  _handleSpecialElementStyleUpdate = (section, path, property, value, isIncrement, isHeading = false, isToggle = false, offValue = null, isList = false) => {
    const currentElement = this.props.properties[section][path];
    if (!currentElement) return;
    console.log("path123: ", path)
    let newValue = value;

    // if (isList && isToggle && path !== "documentTitle" && path !== "VatSummary") {
    //   const currentListStyle = currentElement.style?.listStyleType;
    //   const toggleValue = currentListStyle === value ? offValue : value;

    //   const updatedElement = {
    //     ...currentElement,
    //     style: {
    //       ...currentElement.style,
    //       listStyleType: toggleValue,
    //       display: toggleValue !== "none" ? "list-item" : "block",
    //       marginLeft: toggleValue !== "none" ? "20px" : "0px",
    //     }
    //   };

    //   const domElement = document.getElementById(currentElement.id);
    //   if (domElement) {
    //     domElement.style.listStyleType = toggleValue;
    //     domElement.style.display = toggleValue !== "none" ? "list-item" : "block";
    //     domElement.style.marginLeft = toggleValue !== "none" ? "20px" : "0px";
    //   }

    //   switch (section) {
    //     case 'head':
    //       this.props.updateHead({
    //         ...this.props.properties.head,
    //         [path]: updatedElement
    //       });
    //       break;

    //     case 'total':
    //       this.props.updateTotal({
    //         ...this.props.properties.total,
    //         [path]: updatedElement
    //       });
    //       break;

    //     default:
    //       break;
    //   }
    //   this._updateActiveStyles(updatedElement);
    //   return;
    // }

    if (isHeading && isToggle) {
      const headingStyles = {
        h1: {
          fontWeight: "bold",
          fontSize: "24pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h2: {
          fontWeight: "bold",
          fontSize: "20pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        h3: {
          fontWeight: "bold",
          fontSize: "16pt",
          textDecoration: "none",
          fontStyle: "normal"
        },
        normal: {
          fontWeight: "normal",
          fontSize: path === "documentTitle" ? "20pt" : (this.props.properties.prop.fontSize + "pt"),
          textDecoration: "none",
          fontStyle: "normal"
        }
      };

      const currentIsHeading =
        (currentElement.style?.fontSize === "24pt" && value === "h1") ||
        (currentElement.style?.fontSize === "20pt" && value === "h2") ||
        (currentElement.style?.fontSize === "16pt" && value === "h3");

      const toggleValue = currentIsHeading ? offValue : value;
      const headingStyle = headingStyles[toggleValue];

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          ...headingStyle
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        Object.keys(headingStyle).forEach(prop => {
          domElement.style[prop] = headingStyle[prop];
        });
      }

      this._updateSection(section, { ...this.props.properties[section], [path]: updatedElement });
      this._updateActiveStyles(updatedElement);
      return;
    }

    if (isToggle) {
      const currentValue = currentElement.style?.[property];
      let toggleValue;

      if (property === "textDecoration") {
        const hasValue = currentValue === value ||
          (currentValue && currentValue.includes(value));
        toggleValue = hasValue ? offValue : value;
      } else {
        toggleValue = currentValue === value ? offValue : value;
      }

      const updatedElement = {
        ...currentElement,
        style: {
          ...currentElement.style,
          [property]: toggleValue
        }
      };

      const domElement = document.getElementById(currentElement.id);
      if (domElement) {
        domElement.style[property] = toggleValue;
      }

      this._updateSection(section, { ...this.props.properties[section], [path]: updatedElement });

      this._updateActiveStyles(updatedElement);
      return;
    }

    if (isIncrement && property === "fontSize") {
      let currentSize = 10;

      if (currentElement.style?.fontSize) {
        const sizeStr = currentElement.style.fontSize;
        currentSize = parseInt(sizeStr) || 10;
      }
      else if (path === "documentTitle") {
        currentSize = 20;
      }

      newValue = (currentSize + value) + "pt";
    } else if (property === "fontSize" && !isIncrement) {
      newValue = value.toString().endsWith("pt") ? value : value + "pt";
    }

    const updatedElement = {
      ...currentElement,
      style: {
        ...currentElement.style,
        [property]: isIncrement ? newValue : value
      }
    };

    const domElement = document.getElementById(currentElement.id);
    if (domElement) {
      domElement.style[property] = isIncrement ? newValue : value;
    }

    this._updateSection(section, { ...this.props.properties[section], [path]: updatedElement });

    if (property === "textAlign") {
      this._updateActiveStyles(updatedElement);
    }
  };

  _parseFontSize = (fontSizeStr) => {
    if (!fontSizeStr) return 10;

    const cleanStr = fontSizeStr.toString().replace('pt', '').replace('px', '').replace('em', '').trim();
    const size = parseFloat(cleanStr);

    return isNaN(size) ? 10 : size;
  };

  // ---- Newly added elements ---------------------------------------------------
  //
  // The panels place new elements with their own rules, which can leave them
  // under or behind what's already there. After each update the editor looks
  // for a single element that just appeared in a section, moves it to a free
  // spot in view, then selects and highlights it. Loading a template, pasting
  // and duplicating set _suppressReveal: they place and select on purpose.

  // Every element in the canvas sections: "section|path|key" → DOM id.
  _collectSectionItems = () => {
    const items = new Map();
    this._getCanvasSections().forEach((section) => {
      const content = this.props.properties[section];
      if (!content) return;
      ["elements", "shapes", "qrCodes", "images", "companyProps"].forEach((path) => {
        Object.entries(content[path] || {}).forEach(([key, item]) => {
          if (!item || !item.id || key === "border") return;
          if (path === "companyProps" && !item.show) return;
          items.set(`${section}|${path}|${key}`, item.id);
        });
      });
    });
    return items;
  };

  componentDidUpdate() {
    this._fillMissingLayers();
    const items = this._collectSectionItems();
    const previous = this._sectionItems;
    this._sectionItems = items;
    if (!previous || this._suppressReveal) {
      this._suppressReveal = false;
      return;
    }
    // New means a new id too: an element only re-keyed (the repair on open)
    // keeps its id and must not move.
    const previousIds = new Set(previous.values());
    const added = [...items.keys()].filter((key) => !previous.has(key) && !previousIds.has(items.get(key)));
    if (added.length !== 1) return;
    const section = added[0].split("|")[0];
    const id = items.get(added[0]);
    window.requestAnimationFrame(() => this._revealNewElement(section, id));
  }

  // Moves a new element to the first free spot in its section (top-left
  // first, never overlapping another element); if there's none it stays put
  // but comes to the front. Then selects it, scrolls it into view and
  // briefly highlights it.
  _revealNewElement = (section, id) => {
    const el = document.getElementById(id);
    const sectionEl = this._getCanvasSectionEl(section);
    const container = el && el.offsetParent;
    if (!el || !sectionEl || !container) return;
    const ref = this._getElementRefFromDom(el);
    if (!ref) return;

    // Positions are relative to the element's container; the free area is
    // the section's visible box in those coordinates.
    const box = container.getBoundingClientRect();
    const area = sectionEl.getBoundingClientRect();
    const GAP = 8;
    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const x0 = Math.max(0, area.left - box.left) + GAP;
    const y0 = Math.max(0, area.top - box.top) + GAP;
    const x1 = area.right - box.left - GAP;
    const y1 = area.bottom - box.top - GAP;

    let maxZ = 0;
    const obstacles = [];
    document.querySelectorAll(`[data-section="${section}"][id]`).forEach((other) => {
      if (other === el || !other.offsetWidth) return;
      const r = other.getBoundingClientRect();
      obstacles.push({ left: r.left - box.left, top: r.top - box.top, right: r.right - box.left, bottom: r.bottom - box.top });
      maxZ = Math.max(maxZ, parseInt(window.getComputedStyle(other).zIndex, 10) || 0);
    });

    const isFree = (x, y) => !obstacles.some((o) =>
      x < o.right + GAP / 2 && x + width > o.left - GAP / 2 && y < o.bottom + GAP / 2 && y + height > o.top - GAP / 2);

    let spot = null;
    for (let y = y0; !spot && y + height <= Math.max(y0 + height, y1); y += GAP) {
      for (let x = x0; x + width <= Math.max(x0 + width, x1); x += GAP) {
        if (isFree(x, y)) {
          spot = { left: Math.round(x), top: Math.round(y) };
          break;
        }
      }
    }

    this._applyElementUpdates([{
      ref,
      updater: (data) => ({
        ...data,
        style: {
          ...data.style,
          ...(spot ? { top: spot.top + "px", left: spot.left + "px" } : { zIndex: Math.min(98, maxZ + 1) }),
        },
      }),
    }]);

    window.requestAnimationFrame(() => {
      const placed = document.getElementById(id);
      if (!placed) return;
      this._selectPrimaryFromDom(placed, [id]);
      placed.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      // Set directly on the DOM so re-renders (which reset className) keep it.
      placed.setAttribute("data-just-added", "");
      setTimeout(() => placed.removeAttribute("data-just-added"), 1600);
    });
  };

  _isBandsMode = () => getLayoutMode(this.props.properties) === LAYOUT_MODES.BANDS;

  _getBands = () => getTemplateBands(this.props.properties);

  // Replaces a section's content by its key: one of the four sections, or an
  // added band's own key in bands mode.
  _updateSection = (section, content) => {
    if (!section || !content) return;
    if (section === "head") this.props.updateHead(content);
    else if (section === "items") this.props.updateItems(content);
    else if (section === "total") this.props.updateTotal(content);
    else if (section === "foot") this.props.updateFoot(content);
    else this.props.updateSection(section, content);
  };

  _updateElementInState = (section, path, index, updatedElement) => {
    const current = this.props.properties[section];
    if (!current) return;
    const key = path === "elements" ? updatedElement.name.replace(/\./g, '') : index;
    this._updateSection(section, {
      ...current,
      [path]: { ...current[path], [key]: updatedElement },
    });
  };

  _closeWindow = function (e) {
    if (this.state.isEdited) this.setState({ showAlert: true });
    else this.props.callbackFromParents(e);
  };

  _confirmClose = function (e) {
    this.props.callbackFromParents(e);
  };

  _onElementClick = (e) => {
    if (e.target.tagName === 'TEXTAREA' || e.target.closest('textarea')) {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
    //  console.log(e)
    var name = e.target.getAttribute("id");
    if (name === null) {
      e.preventDefault();
      return false;
    }
    if (this._deselectOnModifierClick(e, name)) return false;
    let section = e.target.getAttribute("data-section");
    let path = e.target.getAttribute("data-path");
    let index = e.target.getAttribute("data-index");
    let isCompanyProp = e.target.getAttribute("data-is-company-prop") === "true";

    if (name === null) return false;

    let element;

    if (isCompanyProp) {
      element = this.props.properties[section][path][index];
    } else if (path === "documentTitle") {
      element = this.props.properties[section][path];
    } else if (path === "VatSummary") {
      element = this.props.properties[section][path];
    } else if (path === "elements") {
      const elementKey = e.target.getAttribute("data-element")?.replace(/\./g, "") || index;
      element = this.props.properties[section].elements[elementKey];
    } else if (path === "shapes") {
      element = this.props.properties[section].shapes[index];
    } else {
      element = this.props.properties[section][path][index];
    }
    this.props.setSelectedElement(
      section,
      path,
      index,
      element,
    );

    this.setState({
      selectedElementName: name,
      selectedElementIds: this._nextSelectionIds(e, name),
    });

    this._updateActiveStyles(element);
  };

  _onShapeClick = (e) => {

    //  console.log(e)
    var name = e.target.getAttribute("id");
    if (name === null) {
      e.preventDefault();
      return false;
    }
    if (this._deselectOnModifierClick(e, name)) return false;
    let section = e.target.getAttribute("data-section");
    let path = e.target.getAttribute("data-path");
    let index = e.target.getAttribute("data-index");

    if (name === null) return false;

    const element = this.props.properties[section].shapes[index];
    this.props.setSelectedElement(
      section,
      path,
      index,
      element
    );

    this.setState({
      selectedElementName: name,
      selectedElementIds: this._nextSelectionIds(e, name),
    });

    this._updateActiveStyles(element);
  };

  _onVatSummaryClick = (e) => {
    var name = e.target.getAttribute("id");
    if (name === null) {
      e.preventDefault();
      return false;
    }
    if (this._deselectOnModifierClick(e, name)) return false;
    let section = 'total'//e.target.getAttribute("data-section");
    let path = "VatSummary"//e.target.getAttribute("data-path");
    let index = e.target.getAttribute("data-index");

    if (name === null) return false;

    const element = this.props.properties[section].VatSummary;
    this.props.setSelectedElement(
      section,
      path,
      index,
      element
    );

    this.setState({
      selectedElementName: name,
      selectedElementIds: this._nextSelectionIds(e, name),
    });

    this._updateActiveStyles(element);
  }

  //#region Element Groups
  // A selection can hold several elements: clicking a grouped element selects
  // every member of its group, Ctrl/Shift+click adds/removes elements and
  // Alt+click picks a single element out of its group. `selectedElementName`
  // stays the "primary" element (the one the toolbar reads from and whose
  // handles drive move/resize); `selectedElementIds` is the whole selection.
  // Group membership is persisted as a `groupId` on each element object.

  _isGroupSelected = (id) => (
    !!id && this.state.selectedElementName !== id && (this.state.selectedElementIds || []).includes(id)
  );

  _getSelectedIds = () => {
    const ids = (this.state.selectedElementIds || []).filter((id) => document.getElementById(id));
    const primary = this.state.selectedElementName;
    if (primary && !ids.includes(primary) && document.getElementById(primary)) ids.unshift(primary);
    return ids;
  };

  _isMultiSelection = () => this._getSelectedIds().length > 1;

  // Resolves a canvas DOM node to where its data lives in the template:
  // `properties[section][path]` for single-object paths (no key) or
  // `properties[section][path][key]` for keyed collections.
  _getElementRefFromDom = (el) => {
    if (!el || !el.id) return null;
    const section = el.getAttribute("data-section");
    const path = el.getAttribute("data-path");
    const index = el.getAttribute("data-index");

    if (el.id === "doc-title") return { id: el.id, section: "head", path: "documentTitle" };
    if (index === "VatSummary") return { id: el.id, section: "total", path: "VatSummary" };
    if (path === "logo") return { id: el.id, section: "head", path: "logo" };
    if (!section || !path) return null;
    if (path === "elements") {
      return { id: el.id, section, path, key: el.getAttribute("data-element")?.replace(/\./g, "") || index };
    }
    return { id: el.id, section, path, key: index };
  };

  _getElementDataByRef = (ref) => {
    const sectionData = ref && this.props.properties?.[ref.section];
    if (!sectionData) return null;
    return (ref.key === undefined ? sectionData[ref.path] : sectionData[ref.path]?.[ref.key]) || null;
  };

  _getSelectionRefs = () => (
    this._getSelectedIds()
      .map((id) => this._getElementRefFromDom(document.getElementById(id)))
      .filter((ref) => ref && this._getElementDataByRef(ref))
  );

  _canRefHaveText = (ref) => ref.path !== "shapes" && ref.path !== "logo" && ref.path !== "qrCodes" && ref.path !== "images";

  // Applies several element updates at once, dispatching a single update per
  // section so successive updates don't overwrite each other through stale
  // props.
  _applyElementUpdates = (updates) => {
    const nextSections = {};

    updates.forEach(({ ref, updater }) => {
      const base = nextSections[ref.section] || this.props.properties[ref.section];
      if (!base) return;
      const current = ref.key === undefined ? base[ref.path] : base[ref.path]?.[ref.key];
      if (!current) return;
      const updated = updater(current, ref);
      if (!updated || updated === current) return;

      nextSections[ref.section] = ref.key === undefined
        ? { ...base, [ref.path]: updated }
        : { ...base, [ref.path]: { ...base[ref.path], [ref.key]: updated } };
    });

    Object.keys(nextSections).forEach((section) => this._updateSection(section, nextSections[section]));
  };

  // Sets `field` on every selected element it applies to; undefined removes
  // it. Format, "hide when empty" and "keep in row" are for text elements,
  // stretching for boxes.
  _setSelectedElementField = (field, value) => {
    const isText = (ref) => ref.path === "elements" || ref.path === "companyProps";
    const applies = field === "stretchWithContent" || field === "matchRow"
      ? (ref) => ref.path === "shapes" && String(ref.key || "").startsWith("box")
      : field === "keepInRow"
        ? this._canRefKeepInRow
        : isText;
    this._applyToSelection(applies, (el) => {
      const next = { ...el };
      if (value === undefined) delete next[field];
      else next[field] = value;
      return next;
    });
  };

  // Line spacing of multi-line text, as a multiple of the font size
  // (style.lineHeight); empty uses the default.
  _getSelectedLineHeight = () => {
    const value = this._getPrimaryElementData()?.style?.lineHeight;
    return value === undefined || value === null ? "" : value;
  };

  _handleLineHeightUpdate = (value) => {
    const n = parseFloat(value);
    // Part-typed values ("0" on the way to "0.8") wait; empty means default.
    if (String(value).trim() !== "" && !(n >= LINE_HEIGHT_MIN && n <= LINE_HEIGHT_MAX)) return;
    const lineHeight = n >= LINE_HEIGHT_MIN && n <= LINE_HEIGHT_MAX ? Math.round(n * 100) / 100 : null;
    this._applyToSelection((ref) => this._canRefHaveText(ref), (el) => {
      const style = { ...(el.style || {}) };
      if (lineHeight) style.lineHeight = lineHeight;
      else delete style.lineHeight;
      return { ...el, style };
    });
    this.setState({ isEdited: true });
  };

  _getSelectedFormatPreset = () => {
    const format = this._getSelectedBadgeElement()?.format;
    if (!format) return "none";
    const match = Object.entries(TEXT_FORMAT_PRESETS).find(([, preset]) => JSON.stringify(preset.format) === JSON.stringify(format));
    // A format no preset matches, e.g. one a total copied from its column.
    return match ? match[0] : "custom";
  };

  _applyToSelection = (filter, updater) => {
    const refs = this._getSelectionRefs().filter(filter);
    this._applyElementUpdates(refs.map((ref) => ({ ref, updater })));
  };

  _getGroupMemberIds = (groupId, section) => {
    if (!groupId) return [];
    return Array.from(document.querySelectorAll(`.custom-element[data-section="${section}"]`))
      .filter((el) => el.getAttribute("data-group-id") === groupId)
      .map((el) => el.id);
  };

  // The ids a click on `name` selects: its whole group (unless Alt is held),
  // added to the current selection when Ctrl/Shift is held. Selections never
  // span sections since positions are section-relative.
  _nextSelectionIds = (e, name) => {
    if (e && e.__selectionIds) return e.__selectionIds;

    const el = document.getElementById(name);
    if (!el) return [name];

    const section = el.getAttribute("data-section");
    const groupId = el.getAttribute("data-group-id");
    const clickedIds = groupId && !e?.altKey ? this._getGroupMemberIds(groupId, section) : [name];
    if (!clickedIds.includes(name)) clickedIds.push(name);

    if (e && (e.ctrlKey || e.metaKey || e.shiftKey)) {
      const current = this._getSelectedIds();
      const sameSection = current.every((id) => document.getElementById(id)?.getAttribute("data-section") === section);
      if (sameSection) return Array.from(new Set([...current, ...clickedIds]));
    }

    return clickedIds;
  };

  // Ctrl/Shift+click on an already-selected element removes just that element
  // from the selection — also inside a group, so a grouped selection can be
  // trimmed one element at a time. Removing the last one clears the
  // selection. Returns true when the click was consumed.
  _deselectOnModifierClick = (e, name) => {
    if (!e || e.__selectionIds || !(e.ctrlKey || e.metaKey || e.shiftKey)) return false;

    const current = this._getSelectedIds();
    if (!current.includes(name)) return false;

    const remaining = current.filter((id) => id !== name);
    if (remaining.length === 0) {
      this._clearSelection();
      return true;
    }

    if (remaining.includes(this.state.selectedElementName)) {
      this.setState({ selectedElementIds: remaining });
    } else {
      this._selectPrimaryFromDom(document.getElementById(remaining[0]), remaining);
    }
    return true;
  };

  _clearSelection = () => {
    this.props.setSelectedElement("", "", "", null);
    this.setState({ selectedElementName: "", selectedElementIds: [], activeStyles: {} });
  };

  // Makes `el` the primary element through the same click handler a real
  // click would use, while keeping `selectionIds` as the selection.
  _selectPrimaryFromDom = (el, selectionIds) => {
    if (!el) return;
    const syntheticEvent = {
      target: el,
      preventDefault: () => { },
      stopPropagation: () => { },
      __selectionIds: selectionIds,
    };

    if (el.getAttribute("data-path") === "shapes") {
      this._onShapeClick(syntheticEvent);
    } else if (el.getAttribute("data-index") === "VatSummary") {
      this._onVatSummaryClick(syntheticEvent);
    } else {
      this._onElementClick(syntheticEvent);
    }
  };

  _canGroupSelection = () => {
    const refs = this._getSelectionRefs();
    if (refs.length < 2) return false;
    const groupIds = refs.map((ref) => this._getElementDataByRef(ref)?.groupId || null);
    return !(groupIds[0] && groupIds.every((g) => g === groupIds[0]));
  };

  _canUngroupSelection = () => (
    this._getSelectionRefs().some((ref) => !!this._getElementDataByRef(ref)?.groupId)
  );

  _groupSelection = () => {
    if (!this._canGroupSelection()) return;
    const groupId = "grp-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
    // A new group starts with the default rule (hide when any counting
    // condition fails); the elements may come from groups with other rules.
    this._applyToSelection(() => true, (el) => {
      const { groupHideRule, ...rest } = el;
      return { ...rest, groupId };
    });
  };

  // Ungrouped elements have no group to hide, so their conditions stop
  // counting for one.
  _ungroupSelection = () => {
    if (!this._canUngroupSelection()) return;
    this._applyToSelection(() => true, (el) => {
      if (!el.groupId) return el;
      const { groupId, groupHideRule, ...rest } = el;
      if (rest.showWhen?.hideGroup) {
        const { hideGroup, ...showWhen } = rest.showWhen;
        rest.showWhen = showWhen;
      }
      return rest;
    });
  };

  // ---- Rotating lines ----

  _getSelectedLineAngle = () => getLineRotation(this._getPrimaryElementData());

  // On every selected line; 0 removes the setting.
  _setSelectedLineAngle = (value) => {
    const angle = getLineRotation({ rotation: value });
    this._applyToSelection(
      (ref) => ref.path === "shapes" && String(ref.key || "").startsWith("line"),
      (el) => {
        const next = { ...el };
        if (angle) next.rotation = angle;
        else delete next.rotation;
        return next;
      }
    );
    this.setState({ isEdited: true });
  };

  // ---- Stacking order (docs/bands-spec.md §8.7) ----

  // A section's items bottom first, read from the canvas, with their refs.
  _getSectionStack = (section) => {
    const seen = new Set();
    const entries = Array.from(document.querySelectorAll(`.custom-element[data-section="${section}"]`))
      .map((node) => this._getElementRefFromDom(node))
      .filter((ref) => ref && !seen.has(ref.id) && seen.add(ref.id) && this._getElementDataByRef(ref));
    const items = entries.map((ref) => {
      const data = this._getElementDataByRef(ref);
      return { id: ref.id, path: ref.path, layer: data.layer, zIndex: data.style?.zIndex };
    });
    return { order: getStackOrder(items), refs: new Map(entries.map((ref) => [ref.id, ref])) };
  };

  _overlapOnCanvas = (a, b) => {
    const ra = document.getElementById(a)?.getBoundingClientRect();
    const rb = document.getElementById(b)?.getBoundingClientRect();
    return !!ra && !!rb && ra.left < rb.right && rb.left < ra.right && ra.top < rb.bottom && rb.top < ra.bottom;
  };

  // The section's order after `action` on the selection, or null when it
  // would change nothing.
  _getArrangedOrder = (action) => {
    const refs = this._getSelectionRefs();
    if (!refs.length) return null;
    const stack = this._getSectionStack(refs[0].section);
    const next = arrangeOrder(stack.order, refs.map((ref) => ref.id), action, this._overlapOnCanvas);
    return next ? { next, stack } : null;
  };

  // Gives every item in the section its place as `layer` (1 = bottom), also
  // written as its zIndex so the canvas and the saved HTML stack the same.
  _arrangeSelection = (action) => {
    const result = this._getArrangedOrder(action);
    if (!result) return;
    this._applyElementUpdates(result.next.map((id, i) => ({
      ref: result.stack.refs.get(id),
      updater: (el) => (el.layer === i + 1 && el.style?.zIndex === i + 1
        ? el
        : { ...el, layer: i + 1, style: { ...(el.style || {}), zIndex: i + 1 } }),
    })));
    this.setState({ isEdited: true });
  };

  // Items added to an arranged section (new, pasted, or copied in without a
  // layer) go on top of it.
  _fillMissingLayers = () => {
    if (this._fillingLayers || !this.props.properties) return;
    const sections = Array.from(new Set(["head", "total", "foot", ...this._getBands().map((b) => b.section)]))
      .filter((section) => section !== "items" && this.props.properties[section]);
    const updates = [];
    sections.forEach((section) => {
      const placed = this._placedRefs(section);
      if (!placed.some((p) => Number.isFinite(p.data.layer))) return;
      let top = Math.max(...placed.map((p) => (Number.isFinite(p.data.layer) ? p.data.layer : 0)));
      placed.filter((p) => !Number.isFinite(p.data.layer)).forEach((p) => {
        top += 1;
        const layer = top;
        updates.push({ ref: p, updater: (el) => ({ ...el, layer, style: { ...(el.style || {}), zIndex: layer } }) });
      });
    });
    if (!updates.length) return;
    this._fillingLayers = true;
    this._applyElementUpdates(updates);
    setTimeout(() => { this._fillingLayers = false; }, 0);
  };

  _onArrangeShortcutKeyDown = (e) => {
    if (!(e.ctrlKey || e.metaKey) || (e.code !== "BracketRight" && e.code !== "BracketLeft")) return;
    const target = e.target;
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)) return;
    if (!this.state.selectedElementName) return;
    e.preventDefault();
    const up = e.code === "BracketRight";
    this._arrangeSelection(e.shiftKey ? (up ? ARRANGE.FRONT : ARRANGE.BACK) : (up ? ARRANGE.FORWARD : ARRANGE.BACKWARD));
  };

  // ---- Visibility: showing a field only when its value passes a check ----
  // (docs/bands-spec.md §5.5)

  _getPrimaryRef = () => this._getElementRefFromDom(document.getElementById(this.state.selectedElementName));

  // Fields bound to a data value; custom text and the current date and time
  // always have their text, so they get no condition.
  _isFieldRef = (ref) => {
    if (!ref || (ref.path !== "elements" && ref.path !== "companyProps")) return false;
    const data = this._getElementDataByRef(ref);
    return !!data && !this._isCustomTextElement(data) && data.data !== CURRENT_DATE_TIME_FIELD;
  };

  // The selection when it is exactly one whole group: { groupId, refs }.
  _getSelectedGroup = () => {
    const refs = this._getSelectionRefs();
    if (refs.length < 2) return null;
    const groupId = this._getElementDataByRef(refs[0])?.groupId;
    if (!groupId || !refs.every((ref) => this._getElementDataByRef(ref)?.groupId === groupId)) return null;
    const members = this._getGroupMemberIds(groupId, refs[0].section);
    const ids = refs.map((ref) => ref.id);
    return members.length === ids.length && members.every((id) => ids.includes(id)) ? { groupId, refs } : null;
  };

  _updateRefs = (refs, updater) => this._applyElementUpdates(refs.map((ref) => ({ ref, updater })));

  _sectionGrows = (section) => !!this._getBands().find((b) => b.section === section)?.canGrow;

  // Everything placed in a section, as refs with their data.
  _placedRefs = (section) => {
    const content = this.props.properties[section] || {};
    const keyed = ["elements", "companyProps", "shapes", "images", "qrCodes"].flatMap((path) =>
      Object.keys(content[path] || {})
        .filter((key) => !(path === "shapes" && key === "border"))
        .map((key) => ({ section, path, key, data: content[path][key] })));
    const single = ["logo", "documentTitle", "VatSummary"]
      .filter((path) => content[path] && typeof content[path] === "object")
      .map((path) => ({ section, path, data: content[path] }));
    return [...keyed, ...single].filter((ref) => ref.data && typeof ref.data === "object");
  };

  // What has to change so the rows below close up when this field (and its
  // group, when the condition hides it) is hidden (docs/bands-spec.md §5.5):
  // the section must grow, and every box around the hidden elements that
  // isn't hidden with them must stretch with its content.
  _getCloseUpFixes = (ref) => {
    const field = this._getElementDataByRef(ref);
    const placed = this._placedRefs(ref.section);
    const hidden = field?.groupId && field.showWhen?.hideGroup
      ? placed.filter((p) => p.data.groupId === field.groupId)
      : placed.filter((p) => p.data === field);
    const px = (value) => parseFloat(value) || 0;
    const corner = (data) => ({ top: px(data.style?.top), left: px(data.style?.left) });
    const boxes = placed.filter((p) => p.path === "shapes" && String(p.key).startsWith("box") &&
      !p.data.stretchWithContent && !hidden.some((h) => h.data === p.data) &&
      hidden.some((h) => {
        const c = corner(h.data);
        const top = px(p.data.style?.top);
        const left = px(p.data.style?.left);
        return c.top >= top && c.top < top + px(p.data.style?.height) && c.left >= left && c.left < left + px(p.data.style?.width);
      }));
    return { grow: !this._sectionGrows(ref.section), boxes };
  };

  // Lets the section grow and the boxes around the hidden rows stretch.
  _applyCloseUpFixes = (ref) => {
    const { grow, boxes } = this._getCloseUpFixes(ref);
    this._ensureBands(() => {
      if (boxes.length) this._updateRefs(boxes, (el) => ({ ...el, stretchWithContent: true }));
      if (grow) {
        const band = this._getBands().find((b) => b.section === ref.section);
        if (band) this._updateBand(band.id, { canGrow: true });
      }
      this.setState({ isEdited: true });
    });
  };

  // Sets the selected field's condition; undefined means always show. The
  // first condition on a field also lets its section grow and the boxes
  // around it stretch, so the rows below close up when it's hidden; after
  // that those settings are left alone (the Visibility panel offers them).
  _setPrimaryCondition = (showWhen) => {
    const ref = this._getPrimaryRef();
    if (!this._isFieldRef(ref)) return;
    const isNew = !!showWhen && !hasCondition(this._getElementDataByRef(ref));
    const apply = () => {
      this._updateRefs([ref], (el) => {
        const next = { ...el };
        if (showWhen) next.showWhen = showWhen;
        else delete next.showWhen;
        return next;
      });
      // After the store has the condition, so its group counts.
      if (isNew) setTimeout(() => this._applyCloseUpFixes(ref), 0);
    };
    if (showWhen) this._ensureBands(apply);
    else {
      apply();
      this._maybeRevertToSections();
    }
    this.setState({ isEdited: true });
  };

  // Saved on every member, so the PDF can read it from any of them.
  _setGroupHideRule = (rule) => {
    const group = this._getSelectedGroup();
    if (!group) return;
    this._updateRefs(group.refs, (el) => {
      const next = { ...el };
      if (rule === GROUP_HIDE_RULES.ALL) next.groupHideRule = GROUP_HIDE_RULES.ALL;
      else delete next.groupHideRule;
      return next;
    });
    this.setState({ isEdited: true });
  };

  _setGroupCount = (id, on) => {
    const ref = this._getSelectedGroup()?.refs.find((r) => r.id === id);
    if (!ref) return;
    this._updateRefs([ref], (el) => {
      if (!el.showWhen) return el;
      const showWhen = { ...el.showWhen };
      if (on) showWhen.hideGroup = true;
      else delete showWhen.hideGroup;
      return { ...el, showWhen };
    });
    this.setState({ isEdited: true });
  };

  // Field names read better split into words: "VATTotal" is "VAT Total".
  _fieldWords = (name) => String(name || "")
    .replace(/_/g, " ")
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim();

  // What a selected element is, for the selection list: { type, label }.
  _describeRef = (ref) => {
    const data = this._getElementDataByRef(ref) || {};
    const key = ref.key || "";
    const firstLine = (text) => {
      const line = String(text || "").split("\n")[0].trim();
      return line.length > 32 ? line.slice(0, 31) + "…" : line;
    };
    switch (ref.path) {
      case "elements":
        if (this._isCustomTextElement(data)) return { type: "Text", label: firstLine(data.text) };
        return { type: "Field", label: this._fieldWords(data.data || String(data.name || "").split(".").pop()) };
      case "companyProps":
        return { type: "Company field", label: this._fieldWords(data.data || data.name) };
      // Renamed: "Rectangle · Grey values"; otherwise just "Rectangle 3".
      case "shapes":
      case "qrCodes":
        return data.label
          ? { type: defaultItemName(ref.path, key).replace(/ \d+$/, ""), label: itemDisplayName(ref.path, key, data) }
          : { type: defaultItemName(ref.path, key), label: "" };
      case "images":
        return { type: "Image", label: "" };
      case "logo":
        return { type: "Logo", label: "" };
      case "documentTitle":
        return { type: "Document title", label: firstLine(data.title) };
      case "VatSummary":
        return { type: "VAT summary", label: "" };
      default:
        return { type: "Element", label: "" };
    }
  };

  // A shape's or QR code's own name (`label`, editor only); undefined goes
  // back to the default name.
  _renameRef = (ref, label) => {
    this._updateRefs([ref], (el) => {
      const next = { ...el };
      if (label) next.label = label;
      else delete next.label;
      return next;
    });
    this.setState({ isEdited: true });
  };

  // Highlights an element on the canvas while its row in the list is hovered.
  _hoverCanvasElement = (id, on) => {
    document.getElementById(id)?.classList.toggle("list-hover-element", on);
  };

  // Rows in the left panel's lists (text, shapes, QR codes, images) carry
  // the canvas element's id in data-target: hovering a row outlines it.
  // Moving between the parts of one row doesn't count as leaving it.
  _onLeftPanelHover = (e, on) => {
    const row = e.target.closest && e.target.closest("[data-target]");
    if (!row || (e.relatedTarget && row.contains(e.relatedTarget))) return;
    const id = row.getAttribute("data-target");
    if (id) this._hoverCanvasElement(id, on);
  };

  // Selects one element of the selection on its own (like Alt+click).
  _selectOnly = (id) => {
    this._hoverCanvasElement(id, false);
    this._selectPrimaryFromDom(document.getElementById(id), [id]);
  };

  _renderSelectionList = (refs) => {
    const group = this._getSelectedGroup();
    return (
      <>
        {group ? "Group" : "Selection"}
        <span className="text-muted fw-normal"> · {refs.length} elements</span>
        <ul className="selection-member-list">
          {refs.map((ref) => {
            const { type, label } = this._describeRef(ref);
            const data = this._getElementDataByRef(ref);
            const isPrimary = ref.id === this.state.selectedElementName;
            return (
              <li
                key={ref.id}
                className={isPrimary ? "primary" : undefined}
                title={(isPrimary ? "The toolbar shows this element's settings. " : "") + "Click to select only this element"}
                onMouseEnter={() => this._hoverCanvasElement(ref.id, true)}
                onMouseLeave={() => this._hoverCanvasElement(ref.id, false)}
                onClick={() => this._selectOnly(ref.id)}
              >
                <span className="selection-member-type">{type}</span>
                {label && <span className="selection-member-label">{label}</span>}
                {hasCondition(data) && (
                  <span className="selection-member-condition" title={`Shown only when the value ${describeCondition(data.showWhen)}`}>
                    <FontAwesomeIcon icon="eye-slash" />
                    {data.showWhen.hideGroup && group ? " hides group" : ""}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </>
    );
  };

  _renderVisibilitySection = () => {
    if (!(BANDS_ENABLED || this._isBandsMode())) return null;
    const primary = this._getPrimaryRef();
    const field = this._isFieldRef(primary) ? this._getElementDataByRef(primary) : null;
    const group = this._getSelectedGroup();
    if (!field && !group) return null;

    const groupFields = group
      ? group.refs
        .filter((ref) => this._isFieldRef(ref) && hasCondition(this._getElementDataByRef(ref)))
        .map((ref) => ({ id: ref.id, label: this._describeRef(ref).label, showWhen: this._getElementDataByRef(ref).showWhen }))
      : [];
    const rule = group && group.refs.some((ref) => this._getElementDataByRef(ref)?.groupHideRule === GROUP_HIDE_RULES.ALL)
      ? GROUP_HIDE_RULES.ALL
      : GROUP_HIDE_RULES.ANY;
    // Hidden rows only close up in a section that grows, past boxes that
    // stretch: what's still missing for this field and the group's fields.
    const conditionalRefs = [
      ...(hasCondition(field) ? [primary] : []),
      ...(group ? group.refs.filter((ref) => groupFields.some((f) => f.id === ref.id) && ref.id !== primary?.id) : []),
    ];
    const fixes = conditionalRefs.map(this._getCloseUpFixes);
    const fixGrow = fixes.some((f) => f.grow);
    const fixBoxes = fixes.flatMap((f) => f.boxes).filter((b, i, all) => all.findIndex((o) => o.key === b.key) === i);

    return (
      <div className="properties-panel-section">
        <div className="properties-panel-section-title">Visibility</div>
        <div className="toolbar-fields">
          {field && (
            <>
              {group && <div className="toolbar-field-label fw-bold">{this._describeRef(primary).label}</div>}
              <FieldVisibility
                showWhen={field.showWhen}
                inGroup={!!field.groupId}
                onChange={this._setPrimaryCondition}
              />
            </>
          )}
          {group && (
            <>
              {field && <hr className="my-2" />}
              <div className="toolbar-field-label fw-bold">This group</div>
              <GroupVisibility
                fields={groupFields}
                rule={rule}
                onRuleChange={this._setGroupHideRule}
                onCountChange={this._setGroupCount}
              />
            </>
          )}
          {(fixGrow || fixBoxes.length > 0) && (
            <div className="visibility-grow-notice">
              <div>When this is hidden, what&rsquo;s below can&rsquo;t move up into its place yet:</div>
              <ul>
                {fixGrow && <li>the section doesn&rsquo;t grow with its content</li>}
                {fixBoxes.map((box) => (
                  <li
                    key={box.key}
                    onMouseEnter={() => this._hoverCanvasElement(box.data.id, true)}
                    onMouseLeave={() => this._hoverCanvasElement(box.data.id, false)}
                  >
                    the rectangle <strong>{itemDisplayName("shapes", box.key, box.data)}</strong> around it doesn&rsquo;t stretch with its content
                  </li>
                ))}
              </ul>
              <button
                type="button"
                className="btn btn-sm btn-outline-primary"
                onClick={() => {
                  fixBoxes.forEach((box) => this._hoverCanvasElement(box.data.id, false));
                  conditionalRefs.forEach(this._applyCloseUpFixes);
                }}
              >
                Move what&rsquo;s below up into its place
              </button>
            </div>
          )}
        </div>
      </div>
    );
  };

  _onGroupShortcutKeyDown = (e) => {
    if (!(e.ctrlKey || e.metaKey) || (e.key !== "g" && e.key !== "G")) return;
    const target = e.target;
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable)) return;
    if (!this.state.selectedElementName) return;

    e.preventDefault();
    if (e.shiftKey) this._ungroupSelection();
    else this._groupSelection();
  };

  //#region Delete elements
  // Deleting from the canvas does what the side panels do: keyed items
  // (text, data fields, shapes, QR codes, images) are removed; company fields
  // and the document title are hidden; the logo is hidden (image kept); the
  // VAT summary is cleared. The last deletion can be undone.

  _buildDeletion = (ref, original) => {
    switch (ref.path) {
      case "companyProps":
      case "documentTitle":
        return { ...original, show: false };
      case "logo":
        return { ...original, showLogo: false };
      case "VatSummary":
        return {};
      default:
        return undefined; // removed from its collection
    }
  };

  _writeSectionItems = (changes) => {
    // changes: [{ ref, value }] — value undefined removes a keyed item.
    const nextSections = {};
    changes.forEach(({ ref, value }) => {
      const base = nextSections[ref.section] || this.props.properties[ref.section];
      if (!base) return;
      if (ref.key === undefined) {
        nextSections[ref.section] = { ...base, [ref.path]: value };
      } else {
        const collection = { ...(base[ref.path] || {}) };
        if (value === undefined) delete collection[ref.key];
        else collection[ref.key] = value;
        nextSections[ref.section] = { ...base, [ref.path]: collection };
      }
    });
    Object.keys(nextSections).forEach((section) => this._updateSection(section, nextSections[section]));
  };

  _deleteSelection = () => {
    const refs = this._getSelectionRefs();
    if (refs.length === 0) return;

    const deleted = refs.map((ref) => ({
      ref,
      original: JSON.parse(JSON.stringify(this._getElementDataByRef(ref))),
    }));
    this._writeSectionItems(deleted.map(({ ref, original }) => ({ ref, value: this._buildDeletion(ref, original) })));
    this._clearSelection();
    this.setState({ lastDeleted: deleted });
  };

  _undoDelete = () => {
    const deleted = this.state.lastDeleted;
    if (!deleted || deleted.length === 0) return;
    this._writeSectionItems(deleted.map(({ ref, original }) => ({ ref, value: original })));
    this.setState({ lastDeleted: null });

    // Re-select what came back once it's on the canvas again.
    window.requestAnimationFrame(() => {
      const ids = deleted.map(({ ref }) => ref.id).filter((id) => document.getElementById(id));
      if (ids.length) this._selectPrimaryFromDom(document.getElementById(ids[0]), ids);
    });
  };

  _onDeleteKeyDown = (e) => {
    const target = e.target;
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT" || target.isContentEditable)) return;

    if ((e.key === "Delete" || e.key === "Backspace") && !e.ctrlKey && !e.metaKey && !e.altKey) {
      if (!this.state.selectedElementName) return;
      e.preventDefault();
      this._deleteSelection();
    } else if ((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (e.key || "").toLowerCase() === "z") {
      if (!this.state.lastDeleted) return;
      e.preventDefault();
      this._undoDelete();
    }
  };
  //#endregion

  //#region Copy / paste elements
  // Ctrl/⌘+C copies the selection, Ctrl/⌘+V pastes it (into the selected
  // element's section, or the section it was copied from) and Ctrl/⌘+D
  // duplicates the selection in place. Copies get new ids/names, are offset
  // by 10px per paste, and copied groups become a new group.

  // Company fields (and copies of them) can be duplicated but not copied:
  // they stay in the section they're in.
  _isCompanyFieldRef = (ref) => ref.path === "companyProps" ||
    (ref.path === "elements" && (this._getElementDataByRef(ref)?.name || "").includes(companyPath()));

  _getCopyableRefs = () => this._getSelectionRefs().filter((ref) => (
    COPYABLE_PATHS.includes(ref.path) && !this._isCompanyFieldRef(ref)
  ));

  _getDuplicableRefs = () => this._getSelectionRefs().filter((ref) => (
    COPYABLE_PATHS.includes(ref.path) || ref.path === "companyProps"
  ));

  // A duplicated company field becomes an ordinary data field bound to the
  // same company field (as company fields are in added sections), so the
  // original keeps its place in the header's company field list.
  _buildClipboardPayload = (refs = this._getCopyableRefs()) => {
    if (refs.length === 0) return null;
    return {
      __type: "witmeg-template-elements",
      section: refs[0].section,
      items: refs.map((ref) => {
        const data = JSON.parse(JSON.stringify(this._getElementDataByRef(ref)));
        if (ref.path !== "companyProps") return { path: ref.path, data };
        delete data.show;
        return { path: "elements", data };
      }),
    };
  };

  _copySelection = () => {
    const payload = this._buildClipboardPayload();
    if (!payload) {
      this.setState({ errorMessage: "The logo, company fields, document title and VAT summary can't be copied." });
      return;
    }
    try {
      window.localStorage.setItem(ELEMENT_CLIPBOARD_KEY, JSON.stringify(payload));
    } catch (err) {
      console.error(err);
    }
    this._elementClipboard = payload;
    this._pasteCounts = {};
    this.setState({ copiedElementCount: payload.items.length });
  };

  _getElementClipboard = () => this._elementClipboard || readElementClipboard();

  _getCanvasSectionEl = (section) => document.querySelector(`[data-canvas-section="${section}"]`);

  // Sections elements can be placed in: header/total/footer, or in bands
  // mode every band except the items band.
  _getCanvasSections = () => (this._isBandsMode()
    ? this._getBands().filter((band) => band.type !== BAND_TYPES.ITEMS).map((band) => band.section)
    : CANVAS_SECTIONS);

  // Works out which section was clicked from the pointer position, so empty
  // space counts too. Clicks outside header/total/footer (e.g. the items
  // table) keep the previous target.
  _rememberCanvasSection = (e) => {
    const hit = this._getCanvasSections().find((section) => {
      const el = this._getCanvasSectionEl(section);
      if (!el) return false;
      const r = el.getBoundingClientRect();
      return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    });
    if (hit && hit !== this.state.pasteTargetSection) this.setState({ pasteTargetSection: hit });
  };

  // Where Paste will put elements: the section last clicked on the canvas,
  // otherwise the selected element's section, otherwise where they came from.
  _getPasteTargetSection = (payload = this._getElementClipboard()) => {
    const sections = this._getCanvasSections();
    if (sections.includes(this.state.pasteTargetSection)) return this.state.pasteTargetSection;
    const primaryRef = this.state.selectedElementName
      ? this._getElementRefFromDom(document.getElementById(this.state.selectedElementName))
      : null;
    if (primaryRef && sections.includes(primaryRef.section)) return primaryRef.section;
    return payload?.section || null;
  };

  // A free name for a copy: numbered kinds (Custom-Text-N, box-N, qr-N, …)
  // take the next number; data fields get "-copy-N" (their {placeholder}
  // text and binding stay the same).
  _getCopyName = (data, collection, taken) => {
    const name = data.name || "element";
    const isTaken = (candidate) => taken.has(candidate) || taken.has(candidate.replace(/\./g, ""));
    const numbered = /^(Custom-Text-|box-|circle-|line-|qr-|image-)(\d+)$/.exec(name);

    if (numbered) {
      const prefix = numbered[1];
      let next = 1 + Math.max(0, ...Object.values(collection)
        .map((item) => (item?.name || "").startsWith(prefix) ? parseInt(item.name.slice(prefix.length), 10) : 0)
        .filter((n) => !isNaN(n)));
      while (isTaken(prefix + next)) next++;
      return prefix + next;
    }

    let n = 1;
    while (isTaken(`${name}-copy-${n}`)) n++;
    return `${name}-copy-${n}`;
  };

  // Same section as the copy: each paste is offset 10px further so copies
  // don't stack. Another section: the first paste keeps the original
  // position (moved inside the section if needed), later ones are offset.
  _pasteElements = (copied = this._getElementClipboard(), options = {}) => {
    // Price fields copied from an invoice aren't pasted into a collection note.
    const payload = this.props.hidesPricing ? stripPricingFromClipboard(copied) : copied;
    if (!payload || !payload.items?.length) return;

    const section = options.section || this._getPasteTargetSection(payload);
    if (!this._getCanvasSections().includes(section) || !this.props.properties[section]) return;
    const update = (content) => this._updateSection(section, content);

    let offset = options.offset;
    if (offset === undefined) {
      this._pasteCounts = this._pasteCounts || {};
      const pastesHere = this._pasteCounts[section] || 0;
      offset = 10 * (section === payload.section ? pastesHere + 1 : pastesHere);
      this._pasteCounts[section] = pastesHere + 1;
    }

    // Keep the pasted set inside the target section, moving it as a whole so
    // grouped items keep their layout.
    const sectionEl = this._getCanvasSectionEl(section);
    const boxes = payload.items.map(({ data }) => ({
      top: (parseFloat(data?.style?.top) || 0) + offset,
      left: (parseFloat(data?.style?.left) || 0) + offset,
      width: parseFloat(data?.style?.width) || 100,
      height: parseFloat(data?.style?.height) || 30,
    }));
    let shiftX = 0;
    let shiftY = 0;
    if (sectionEl && boxes.length) {
      const maxRight = Math.max(...boxes.map((b) => b.left + b.width));
      const maxBottom = Math.max(...boxes.map((b) => b.top + b.height));
      const minLeft = Math.min(...boxes.map((b) => b.left));
      const minTop = Math.min(...boxes.map((b) => b.top));
      if (maxRight > sectionEl.clientWidth) shiftX = sectionEl.clientWidth - maxRight;
      if (minLeft + shiftX < 0) shiftX = -minLeft;
      if (maxBottom > sectionEl.clientHeight) shiftY = sectionEl.clientHeight - maxBottom;
      if (minTop + shiftY < 0) shiftY = -minTop;
    }

    const next = { ...this.props.properties[section] };
    const newGroupIds = {};
    const newIds = [];

    payload.items.forEach(({ path, data }, i) => {
      if (!COPYABLE_PATHS.includes(path) || !data) return;
      const collection = { ...(next[path] || {}) };
      const taken = new Set([...Object.keys(collection), ...Object.values(collection).map((item) => item?.name).filter(Boolean)]);
      const name = this._getCopyName(data, collection, taken);
      const key = name.replace(/\./g, "");

      const copy = JSON.parse(JSON.stringify(data));
      copy.name = name;
      copy.id = sha256(`${section}-${path}-${name}-${Date.now()}-${i}`);
      if (copy.groupId) {
        newGroupIds[copy.groupId] = newGroupIds[copy.groupId] ||
          "grp-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 8);
        copy.groupId = newGroupIds[copy.groupId];
      }
      copy.style = {
        ...(copy.style || {}),
        top: Math.round(boxes[i].top + shiftY) + "px",
        left: Math.round(boxes[i].left + shiftX) + "px",
      };

      collection[key] = copy;
      next[path] = collection;
      newIds.push(copy.id);
    });

    if (newIds.length === 0) return;
    // Pasted/duplicated elements are placed and selected here, not moved.
    this._suppressReveal = true;
    update(next);

    // Select the pasted elements once they're on the canvas.
    window.requestAnimationFrame(() => {
      const present = newIds.filter((id) => document.getElementById(id));
      if (present.length) this._selectPrimaryFromDom(document.getElementById(present[0]), present);
    });
  };

  _duplicateSelection = () => {
    const payload = this._buildClipboardPayload(this._getDuplicableRefs());
    if (!payload) {
      this.setState({ errorMessage: "The logo, document title and VAT summary can't be duplicated." });
      return;
    }
    this._pasteElements(payload, { section: payload.section, offset: 10 });
  };

  _onClipboardKeyDown = (e) => {
    if (!(e.ctrlKey || e.metaKey) || e.altKey || e.shiftKey) return;
    const key = (e.key || "").toLowerCase();
    if (key !== "c" && key !== "v" && key !== "d") return;

    const target = e.target;
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.tagName === "SELECT" || target.isContentEditable)) return;

    if (key === "c") {
      if (!this.state.selectedElementName) return;
      // Let the browser copy highlighted page text as usual.
      if (window.getSelection && String(window.getSelection()).trim()) return;
      e.preventDefault();
      this._copySelection();
    } else if (key === "v") {
      if (!this._getElementClipboard()) return;
      e.preventDefault();
      this._pasteElements();
    } else {
      if (!this.state.selectedElementName) return;
      e.preventDefault();
      this._duplicateSelection();
    }
  };
  //#endregion

  _getElementFontSizeValue = (el, ref) => {
    if (el.style?.fontSize) return this._parseFontSize(el.style.fontSize);
    if (ref.path === "documentTitle") return 20;
    if (this.props.properties[ref.section]?.font?.fontSize) return this._parseFontSize(this.props.properties[ref.section].font.fontSize);
    if (this.props.properties.prop?.fontSize) return this._parseFontSize(this.props.properties.prop.fontSize);
    return 10;
  };

  // Toolbar style buttons for a multi-selection. Toggles are decided from the
  // primary element so every selected element ends up with the same value.
  _handleGroupStyleUpdate = (property, value, isIncrement, isHeading, isToggle, offValue) => {
    const refs = this._getSelectionRefs().filter(this._canRefHaveText);
    if (refs.length === 0) return;

    const primaryRef = this._getElementRefFromDom(document.getElementById(this.state.selectedElementName));
    const referenceRef = primaryRef && refs.some((r) => r.id === primaryRef.id) ? primaryRef : refs[0];
    const referenceStyle = this._getElementDataByRef(referenceRef)?.style || {};

    let stylePatch;
    if (isHeading && isToggle) {
      const headingSizes = { h1: "24pt", h2: "20pt", h3: "16pt" };
      const turningOff = referenceStyle.fontSize === headingSizes[value];
      stylePatch = (el, ref) => (turningOff
        ? {
          fontWeight: "normal",
          fontSize: ref.path === "documentTitle" ? "20pt" : this.props.properties.prop.fontSize + "pt",
          textDecoration: "none",
          fontStyle: "normal"
        }
        : { fontWeight: "bold", fontSize: headingSizes[value], textDecoration: "none", fontStyle: "normal" });
    } else if (isToggle) {
      const currentValue = referenceStyle[property];
      const hasValue = property === "textDecoration"
        ? currentValue === value || (currentValue && currentValue.includes(value))
        : currentValue === value;
      const toggleValue = hasValue ? offValue : value;
      stylePatch = () => ({ [property]: toggleValue });
    } else if (isIncrement && property === "fontSize") {
      stylePatch = (el, ref) => ({ fontSize: (this._getElementFontSizeValue(el, ref) + value) + "pt" });
    } else {
      stylePatch = () => ({ [property]: value });
    }

    const updater = (el, ref) => ({ ...el, style: { ...el.style, ...stylePatch(el, ref) } });
    this._applyElementUpdates(refs.map((ref) => ({ ref, updater })));

    const referenceElement = this._getElementDataByRef(referenceRef);
    if (referenceElement) this._updateActiveStyles(updater(referenceElement, referenceRef));
  };

  // Moves every selected element by the primary element's (snapped) offset.
  _moveGroup = (primaryName) => {
    const members = this._dragGroupStart;
    const primary = members.find((m) => m.id === primaryName) || members[0];

    const snapped = this._getSnapAdjustedPosition(
      primary.id,
      primary.ref.section,
      this._dragRawTop,
      this._dragRawLeft,
      members.map((m) => m.id)
    );
    const deltaTop = snapped.top - primary.top;
    const deltaLeft = snapped.left - primary.left;

    const newManuallyPositioned = new Set(this.state.manuallyPositionedElements);
    members.forEach((m) => {
      newManuallyPositioned.add(m.id);
      const domEl = document.getElementById(m.id);
      if (domEl) {
        domEl.style.top = (m.top + deltaTop) + "px";
        domEl.style.left = (m.left + deltaLeft) + "px";
      }
    });
    this.setState({ manuallyPositionedElements: newManuallyPositioned });

    this._applyElementUpdates(members.map((m) => ({
      ref: m.ref,
      updater: (el) => ({
        ...el,
        style: { ...el.style, top: (m.top + deltaTop) + "px", left: (m.left + deltaLeft) + "px" }
      })
    })));
  };

  //#endregion

  //#region Resize Element
  _resizeMouseDown = (e) => {
    console.log(e)
    e.preventDefault();
    // this.selectedElementResizeOn = true;
    this._resizeRaw = undefined; // starts from the element's current size
    this.setState({
      selectedElementResizeOn: true
    })
  };

  _resizeMouseMove = (e) => {
    if (this.state.selectedElementResizeOn) {
      var elementName = this.state.selectedElementName;
      var width = document.getElementById(elementName).offsetWidth;
      var height = document.getElementById(elementName).offsetHeight;
      var props = this.props.properties;
      var sect = props[this.section];
      //console.log(this.section);

      this.setState(
        {
          properties: {
            ...props,
            [this.section]: {
              ...sect,
              logo: {
                ...sect.logo,
                style: {
                  ...sect.logo.style,
                  width: width + e.movementX + "px",
                  height: height + e.movementY + "px",
                },
              },
              elements: [
                ...sect.elements.slice(0, this.index),
                {
                  ...sect.elements[this.index],
                  style: {
                    ...sect.elements[this.index].style,
                    width: width + e.movementX + "px",
                    height: height + e.movementY + "px",
                  },
                },
                ...sect.elements.slice(this.index + 1),
              ],
            },
          },
        },
        function () { }
      );
    }
  };

  _resizeMouseUp = (e) => {
    e.preventDefault();
    // this.selectedElementResizeOn = false;
    this._resizeRaw = undefined;
    this.setState({
      selectedElementResizeOn: false
    })
  };

  _resizeMouseLeave = (e) => {
    e.preventDefault();
    // this.selectedElementResizeOn = false;
    this._resizeRaw = undefined;
    this.setState({
      selectedElementResizeOn: false
    })
  };

  //#endregion

  //#region Move Element
  _moveMouseDown = (e) => {
    e.preventDefault();
    // this.selectedElementMoveOn = true;
    const elementName = this.state.selectedElementName;
    const el = elementName && document.getElementById(elementName);
    // Tracks the element's true (unsnapped) position as the mouse moves it,
    // independently of the snapped position actually rendered/applied — so
    // snapping only engages while genuinely close to another element and
    // releases immediately once the cursor moves away, instead of "sticking".
    this._dragRawTop = el ? (parseInt(el.style.top) || 0) : 0;
    this._dragRawLeft = el ? (parseInt(el.style.left) || 0) : 0;

    // With several elements selected, remember where each one started so the
    // whole selection moves by the same offset as the dragged element.
    const selectedIds = this._getSelectedIds();
    this._dragGroupStart = selectedIds.length > 1
      ? selectedIds.map((id) => {
        const domEl = document.getElementById(id);
        return {
          id,
          ref: this._getElementRefFromDom(domEl),
          top: parseInt(domEl.style.top) || 0,
          left: parseInt(domEl.style.left) || 0,
        };
      }).filter((m) => m.ref && this._getElementDataByRef(m.ref))
      : null;

    this.setState({
      selectedElementMoveOn: true
    })
  };

  // Page border edges an element in `section` snaps to, in the section's own
  // coordinates: { x: [...], y: [...] }, or null without a page border.
  // Sideways: the padding edge (0 / content width) and, beyond the padding,
  // the border's inner edge. Up and down only where the section touches the
  // frame: the top of the first section and the bottom of a bottom section.
  _getFrameSnapGuides = (section) => {
    if (!this._isBandsMode()) return null;
    const layout = getPageLayout(this.props.properties);
    if (!layout.pageFrame) return null;
    const bands = this._getBands();
    const index = bands.findIndex((b) => b.section === section);
    if (index < 0) return null;
    const band = bands[index];
    const pad = layout.pageFrame.padding;
    const width = layout.content.width;

    const x = pad > 0 ? [0, width, -pad, width + pad] : [0, width];
    const y = [];
    if (index === 0 && band.placement === BAND_PLACEMENT.AFTER_CONTENT) y.push(0, ...(pad > 0 ? [-pad] : []));
    if (index === bands.length - 1 && band.placement === BAND_PLACEMENT.PAGE_BOTTOM) {
      y.push(band.height, ...(pad > 0 ? [band.height + pad] : []));
    }
    return { x, y };
  };

  // Edges of the boxes an element (at `rect`, in its section's coordinates)
  // is over or close to: the box's outer edge, the inner edge of its border
  // and, with padding set, the padding edge — so things placed in a box line
  // up with it. Boxes elsewhere in the section don't pull. { x: [], y: [] }.
  _getShapeSnapGuides = (section, elementName, rect) => {
    const x = [];
    const y = [];
    const reach = 6;
    document.querySelectorAll(`.custom-element[data-section="${section}"][data-path="shapes"]`).forEach((shape) => {
      if (shape.id === elementName || !String(shape.getAttribute("data-index") || "").startsWith("box")) return;
      const left = parseInt(shape.style.left) || 0;
      const top = parseInt(shape.style.top) || 0;
      const right = left + shape.offsetWidth;
      const bottom = top + shape.offsetHeight;
      if (rect.right < left - reach || rect.left > right + reach || rect.bottom < top - reach || rect.top > bottom + reach) return;

      const css = window.getComputedStyle(shape);
      const border = (side) => parseFloat(css[`border${side}Width`]) || 0;
      const data = this.props.properties[section]?.shapes?.[shape.getAttribute("data-index")];
      const pad = Math.max(0, parseInt(data?.padding, 10) || 0);

      x.push(left, right, left + border("Left"), right - border("Right"));
      y.push(top, bottom, top + border("Top"), bottom - border("Bottom"));
      if (pad > 0) {
        x.push(left + border("Left") + pad, right - border("Right") - pad);
        y.push(top + border("Top") + pad, bottom - border("Bottom") - pad);
      }
    });
    return x.length ? { x, y } : null;
  };

  // The items table's column edges, so a totals block under the table can
  // line up with its columns. Bands mode only: there the table spans the
  // content width and every section starts at its left edge, so these are
  // x positions in any section (the PDF splits the width the same way).
  _getTableColumnEdges = () => {
    if (!this._isBandsMode()) return [];
    const items = this.props.properties.items?.items || {};
    const columns = Object.keys(items).map((k) => items[k]).filter((c) => c && c.width !== undefined);
    if (columns.length === 0) return [];
    const width = getPageLayout(this.props.properties).content.width;
    const total = columns.reduce((sum, c) => sum + Number(c.width || 10), 0) || 1;
    let at = 0;
    return [0, ...columns.map((c) => {
      at += Number(c.width || 10);
      return Math.round((at / total) * width);
    })];
  };

  // Page border, box and table column guides together, or null when there
  // are none.
  _getAlwaysOnGuides = (section, elementName, rect) => {
    const frame = this._getFrameSnapGuides(section);
    const shapes = this._getShapeSnapGuides(section, elementName, rect);
    const columns = this._getTableColumnEdges();
    if (!frame && !shapes && columns.length === 0) return null;
    return { x: [...(frame?.x || []), ...(shapes?.x || []), ...columns], y: [...(frame?.y || []), ...(shapes?.y || [])] };
  };

  // Faint lines at the table's column edges in the section an element is
  // being moved or resized in.
  _renderColumnGuides = (section) => {
    if (!(this.state.selectedElementMoveOn || this.state.selectedElementResizeOn)) return null;
    if (this.props.selectedElement?.section !== section) return null;
    return this._getTableColumnEdges().map((x) => (
      <div
        key={x}
        className="table-column-guide"
        aria-hidden="true"
        style={{ position: "absolute", top: 0, bottom: 0, left: x, borderLeft: "1px dashed rgba(0, 123, 255, 0.35)", pointerEvents: "none" }}
      />
    ));
  };

  _getSnapAdjustedPosition = (elementName, section, rawTop, rawLeft, excludeIds = []) => {
    // All snapping is always on (holding Alt while dragging turns it off for
    // that drag; see _moveMouseMove): other elements' edges and centres, the
    // page border, boxes, equal spacing and the page centre.
    const snapToElements = true;

    const el = document.getElementById(elementName);
    if (!el || !section) return { top: rawTop, left: rawLeft };

    const width = el.offsetWidth;
    const height = el.offsetHeight;
    const frameGuides = this._getAlwaysOnGuides(section, elementName, { left: rawLeft, top: rawTop, right: rawLeft + width, bottom: rawTop + height });
    // Tight, deliberate snap zone: only engages when genuinely close, and
    // — since it always locks to the exact matching pixel, never a soft
    // partial pull — the result is a crisp, decisive snap rather than a
    // gradual magnet.
    const threshold = 3;

    const draggedX = { left: rawLeft, right: rawLeft + width, centerX: rawLeft + width / 2 };
    const draggedY = { top: rawTop, bottom: rawTop + height, centerY: rawTop + height / 2 };

    const others = [];
    document.querySelectorAll(`.custom-element[data-section="${section}"]`).forEach((other) => {
      if (!snapToElements) return;
      if (other.id === elementName || excludeIds.includes(other.id)) return;

      const otherTop = parseInt(other.style.top) || 0;
      const otherLeft = parseInt(other.style.left) || 0;
      const otherWidth = other.offsetWidth;
      const otherHeight = other.offsetHeight;

      others.push({
        x: { left: otherLeft, right: otherLeft + otherWidth, centerX: otherLeft + otherWidth / 2 },
        y: { top: otherTop, bottom: otherTop + otherHeight, centerY: otherTop + otherHeight / 2 },
      });
    });

    // Finds the smallest-magnitude delta within `threshold` across every
    // candidate for a given set of edge/center pairings only — called in
    // priority tiers below so edge-to-edge alignment always wins over a
    // center-based match at the same distance, instead of whichever
    // happened to be checked first.
    const bestDeltaFor = (draggedAxis, axisKey, pairs) => {
      let best = null;
      others.forEach((other) => {
        pairs.forEach(([draggedKey, otherKey]) => {
          const delta = other[axisKey][otherKey] - draggedAxis[draggedKey];
          if (Math.abs(delta) <= threshold && (best === null || Math.abs(delta) < Math.abs(best))) {
            best = delta;
          }
        });
      });
      return best;
    };

    const xEdgePairs = [["left", "left"], ["left", "right"], ["right", "left"], ["right", "right"]];
    const xCenterPairs = [["left", "centerX"], ["right", "centerX"], ["centerX", "left"], ["centerX", "right"]];
    const xCenterCenterPairs = [["centerX", "centerX"]];

    const yEdgePairs = [["top", "top"], ["top", "bottom"], ["bottom", "top"], ["bottom", "bottom"]];
    const yCenterPairs = [["top", "centerY"], ["bottom", "centerY"], ["centerY", "top"], ["centerY", "bottom"]];
    const yCenterCenterPairs = [["centerY", "centerY"]];

    const elementXDelta = bestDeltaFor(draggedX, "x", xEdgePairs)
      ?? bestDeltaFor(draggedX, "x", xCenterPairs)
      ?? bestDeltaFor(draggedX, "x", xCenterCenterPairs);
    const elementYDelta = bestDeltaFor(draggedY, "y", yEdgePairs)
      ?? bestDeltaFor(draggedY, "y", yCenterPairs)
      ?? bestDeltaFor(draggedY, "y", yCenterCenterPairs);

    // Page border edges: either edge of the element locks onto a guide, with a
    // slightly wider pull since they're targets users aim for. The nearer of
    // a border snap and an element snap wins.
    const FRAME_SNAP_THRESHOLD = 6;
    const nearestGuide = (edges, guides) => {
      let best = null;
      (guides || []).forEach((guide) => edges.forEach((edge) => {
        const delta = guide - edge;
        if (Math.abs(delta) <= FRAME_SNAP_THRESHOLD && (best === null || Math.abs(delta) < Math.abs(best))) best = delta;
      }));
      return best;
    };
    const nearer = (a, b) => (a === null ? b : b === null ? a : (Math.abs(b) < Math.abs(a) ? b : a));
    let xDelta = nearer(elementXDelta, nearestGuide([rawLeft, rawLeft + width], frameGuides?.x));
    let yDelta = nearer(elementYDelta, nearestGuide([rawTop, rawTop + height], frameGuides?.y));

    // Equal spacing and the page centre: a smart snap wins when it's nearer
    // than the edge snaps above, and brings its indicator with it.
    const smart = this._getSmartSnaps(el, section, rawLeft, rawTop, width, height);
    const pick = (current, candidates) => {
      let best = null;
      candidates.forEach((c) => {
        if (Math.abs(c.delta) <= SMART_SNAP_THRESHOLD && (best === null || Math.abs(c.delta) < Math.abs(best.delta))) best = c;
      });
      return best && (current === null || Math.abs(best.delta) <= Math.abs(current)) ? best : null;
    };
    const smartX = pick(xDelta, smart.x);
    const smartY = pick(yDelta, smart.y);
    if (smartX) xDelta = smartX.delta;
    if (smartY) yDelta = smartY.delta;

    const left = xDelta !== null ? rawLeft + xDelta : rawLeft;
    const top = yDelta !== null ? rawTop + yDelta : rawTop;

    // Indicators: equal gaps found, and the centre lines whenever the element
    // ends up exactly centred on the page (however it got there).
    const indicators = [...(smartX?.gapIndicators || []), ...(smartY?.gapIndicators || [])];

    // Alignment: a line from this element to each one it now lines up with —
    // same top / middle / bottom (a row) or left / centre / right (a column).
    const placed = { left, right: left + width, centerX: left + width / 2, top, bottom: top + height, centerY: top + height / 2 };
    others.forEach((other) => {
      ["top", "centerY", "bottom"].forEach((k) => {
        if (Math.abs(other.y[k] - placed[k]) < 0.5) {
          indicators.push({ type: "align", orientation: "h", x1: Math.min(placed.left, other.x.left), x2: Math.max(placed.right, other.x.right), y1: placed[k], y2: placed[k] });
        }
      });
      ["left", "centerX", "right"].forEach((k) => {
        if (Math.abs(other.x[k] - placed[k]) < 0.5) {
          indicators.push({ type: "align", orientation: "v", x1: placed[k], x2: placed[k], y1: Math.min(placed.top, other.y.top), y2: Math.max(placed.bottom, other.y.bottom) });
        }
      });
    });

    if (smart.page) {
      if (Math.abs(left + width / 2 - smart.page.centerX) < 0.5) indicators.push({ type: "centerV", x: smart.page.width / 2 });
      if (Math.abs(top + height / 2 - smart.page.centerY) < 0.5) indicators.push({ type: "centerH", y: smart.page.height / 2 });
      indicators.forEach((ind) => {
        // Gap markers come in the element's container coordinates; the
        // overlay is positioned on the page.
        if (ind.type === "gap" || ind.type === "align") {
          ind.x1 += smart.page.offsetX; ind.x2 += smart.page.offsetX;
          ind.y1 += smart.page.offsetY; ind.y2 += smart.page.offsetY;
        }
      });
    }

    return { top, left, indicators };
  };

  // Smart snaps for an element at (rawLeft, rawTop) in its container:
  //   equal spacing — in its row (or column), the centre-to-centre distance
  //     to its nearest neighbour can match the centre-to-centre distance of
  //     two neighbouring elements there, or its centre can sit exactly
  //     halfway between its two neighbours' centres;
  //   page centre — its centre on the page's vertical / horizontal middle.
  // Returns { x: [candidates], y: [candidates], page } where a candidate is
  // { delta, gapIndicators } and `page` gives the page centre in container
  // coordinates plus the offset from container to page.
  _getSmartSnaps = (el, section, rawLeft, rawTop, width, height) => {
    const result = { x: [], y: [], page: null };
    const container = el.offsetParent;
    const page = el.closest(".canves-content");
    if (!container || !page) return result;

    const containerBox = container.getBoundingClientRect();
    const pageBox = page.getBoundingClientRect();
    const offsetX = containerBox.left - pageBox.left;
    const offsetY = containerBox.top - pageBox.top;
    result.page = {
      width: page.clientWidth,
      height: page.clientHeight,
      centerX: page.clientWidth / 2 - offsetX,
      centerY: page.clientHeight / 2 - offsetY,
      offsetX,
      offsetY,
    };
    result.x.push({ delta: result.page.centerX - (rawLeft + width / 2) });
    result.y.push({ delta: result.page.centerY - (rawTop + height / 2) });

    const others = [];
    document.querySelectorAll(`.custom-element[data-section="${section}"]`).forEach((other) => {
      if (other === el || !other.offsetWidth || other.classList.contains("selected-element")) return;
      const l = parseInt(other.style.left) || 0;
      const t = parseInt(other.style.top) || 0;
      others.push({ left: l, top: t, right: l + other.offsetWidth, bottom: t + other.offsetHeight });
    });
    const me = { left: rawLeft, top: rawTop, right: rawLeft + width, bottom: rawTop + height };

    // One axis at a time (spacing measured between centres): "a"/"b" are the
    // near/far edges along it and
    // "c"/"d" the edges across it (a row shares vertical space, a column
    // horizontal space).
    const axis = (a, b, c, d, size) => {
      const overlaps = (p, q) => p[c] < q[d] && q[c] < p[d];
      const gapMarker = (from, to, p, q) => {
        const mid = (Math.max(p[c], q[c]) + Math.min(p[d], q[d])) / 2;
        return a === "left"
          ? { type: "gap", orientation: "h", x1: from, x2: to, y1: mid, y2: mid }
          : { type: "gap", orientation: "v", x1: mid, x2: mid, y1: from, y2: to };
      };

      // Spacing is measured centre to centre along the axis.
      const center = (o) => (o[a] + o[b]) / 2;
      const myCenter = center(me);

      // Only the element's own row (or column) counts: the elements sharing
      // its vertical (or horizontal) space, in centre order, and the
      // centre-to-centre spacing of each neighbouring pair of them.
      const mates = others.filter((o) => overlaps(o, me)).sort((p, q) => center(p) - center(q));
      const gaps = [];
      for (let i = 0; i + 1 < mates.length; i++) {
        const p = mates[i];
        const q = mates[i + 1];
        const gap = center(q) - center(p);
        if (gap > 0) gaps.push({ gap, marker: gapMarker(center(p), center(q), p, q) });
      }

      // Nearest neighbours on either side, by centre.
      const before = mates.filter((o) => center(o) < myCenter).slice(-1)[0];
      const after = mates.filter((o) => center(o) > myCenter)[0];
      const candidates = [];
      // Moves the element so its centre lands on `target`.
      const toCenter = (target) => target - size / 2 - me[a];

      gaps.forEach(({ gap, marker }) => {
        if (before) {
          const target = center(before) + gap;
          candidates.push({ delta: toCenter(target), gapIndicators: [marker, gapMarker(center(before), target, before, me)] });
        }
        if (after) {
          const target = center(after) - gap;
          candidates.push({ delta: toCenter(target), gapIndicators: [marker, gapMarker(target, center(after), me, after)] });
        }
      });
      if (before && after) {
        // Exactly halfway between the two neighbours' centres.
        const target = (center(before) + center(after)) / 2;
        candidates.push({
          delta: toCenter(target),
          gapIndicators: [gapMarker(center(before), target, before, me), gapMarker(target, center(after), me, after)],
        });
      }
      return candidates;
    };

    result.x.push(...axis("left", "right", "top", "bottom", width));
    result.y.push(...axis("top", "bottom", "left", "right", height));
    return result;
  };

  // Shows the snap indicators on the canvas (empty clears them).
  _setSnapIndicators = (indicators) => {
    const next = indicators || [];
    const key = JSON.stringify(next);
    if (key === this._snapIndicatorKey) return;
    this._snapIndicatorKey = key;
    this.setState({ snapIndicators: next });
  };

  _renderSnapIndicators = () => {
    const indicators = this.state.snapIndicators || [];
    if (!indicators.length) return null;
    const color = "#E83E8C";
    return (
      <div className="snap-indicators" style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0, pointerEvents: "none", zIndex: 5 }}>
        {indicators.map((ind, i) => {
          if (ind.type === "centerV") {
            return <div key={i} style={{ position: "absolute", left: ind.x, top: 0, bottom: 0, borderLeft: `1px dashed ${color}` }} />;
          }
          if (ind.type === "centerH") {
            return <div key={i} style={{ position: "absolute", top: ind.y, left: 0, right: 0, borderTop: `1px dashed ${color}` }} />;
          }
          // Two elements lined up: a line from one to the other.
          if (ind.type === "align") {
            return ind.orientation === "h"
              ? <div key={i} style={{ position: "absolute", left: ind.x1, top: ind.y1, width: Math.max(0, ind.x2 - ind.x1), borderTop: `1px solid ${color}` }} />
              : <div key={i} style={{ position: "absolute", top: ind.y1, left: ind.x1, height: Math.max(0, ind.y2 - ind.y1), borderLeft: `1px solid ${color}` }} />;
          }
          // An equal gap: a line across it with short end ticks.
          const horizontal = ind.orientation === "h";
          return horizontal ? (
            <div key={i} style={{ position: "absolute", left: ind.x1, top: ind.y1 - 4, width: Math.max(0, ind.x2 - ind.x1), height: 8, borderLeft: `1px solid ${color}`, borderRight: `1px solid ${color}`, boxSizing: "border-box" }}>
              <div style={{ position: "absolute", top: 3.5, left: 0, right: 0, borderTop: `1px solid ${color}` }} />
            </div>
          ) : (
            <div key={i} style={{ position: "absolute", top: ind.y1, left: ind.x1 - 4, height: Math.max(0, ind.y2 - ind.y1), width: 8, borderTop: `1px solid ${color}`, borderBottom: `1px solid ${color}`, boxSizing: "border-box" }}>
              <div style={{ position: "absolute", left: 3.5, top: 0, bottom: 0, borderLeft: `1px solid ${color}` }} />
            </div>
          );
        })}
      </div>
    );
  };

  _moveMouseMove = (e) => {
    if (this.state.selectedElementMoveOn) {

      var elementName = this.state.selectedElementName;
      const newManuallyPositioned = new Set(this.state.manuallyPositionedElements);
      newManuallyPositioned.add(elementName);
      this.setState({ manuallyPositionedElements: newManuallyPositioned });

      // Advance the true (unsnapped) cursor-tracked position first, so snapping
      // never accumulates on top of an already-snapped value — it's recomputed
      // fresh from the real drag distance every tick.
      if (this._dragRawTop === undefined || this._dragRawLeft === undefined) {
        const domEl = document.getElementById(elementName);
        this._dragRawTop = domEl ? (parseInt(domEl.style.top) || 0) : 0;
        this._dragRawLeft = domEl ? (parseInt(domEl.style.left) || 0) : 0;
      }
      this._dragRawTop += e.movementY;
      this._dragRawLeft += e.movementX;

      if (this._dragGroupStart && this._dragGroupStart.length > 1) {
        this._moveGroup(elementName);
        return;
      }

      const section = document.getElementById(elementName).getAttribute("data-section");
      const path = document.getElementById(elementName).getAttribute("data-path");

      if (path === "logo") {
        // Holding Alt places freely (no snapping).
        const snappedLogo = e.altKey
          ? { top: this._dragRawTop, left: this._dragRawLeft, indicators: [] }
          : this._getSnapAdjustedPosition(elementName, section, this._dragRawTop, this._dragRawLeft);
        this._setSnapIndicators(snappedLogo.indicators);
        const newTop = snappedLogo.top;
        const newLeft = snappedLogo.left;

        document.getElementById(elementName).style.top = newTop + "px";
        document.getElementById(elementName).style.left = newLeft + "px";

        this.props.updateHead({
          ...this.props.properties.head,
          logo: {
            ...this.props.properties.head.logo,
            style: {
              ...this.props.properties.head.logo.style,
              top: newTop + "px",
              left: newLeft + "px",
            }
          }
        });
        return;
      }

      const index = document.getElementById(elementName).getAttribute("data-index");
      const isCompanyProp = document.getElementById(elementName).getAttribute("data-is-company-prop") === "true";
      const isDocumentTitleId = document.getElementById(elementName).getAttribute("id") === "doc-title";

      // Holding Alt places freely (no snapping).
      const snapped = e.altKey
        ? { top: this._dragRawTop, left: this._dragRawLeft, indicators: [] }
        : this._getSnapAdjustedPosition(elementName, section, this._dragRawTop, this._dragRawLeft);
      this._setSnapIndicators(snapped.indicators);
      const newTop = snapped.top;
      const newLeft = snapped.left;

      document.getElementById(elementName).style.top = newTop + "px";
      document.getElementById(elementName).style.left = newLeft + "px";

      // console.log("document: ", document.getElementById(elementName))

      // console.log("pathhh: ", path)

      // console.log("newTop: ", newTop)

      // console.log("newLeft: ", newLeft)
      if (isDocumentTitleId) {
        console.log("Moving documentTitle to:", newLeft, newTop);

        const updatedDocumentTitle = {
          ...this.props.properties.head.documentTitle,
          style: {
            ...this.props.properties.head.documentTitle.style,
            top: newTop + "px",
            left: newLeft + "px"
          }
        };

        console.log("Updated documentTitle:", updatedDocumentTitle);

        this.props.updateHead({
          ...this.props.properties.head,
          documentTitle: updatedDocumentTitle
        });
      }

      if (isCompanyProp && path === "companyProps") {
        const updatedCompanyProps = {
          ...this.props.properties.head.companyProps,
          [index]: {
            ...this.props.properties.head.companyProps[index],
            style: {
              ...this.props.properties.head.companyProps[index].style,
              top: newTop + "px",
              left: newLeft + "px"
            }
          }
        };

        this.props.updateHead({
          ...this.props.properties.head,
          companyProps: updatedCompanyProps
        });
      } else {
        this.props.moveElement(newTop, newLeft);
      }
    } else if (this.state.selectedElementResizeOn) {
      var elementName = this.state.selectedElementName;

      var width = document.getElementById(elementName).offsetWidth;
      var height = document.getElementById(elementName).offsetHeight;

      const path = document.getElementById(elementName).getAttribute("data-path");

      if (path === "logo") {
        if (!this._resizeRaw) this._resizeRaw = { width, height };
        this._resizeRaw.width += e.movementX;
        this._resizeRaw.height += e.movementY;
        const logoEl = document.getElementById(elementName);
        const { width: newWidth, height: newHeight } = this._getSnapAdjustedSize(
          elementName,
          "head",
          parseInt(logoEl.style.left) || 0,
          parseInt(logoEl.style.top) || 0,
          this._resizeRaw.width,
          this._resizeRaw.height,
          e.altKey
        );

        document.getElementById(elementName).style.width = newWidth + "px";
        document.getElementById(elementName).style.height = newHeight + "px";

        this.props.updateHead({
          ...this.props.properties.head,
          logo: {
            ...this.props.properties.head.logo,
            style: {
              ...this.props.properties.head.logo.style,
              width: newWidth + "px",
              height: newHeight + "px",
            }
          }
        });
        return;
      }

      const index = document.getElementById(elementName).getAttribute("data-index");
      const isLine = path === "shapes" && index && index.startsWith("line");

      // A rotated line gets longer along its own direction; no snapping,
      // since its end isn't on the page's horizontal or vertical lines.
      const angle = isLine ? getLineRotation(this._getPrimaryElementData()) : 0;
      if (angle) {
        if (!this._resizeRaw) this._resizeRaw = { width, height };
        const rad = (angle * Math.PI) / 180;
        this._resizeRaw.width += e.movementX * Math.cos(rad) + e.movementY * Math.sin(rad);
        this.props.resizeElement(height, Math.max(4, Math.round(this._resizeRaw.width)));
        return;
      }

      // Track the true (unsnapped) size from the mouse, like moving does, so
      // a snap only holds while the edge is genuinely close to a guide.
      if (!this._resizeRaw) this._resizeRaw = { width, height };
      this._resizeRaw.width += e.movementX;
      this._resizeRaw.height += e.movementY;

      const el = document.getElementById(elementName);
      const snapped = this._getSnapAdjustedSize(
        elementName,
        el.getAttribute("data-section"),
        parseInt(el.style.left) || 0,
        parseInt(el.style.top) || 0,
        this._resizeRaw.width,
        this._resizeRaw.height,
        e.altKey
      );

      this.props.resizeElement(isLine ? height : snapped.height, snapped.width);
    }
  };

  // Resizing: the right and bottom edges snap like a moved element's edges —
  // to other elements' edges and centres, the page border and boxes.
  // `free` (Alt held): no snapping, just the mouse size.
  _getSnapAdjustedSize = (elementName, section, left, top, rawWidth, rawHeight, free = false) => {
    const snapToElements = true;
    const minSize = 4;
    const clamp = (width, height) => ({ width: Math.max(minSize, Math.round(width)), height: Math.max(minSize, Math.round(height)) });
    if (free || !section) return clamp(rawWidth, rawHeight);
    const frameGuides = this._getAlwaysOnGuides(section, elementName, { left, top, right: left + rawWidth, bottom: top + rawHeight });

    const xs = [];
    const ys = [];
    if (snapToElements) {
      document.querySelectorAll(`.custom-element[data-section="${section}"]`).forEach((other) => {
        if (other.id === elementName) return;
        const l = parseInt(other.style.left) || 0;
        const t = parseInt(other.style.top) || 0;
        xs.push(l, l + other.offsetWidth, l + other.offsetWidth / 2);
        ys.push(t, t + other.offsetHeight, t + other.offsetHeight / 2);
      });
    }

    const nearest = (edge, lines, threshold) => {
      let best = null;
      (lines || []).forEach((line) => {
        const delta = line - edge;
        if (Math.abs(delta) <= threshold && (best === null || Math.abs(delta) < Math.abs(best))) best = delta;
      });
      return best;
    };
    const nearer = (a, b) => (a === null ? b : b === null ? a : (Math.abs(b) < Math.abs(a) ? b : a));

    const right = left + rawWidth;
    const bottom = top + rawHeight;
    const dx = nearer(nearest(right, xs, 3), nearest(right, frameGuides?.x, 6));
    const dy = nearer(nearest(bottom, ys, 3), nearest(bottom, frameGuides?.y, 6));
    return clamp(rawWidth + (dx || 0), rawHeight + (dy || 0));
  };

  _moveMouseUp = (e) => {
    e.preventDefault();
    // this.selectedElementMoveOn = false;
    this._setSnapIndicators([]);
    this._dragRawTop = undefined;
    this._dragRawLeft = undefined;
    this._dragGroupStart = null;
    this.setState({
      selectedElementMoveOn: false
    })
  };

  _moveMouseLeave = (e) => {
    e.preventDefault();
    //this.selectedElementMoveOn = false;
    this.setState({
      selectedElementMoveOn: false
    })
  };
  //#endregion

  _getBestPositionForNewElement = (elementWidth, elementHeight, existingElements) => {
    const GRID_SIZE = 10;
    const START_X = 40;
    const START_Y = 40;
    const MAX_X = 800;
    const MAX_Y = 400;

    const gridPositions = [];

    for (let y = START_Y; y < MAX_Y - elementHeight; y += GRID_SIZE) {
      for (let x = START_X; x < MAX_X - elementWidth; x += GRID_SIZE) {
        gridPositions.push({ x, y });
      }
    }

    gridPositions.sort((a, b) => {
      if (a.y !== b.y) return a.y - b.y;
      return a.x - b.x;
    });

    for (const position of gridPositions) {
      const testRect = {
        top: position.y,
        left: position.x,
        right: position.x + elementWidth,
        bottom: position.y + elementHeight,
        width: elementWidth,
        height: elementHeight
      };

      let hasOverlap = false;

      for (const existingElement of existingElements) {
        const existingRect = this._getElementDimensions(existingElement.id);

        if (this._checkRectOverlap(testRect, existingRect)) {
          hasOverlap = true;
          break;
        }
      }

      if (!hasOverlap) {
        return { top: position.y, left: position.x };
      }
    }

    return { top: MAX_Y - elementHeight, left: START_X };
  };

  _checkRectOverlap = (rect1, rect2) => {
    const MARGIN = 5;

    return !(
      rect1.right + MARGIN < rect2.left ||
      rect2.right + MARGIN < rect1.left ||
      rect1.bottom + MARGIN < rect2.top ||
      rect2.bottom + MARGIN < rect1.top
    );
  };

  //#endregion

  _showToolTips = (obj) => {
    this.setState({ showToolTips: obj });
  };

  _renderElements = (section) => {
    var index = 0;
    return (
      this.props.properties &&
      Object.keys(this.props.properties[section].elements).map((key) => {
        var data = this.props.properties[section].elements[key];
        const defaultFontColor = this.props.properties.prop.fontColor;
        const defaultFontSize = this.props.properties.prop.fontSize + "pt";
        const sectionFont = this.props.properties[section]?.font || {
          fontFamily: 'Inter',
          fontSize: this.props.properties.prop.fontSize,
          color: this.props.properties.prop.fontColor
        };

        var dStyle = Object.assign({}, data.style);
        dStyle.fontFamily = data.style?.fontFamily || sectionFont.fontFamily || 'Inter';
        if (!dStyle.color) {
          dStyle.color = sectionFont.color || defaultFontColor;
        }
        if (!dStyle.fontSize) {
          dStyle.fontSize = sectionFont.fontSize ? sectionFont.fontSize + "pt" : defaultFontSize;
        }
        if (!dStyle.fontWeight) {
          dStyle.fontWeight = data.style?.fontWeight || 'normal';
        }
        if (!dStyle.fontStyle) {
          dStyle.fontStyle = data.style?.fontStyle || 'normal';
        }
        if (!dStyle.textDecoration) {
          dStyle.textDecoration = data.style?.textDecoration || 'none';
        }
        if (!dStyle.textAlign) {
          dStyle.textAlign = data.style?.textAlign || 'left';
        }

        const isSelected = this.state.selectedElementName == data.id;
        const isGroupSelected = this._isGroupSelected(data.id);

        return (
          <TemplateElement
            key={data.id}
            elementId={data.id}
            element={{
              ...data,
              section: section
            }}
            calculationLabel={data.data === CALCULATION_FIELD ? this._describeCalculation(data, section) : undefined}
            style={dStyle}
            isSelected={isSelected}
            isGroupSelected={isGroupSelected}
            onClick={(e) => this._onElementClick(e)}
            onMount={(id, domElement) => {
              console.log(`TemplateElement mounted: ${id}`);
              this._registerElementRef(id, domElement);
            }}
            onUnmount={(id) => {
              console.log(`TemplateElement unmounted: ${id}`);
              this._unregisterElementRef(id);
            }}
            renderElementControl={() => this._renderElementControl()}
          />
        );
      })
    );
  };

  _renderVatSummary = () => {
    var index = 0;

    if (this.props.properties.total.VatSummary && Object.keys(this.props.properties.total.VatSummary).length > 0) {
      var data = this.props.properties.total.VatSummary;
      const defaultFontColor = this.props.properties.prop.fontColor;
      const defaultFontSize = this.props.properties.prop.fontSize + "pt";

      const sectionFont = this.props.properties.total?.font || { fontFamily: 'Inter', fontSize: this.props.properties.prop.fontSize, color: this.props.properties.prop.fontColor };

      var dStyle = Object.assign({}, data.style);
      dStyle.width = 320
      dStyle.height = 100

      dStyle.fontFamily = data.style?.fontFamily || sectionFont.fontFamily || 'Inter';

      if (!dStyle.color) {
        dStyle.color = sectionFont.color || defaultFontColor;
      }

      if (!dStyle.fontSize) {
        dStyle.fontSize = sectionFont.fontSize ? sectionFont.fontSize + "pt" : defaultFontSize;
      }

      if (!dStyle.fontWeight) {
        dStyle.fontWeight = data.style?.fontWeight || 'normal';
      }
      if (!dStyle.fontStyle) {
        dStyle.fontStyle = data.style?.fontStyle || 'normal';
      }
      if (!dStyle.textDecoration) {
        dStyle.textDecoration = data.style?.textDecoration || 'none';
      }
      if (!dStyle.textAlign) {
        dStyle.textAlign = data.style?.textAlign || 'left';
      }
      const isList = dStyle.listStyleType && dStyle.listStyleType !== 'none';
      const textLines = data.text ? data.text.split('\n') : [''];

      index++;
      var id = sha256("vat-summary-ele-" + index);
      var isSelected = this.state.selectedElementName == data.id;
      var isGroupSelected = this._isGroupSelected(data.id);
      return (
        <div
          onClick={(e) => this._onVatSummaryClick(e)}
          key={data.id}
          style={dStyle}
          id={data.id}
          data-group-id={data.groupId}
          data-element={data.name}
          data-section="total"
          data-path="elements"
          data-index="VatSummary"
          className={
            "custom-element" + (isSelected ? " selected-element" : "") + (isGroupSelected ? " group-selected-element" : "")
          }
        >
          {isList ? (
            <ListLines
                lines={textLines}
                type={dStyle.listStyleType}
                spacing={getListSpacing(data)}
                textStyle={{
                    color: dStyle.color,
                    fontSize: dStyle.fontSize,
                    fontFamily: dStyle.fontFamily,
                    fontWeight: dStyle.fontWeight,
                    fontStyle: dStyle.fontStyle,
                    textDecoration: dStyle.textDecoration,
                    textAlign: dStyle.textAlign
                }}
            />
          ) : (
            data.text
          )}
          {isSelected ? this._renderElementControl() : <></>}
        </div>
      );
    }

  };

  _renderShapes = (section) => {
    var index = 0;
    return (
      this.props.properties && this.props.properties[section].shapes && Object.keys(this.props.properties[section].shapes).length > 0 &&
      Object.keys(this.props.properties[section].shapes).filter(s => s !== 'border').map((key) => {
        var data = this.props.properties[section].shapes[key];
        var font = this.props.properties[section]?.font || { fontFamily: 'Inter', fontSize: 10 }
        var sectionBorder = this.props.properties[section].shapes.border
        var bgColor = data.fillColor || sectionBorder.fillColor
        var isLine = data.name && data.name.startsWith('line');
        var dStyle;
        if (isLine) {
          dStyle = Object.assign({}, data.style, getLineShapeStyle(data, sectionBorder));
        } else {
          dStyle = Object.assign({ minWidth: '32px', minHeight: '16px' }, data.style, getShapeBorderStyle(data, sectionBorder));
          dStyle.background = `${bgColor}`
        }

        index++;
        var id = sha256(section + "-ele-" + index);
        var isSelected = this.state.selectedElementName == data.id;
        var isGroupSelected = this._isGroupSelected(data.id);
        return (
          <div
            onClick={(e) => this._onShapeClick(e)}
            key={data.id}
            style={Object.assign(dStyle, font)}
            id={data.id}
            data-group-id={data.groupId}
            data-element={data.name}
            data-section={section}
            data-path="shapes"
            data-index={data.name ? data.name.replace(/\./g, "") : ""}
            title={itemDisplayName("shapes", key, data) + (data.link ? ` · links to: ${data.link}` : "")}
            className={
              "custom-element" + (isSelected ? " selected-element" : "") + (isGroupSelected ? " group-selected-element" : "") + (data.link ? " has-link" : "")
            }
          >
            {/* Where the box's padding ends, while it's selected (editor only). */}
            {isSelected && !isLine && parseInt(data.padding, 10) > 0 && (
              <div
                className="shape-padding-guide"
                style={{ position: "absolute", inset: parseInt(data.padding, 10) + "px", border: "1px dashed rgba(0, 123, 255, 0.6)", pointerEvents: "none" }}
              />
            )}
            {isSelected ? this._renderElementControl() : <></>}
          </div>
        );
      })
    );
  };

  _renderQRCodes = (section) => {
    var qrCodes = this.props.properties?.[section]?.qrCodes;
    if (!qrCodes || Object.keys(qrCodes).length === 0) return null;

    return Object.keys(qrCodes).map((key) => {
      var data = qrCodes[key];
      var isSelected = this.state.selectedElementName == data.id;
      var isGroupSelected = this._isGroupSelected(data.id);
      var width = parseInt(data.style?.width, 10) || 80;
      var height = parseInt(data.style?.height, 10) || 80;
      var size = Math.max(1, Math.min(width, height));

      return (
        <div
          onClick={(e) => this._onElementClick(e)}
          key={data.id}
          style={{
            ...data.style,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#fff'
          }}
          id={data.id}
          data-group-id={data.groupId}
          data-element={data.name}
          data-section={section}
          data-path="qrCodes"
          data-index={data.name ? data.name.replace(/\./g, "") : ""}
          title={itemDisplayName("qrCodes", key, data)}
          className={
            "custom-element" + (isSelected ? " selected-element" : "") + (isGroupSelected ? " group-selected-element" : "")
          }
        >
          {data.qrMode === 'image' && data.qrImage ? (
            <img src={data.qrImage} alt="QR code" style={{ width: '100%', height: '100%', objectFit: 'contain', pointerEvents: 'none' }} />
          ) : data.qrMode === 'generate' && data.qrValue ? (
            <QRCodeSVG value={data.qrValue} size={size} style={{ width: '100%', height: '100%' }} />
          ) : (
            <div style={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: '1px dashed #999',
              color: '#999',
              fontSize: '9px',
              textAlign: 'center',
              padding: '4px'
            }}>
              {data.qrMode === 'image'
                ? 'Upload QR image'
                : data.qrMode === 'field'
                  ? (data.qrFieldName ? `Bound to: ${data.qrFieldName}` : 'Select a field to bind')
                  : 'Set QR content'}
            </div>
          )}
          {isSelected ? this._renderElementControl() : <></>}
        </div>
      );
    });
  };


  _renderUploadedImages = (section) => {
    var images = this.props.properties?.[section]?.images;
    if (!images || Object.keys(images).length === 0) return null;

    return Object.keys(images).map((key) => {
      var data = images[key];
      if (!data) return null;
      var isSelected = this.state.selectedElementName == data.id;
      var isGroupSelected = this._isGroupSelected(data.id);

      return (
        <div
          onClick={(e) => this._onElementClick(e)}
          key={data.id}
          style={{ ...data.style }}
          id={data.id}
          data-group-id={data.groupId}
          data-element={data.name}
          data-section={section}
          data-path="images"
          data-index={key}
          className={
            "custom-element" + (isSelected ? " selected-element" : "") + (isGroupSelected ? " group-selected-element" : "")
          }
        >
          <img
            src={data.src}
            alt={data.alt || data.name}
            draggable={false}
            style={{ width: '100%', height: '100%', objectFit: 'fill', display: 'block', pointerEvents: 'none' }}
          />
          {isSelected ? this._renderElementControl() : <></>}
        </div>
      );
    });
  };

  _renderImage = (section) => {
    if (this.props.properties.head && this.props.properties.head.logo && Object.keys(this.props.properties.head.logo).length > 0) {
      var index = 0;
      index++;
      //console.log(this.props.properties.head.logo);
      var id = sha256(section + "img-ele" + index);
      var isSelected = this.state.selectedElementName == id;
      var isGroupSelected = this._isGroupSelected(id);

      const logo = this.props.properties.head.logo;
      const logoSize = logo.logoSize || 100;
      const hasExplicitDimensions = logo.style?.width && logo.style?.height;

      const logoStyle = {
        ...logo.style,
        zIndex: 0,
        ...(!hasExplicitDimensions && { maxWidth: '100%' }),
      };

      const imgKey = hasExplicitDimensions
        ? `logo-img-${logo.style.width}-${logo.style.height}`
        : `logo-img-unset-${Date.now()}`;

      return logo.showLogo && logo.logo !== null ? (
        <div
          onClick={(e) => { this._onElementClick(e) }}
          style={logoStyle}
          key={logo.id}
          id={id}
          data-group-id={logo.groupId}
          data-element={logo.name}
          data-section={section}
          data-path="logo"
          data-index=""
          className={"custom-element" + (isSelected ? " selected-element" : "") + (isGroupSelected ? " group-selected-element" : "")}
        >
          <div style={{ width: '100%', height: '100%' }}>
            <img
              key={imgKey}
              src={this.state.tempLogo ? this.state.tempLogo : logo.logo}
              style={{
                width: hasExplicitDimensions ? "100%" : logoSize + "%",
                height: hasExplicitDimensions ? "100%" : "auto",
                objectFit: "fill",
                pointerEvents: "none",
                display: "block",
              }}
              onLoad={(e) => {
                const imgEl = e.target;
                const containerEl = imgEl.parentElement?.parentElement;

                if (containerEl && !logo.style?.width) {
                  const headerSection = containerEl.closest('.canves-header');

                  if (!headerSection) return;

                  const headerRect = headerSection.getBoundingClientRect();
                  const headerHeight = headerRect.height;
                  const headerWidth = headerRect.width;
                  const headerTop = headerRect.top;

                  const logoTopOffset = logo.style?.top
                    ? parseInt(logo.style.top)
                    : 16;

                  const logoLeftOffset = logo.style?.left
                    ? parseInt(logo.style.left)
                    : 16;

                  const naturalW = imgEl.naturalWidth;
                  const naturalH = imgEl.naturalHeight;
                  const aspectRatio = naturalW > 0 && naturalH > 0
                    ? naturalW / naturalH
                    : 1;

                  const availableHeight = headerHeight - logoTopOffset;
                  const availableWidth = headerWidth - logoLeftOffset;

                  let fittedWidth = availableWidth * (logoSize / 100);
                  let fittedHeight = fittedWidth / aspectRatio;

                  if (fittedHeight > availableHeight) {
                    fittedHeight = availableHeight;
                    fittedWidth = fittedHeight * aspectRatio;
                  }

                  fittedWidth = Math.min(fittedWidth, availableWidth);
                  fittedHeight = Math.min(fittedHeight, availableHeight);

                  this.props.updateHead({
                    ...this.props.properties.head,
                    logo: {
                      ...logo,
                      style: {
                        ...logo.style,
                        width: Math.round(fittedWidth) + "px",
                        height: Math.round(fittedHeight) + "px",
                      }
                    }
                  });
                }
              }}
            />
          </div>
          {isSelected ? this._renderElementControl() : <></>}
        </div>
      ) : (
        <></>
      );
    } else {
      return null;
    }
  };

  _renderCompanyElements = () => {
    if (this.props.properties.head && this.props.properties.head.companyProps && Object.keys(this.props.properties.head.companyProps).length > 0) {
      var index = 0;
      return Object.keys(this.props.properties?.head?.companyProps).map((key) => {
        var prop = this.props.properties.head.companyProps[key];

        if (!prop.show) return null;

        const defaultFontColor = this.props.properties.prop.fontColor;
        const defaultFontSize = this.props.properties.prop.fontSize + "pt";
        const sectionFont = this.props.properties.head?.font || {
          fontFamily: 'Inter',
          fontSize: this.props.properties.prop.fontSize,
          color: this.props.properties.prop.fontColor
        };

        var dStyle = Object.assign({}, prop.style);
        dStyle.fontFamily = prop.style?.fontFamily || sectionFont.fontFamily || 'Inter';
        if (!dStyle.color) {
          dStyle.color = sectionFont.color || defaultFontColor;
        }
        if (!dStyle.fontSize) {
          dStyle.fontSize = sectionFont.fontSize ? sectionFont.fontSize + "pt" : defaultFontSize;
        }
        if (!dStyle.fontWeight) {
          dStyle.fontWeight = prop.style?.fontWeight || 'normal';
        }
        if (!dStyle.fontStyle) {
          dStyle.fontStyle = prop.style?.fontStyle || 'normal';
        }
        if (!dStyle.textDecoration) {
          dStyle.textDecoration = prop.style?.textDecoration || 'none';
        }
        if (!dStyle.textAlign) {
          dStyle.textAlign = prop.style?.textAlign || 'left';
        }

        const isSelected = this.state.selectedElementName == prop.id;
        const isGroupSelected = this._isGroupSelected(prop.id);

        return (
          <TemplateElement
            key={prop.id}
            elementId={prop.id}
            element={{
              ...prop,
              section: "head",
              name: prop.name,
              text: prop.text,
              isCompanyProp: true,
              propKey: key
            }}
            style={dStyle}
            isSelected={isSelected}
            isGroupSelected={isGroupSelected}
            onClick={(e) => this._onElementClick(e)}
            onMount={(id, domElement) => this._registerElementRef(id, domElement)}
            onUnmount={(id) => this._unregisterElementRef(id)}
            renderElementControl={() => this._renderElementControl()}
            dataAttributes={{
              "data-section": "head",
              "data-path": "companyProps",
              "data-index": key,
              "data-element": prop.name,
              "data-is-company-prop": "true"
            }}
          />
        );
      });
    } else {
      return null;
    }
  };

  _renderDocumentTitle = () => {
    if (this.props.properties.head && this.props.properties.head.documentTitle && Object.keys(this.props.properties.head.documentTitle).length > 0) {
      var title = this.props.properties.head.documentTitle;

      // console.log("docTitle: ", title)

      if (!title.show) return null;

      const defaultFontColor = this.props.properties.prop.fontColor;
      var dStyle = Object.assign({}, title.style);
      if (!dStyle.color) {
        dStyle.color = defaultFontColor;
      }
      if (!dStyle.fontFamily && this.props.properties.head?.font?.fontFamily) {
        dStyle.fontFamily = this.props.properties.head.font.fontFamily;
      } else if (!dStyle.fontFamily) {
        dStyle.fontFamily = 'Inter';
      }
      if (!dStyle.fontSize) {
        dStyle.fontSize = "20pt";
      }
      if (!dStyle.fontWeight) {
        dStyle.fontWeight = title.style?.fontWeight || 'bold';
      }
      if (!dStyle.fontStyle) {
        dStyle.fontStyle = title.style?.fontStyle || 'normal';
      }
      if (!dStyle.textDecoration) {
        dStyle.textDecoration = title.style?.textDecoration || 'none';
      }
      if (!dStyle.textAlign) {
        dStyle.textAlign = title.style?.textAlign || 'center';
      }

      const isSelected = this.state.selectedElementName == title.id;
      const isGroupSelected = this._isGroupSelected(title.id);

      return (
        <TemplateElement
          key={title.id}
          elementId={title.id}
          element={{
            ...title,
            section: "head",
            name: title.name,
            text: title.title
          }}
          style={dStyle}
          isSelected={isSelected}
          isGroupSelected={isGroupSelected}
          onClick={(e) => this._onElementClick(e)}
          onMount={(id, domElement) => this._registerElementRef(id, domElement)}
          onUnmount={(id) => this._unregisterElementRef(id)}
          renderElementControl={() => this._renderElementControl()}
        />
      );
    } else {
      return null;
    }
  };

  _renderElementControl = () => {
    return (
      <div className="resize">
        <span
          className="top-left"
          onMouseDown={(e) => this._moveMouseDown(e)}
          onMouseUp={(e) => this._moveMouseUp(e)}
        ></span>

        <span
          className="bottom-right"
          onMouseDown={(e) => this._resizeMouseDown(e)}
          onMouseUp={(e) => this._resizeMouseUp(e)}
        ></span>
      </div>
    );
  };

  // `rowCount` sample rows; in bands mode the items band shows a few, with
  // the detail line under each when there is one, at the shared table sizes
  // (getTableMetrics) so the canvas matches the preview and the PDF.
  _renderBodyElements = (displayData, rowCount = 50, detailRow = null, { bandsMode = false } = {}) => {
    const itemRow = this.props.properties.items.layout.itemRow;
    const metrics = bandsMode ? getTableMetrics(this.props.properties.items.layout, detailRow) : null;
    const rowLine = itemRow.showHorizontalLines ? `${itemRow.horizontalLineSize}px solid ${itemRow.horizontalLineColor}` : 'none';
    return (
      <div style={{
        border: `1px solid ${this.props.properties.items.layout.tableBorder}`,
        borderRadius: `${getTableBorderRadius(this.props.properties.items.layout)}px`,
        overflow: "hidden"
      }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr style={{ height: metrics ? `${metrics.headerHeight}px` : "32px" }}>
              {displayData.map((obj, key) => {
                if (displayData[key]) {
                  return (
                    <td
                      width={obj.width ? (obj.width / (displayData.reduce((a, v) => { return (a + Number(v.width ? v.width : 10)) }, 0)) * 100 + "%") : 'auto'}
                      className={getUnderlineCellClass(resolveTableCellStyle(this.props.properties.items.layout, obj, "header"))}
                      style={{
                        padding: metrics ? "10px" : "5px 0px 5px 5px",
                        ...tableCellCss(resolveTableCellStyle(this.props.properties.items.layout, obj, "header")),
                        // Bands mode: one line, as the preview and the PDF draw it.
                        ...(metrics ? { whiteSpace: "nowrap", overflow: "hidden" } : {}),
                        // borderRight: this.props.properties.items.layout.itemRow.showVerticleLines ?
                        //   `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                        //   'none',
                        // borderLeft: key === 0 && this.props.properties.items.layout.itemRow.showVerticleLines ?
                        //   `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                        //   'none'
                      }}
                      key={`dd_${key}`}
                    >
                      {obj.header}
                    </td>
                  );
                }
                return null;
              })}
            </tr>
            {this.props.properties.items.layout.tableHeader.showBottomBorder && (
              <tr>
                <td colSpan={displayData.length} style={{ padding: 0 }}>
                  <div style={{
                    width: `${this.props.properties.items.layout.tableHeader.bottomBorderWidth ?? 100}%`,
                    height: `${this.props.properties.items.layout.tableHeader.bottomBorderSize ?? 1}px`,
                    backgroundColor: this.props.properties.items.layout.tableHeader.bottomBorderColor || '#333333ff'
                  }} />
                </td>
              </tr>
            )}
          </thead>
          <tbody>
            {[...Array(rowCount)].map((x, i) => (
              <React.Fragment key={`tr1k_${i}`}>
              <tr style={{
                // With a detail line, the row's line goes under the detail line.
                borderBottom: detailRow ? 'none' : rowLine,
                // The line under the row is inside the row's box (see the preview).
                ...(metrics ? { height: metrics.rowHeight + (detailRow ? 0 : metrics.rowLineSize) } : {})
              }}>
                {Object.keys(this.props.properties.items.items).map((key, j) => {
                  if (this.props.properties.items.items[key]) {
                    return (
                      <td
                        className={getUnderlineCellClass(resolveTableCellStyle(this.props.properties.items.layout, this.props.properties.items.items[key], "row"))}
                        style={{
                          // Bands mode: the PDF's padding (10px, or centring the line in a
                          // set row height), text at the top of the cell.
                          padding: metrics ? `${metrics.rowPaddingY}px 10px` : "10px 0px 10px 20px",
                          ...(metrics ? { verticalAlign: "top", lineHeight: BAND_TABLE_LINE_HEIGHT } : {}),
                          ...tableCellCss(resolveTableCellStyle(this.props.properties.items.layout, this.props.properties.items.items[key], "row")),
                          // The second sample row shows the price-change colours when they're on.
                          backgroundColor: getPriceNotifyColours(this.props.properties.prop, { IsPriceNotify: i === 1 })?.background ||
                            getRowCellBackground(this.props.properties.items.layout, this.props.properties.items.items[key], i),
                          ...(getPriceNotifyColours(this.props.properties.prop, { IsPriceNotify: i === 1 })?.color
                            ? { color: getPriceNotifyColours(this.props.properties.prop, { IsPriceNotify: i === 1 }).color }
                            : {}),
                          borderRight: this.props.properties.items.layout.itemRow.showVerticleLines ?
                            `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                            'none',
                          borderLeft: j === 0 && this.props.properties.items.layout.itemRow.showVerticleLines ?
                            `${this.props.properties.items.layout.itemRow.verticleLineSize}px solid ${this.props.properties.items.layout.itemRow.verticleLineColor}` :
                            'none'
                        }}
                        key={`td1k_${j}`}
                      >
                        {/* Row data only shows in the preview and the PDF. */}
                        -
                      </td>
                    );
                  }
                  return null;
                })}
              </tr>
              {detailRow && (
                <tr style={{ borderBottom: rowLine, ...(metrics ? { height: metrics.detailHeight + metrics.rowLineSize } : {}) }}>
                  <td colSpan={displayData.length} style={{ padding: "0 10px 4px 10px", verticalAlign: "top" }}>
                    <DetailRowLine detailRow={detailRow} valueOf={(field) => `{${field}}`} />
                  </td>
                </tr>
              )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  _handleSplitSize = (s) => {
    console.log("XXXXX==>>", s)
    this.props.updateSplitSizes(s.map(size => Number(size * 100)))
    this.setState({
      splitSizes: s
    })

  }

  _copyLayout = async () => {
    try {
      const payload = {
        __type: "witmeg-template-layout",
        version: 1,
        prop: this.props.properties.prop,
        head: this.props.properties.head,
        items: this.props.properties.items,
        total: this.props.properties.total,
        foot: this.props.properties.foot,
        heights: this.props.heights,
        // Bands mode: the band list, page frame and added bands' content.
        bands: this.props.properties.bands || [],
        pageFrame: this.props.properties.pageFrame || null,
        bandSections: Object.fromEntries((this.props.properties.bands || [])
          .filter((band) => band.section && !["head", "items", "total", "foot"].includes(band.section))
          .map((band) => [band.section, this.props.properties[band.section]])),
      };

      await navigator.clipboard.writeText(JSON.stringify(payload));
      this.setState({ successMessage: "Layout copied — paste it into another template to reuse it.", hasCopiedLayout: true });
    } catch (err) {
      console.error(err);
      this.setState({ errorMessage: "Could not copy the layout to the clipboard." });
    }
  };

  _isValidLayoutPayload = (payload) => (
    !!(payload && payload.__type === "witmeg-template-layout" &&
      payload.prop && payload.head && payload.items && payload.total && payload.foot)
  );

  // Silently probes the clipboard to keep the Paste button's enabled state
  // honest — the clipboard can hold a copied layout from an earlier session
  // (e.g. a different template opened in another tab), so this isn't just
  // local component state. Failures (permission denied, empty clipboard,
  // non-JSON content) are expected and simply leave Paste disabled.
  _checkClipboardForLayout = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const payload = JSON.parse(text);
      this.setState({ hasCopiedLayout: this._isValidLayoutPayload(payload) });
    } catch (err) {
      this.setState({ hasCopiedLayout: false });
    }
  };

  _openPasteConfirm = async () => {
    try {
      const text = await navigator.clipboard.readText();
      const payload = JSON.parse(text);

      if (!this._isValidLayoutPayload(payload)) {
        this.setState({ errorMessage: "Clipboard doesn't contain a copied template layout.", hasCopiedLayout: false });
        return;
      }

      this._pendingPasteLayout = payload;
      this.setState({ showPasteConfirm: true, hasCopiedLayout: true });
    } catch (err) {
      console.error(err);
      this.setState({ errorMessage: "Could not read the clipboard.", hasCopiedLayout: false });
    }
  };

  _cancelPasteLayout = () => {
    this._pendingPasteLayout = null;
    this.setState({ showPasteConfirm: false });
  };

  _confirmPasteLayout = () => {
    const pending = this._pendingPasteLayout;
    this._pendingPasteLayout = null;
    this.setState({ showPasteConfirm: false });

    if (!pending) return;
    // Collection notes have no prices: a layout copied from an invoice loses
    // its price fields, price columns and VAT summary.
    const payload = this.props.hidesPricing ? stripPricing(pending) : pending;

    // Keep this template's own name — only the design/layout is meant to transfer.
    const { templateName } = this.props.properties.prop;
    this._suppressReveal = true;
    this.props.updateProp({ ...payload.prop, templateName });
    this.props.updateHead(payload.head);
    this.props.updateItems(payload.items);
    this.props.updateTotal(payload.total);
    this.props.updateFoot(payload.foot);
    Object.entries(payload.bandSections || {}).forEach(([section, content]) => this.props.updateSection(section, content));
    this.props.updateBands(Array.isArray(payload.bands) ? payload.bands : []);
    this.props.updatePageFrame(payload.pageFrame || null);

    if (payload.heights) {
      const { head: h, body: b, total: t, foot: f } = payload.heights;
      this.props.setSectionHeight(h, b, t, f);

      const totalHeight = h + b + t + f;
      this.setState({
        splitSizes: [h / totalHeight, b / totalHeight, t / totalHeight, f / totalHeight],
      });
    }

    this.setState({ successMessage: "Layout pasted from clipboard.", isEdited: true });
  };

  // Gives every text element without a width the width it has on the canvas.
  // Without one the PDF has no box to align the merged value in, so a
  // right-aligned total starts at its left edge and the totals no longer
  // line up as they did around their (longer) {placeholders}. Elements not
  // on the canvas (hidden company fields) are left as they are.
  // The canvas width fits the {placeholder}, not the value, so these
  // elements are also kept to one line (they never wrapped before having a
  // width); "Wrap text" turns wrapping back on.
  // Lists without a spacing get the default one written in, so the PDF
  // spaces them as the canvas does.
  // Returns the updated properties and the sections that changed.
  _withCanvasTextWidths = (properties) => {
    const sections = this._isBandsMode() ? this._getBands().map((band) => band.section) : ["head", "total", "foot"];
    const next = { ...properties };
    const changed = [];
    sections.filter((section) => section !== "items" && properties[section]).forEach((section) => {
      let content = properties[section];
      ["elements", "companyProps"].forEach((path) => {
        Object.entries(content[path] || {}).forEach(([key, el]) => {
          if (!el) return;
          let updated = el;
          if (this._isListElement(el) && isNaN(parseFloat(el.listSpacing))) {
            updated = { ...updated, listSpacing: getListSpacing(el) };
          }
          const width = el.style?.width;
          const node = el.id && document.getElementById(el.id);
          const measured = (width === undefined || width === "" || width === "auto") && node
            ? parseFloat(window.getComputedStyle(node).width)
            : 0;
          if (measured > 0) {
            updated = { ...updated, style: { ...(updated.style || {}), width: Math.ceil(measured) + "px", whiteSpace: "pre" } };
          }
          if (updated !== el) content = { ...content, [path]: { ...content[path], [key]: updated } };
        });
      });
      if (content !== properties[section]) {
        next[section] = content;
        changed.push(section);
      }
    });
    return { properties: next, changed };
  };

  _saveTemplate = async (e) => {
    if (this.state.isSaving) return false;

    // Save widths into the template first: SaveTemplate sends the stored
    // template, and the HTML below is written from the same properties.
    const { properties, changed } = this._withCanvasTextWidths(this.props.properties);
    changed.forEach((section) => this._updateSection(section, properties[section]));

    // In bands mode the four strings below are the fallback for PDF services
    // without bands support, written from the equivalent four sections.
    const fallback = this._isBandsMode() ? toFallbackSections(properties) : null;
    const sectionProps = fallback ? { ...properties, ...fallback } : properties;
    const sectionHeights = fallback ? fallback.heights : this.props.heights;

    // Semi-transparent colours are saved as rgba() so PDF engines keep the
    // transparency (see convertHtmlAlphaColors).
    const htmlString = convertHtmlAlphaColors(renderToString(<HTMLTemplate properties={sectionProps} heights={sectionHeights} tempLogo={this.state.tempLogo} />));
    const htmlHeaderString = convertHtmlAlphaColors(renderToString(<HTMLHeaderTemplate properties={sectionProps} heights={sectionHeights} tempLogo={this.state.tempLogo} />));
    const htmlTotalString = convertHtmlAlphaColors(renderToString(<HTMLTotalTemplate properties={sectionProps} heights={sectionHeights} tempLogo={this.state.tempLogo} />));
    const htmlFooterString = convertHtmlAlphaColors(renderToString(<HTMLFooterTemplate properties={sectionProps} heights={sectionHeights} tempLogo={this.state.tempLogo} />));
    let encodedHTMLString = encodeURI(htmlString)
    let encodedHTMLHeaderString = encodeURI(htmlHeaderString)
    let encodedHTMLFooterString = encodeURI(htmlFooterString)
    let encodedHTMLTotalString = encodeURI(htmlTotalString)
    // Bands mode: one HTML string per band (spec §10). The four strings above
    // are still sent, as a fallback for PDF services without bands support.
    const encodedBands = this._isBandsMode()
      ? Object.fromEntries(Object.entries(renderBandsHtml(properties)).map(([id, html]) => [id, encodeURI(html)]))
      : null;
    console.log(htmlString);
    this.setState({ isSaving: true }, function () {
      SaveTemplate(encodedHTMLString, encodedHTMLHeaderString, encodedHTMLFooterString, encodedHTMLTotalString, encodedBands).then((response) => {
        this.setState({ isSaved: response.data.Status });
        if (response.data.Status) {

          this.setState(
            {
              isSaving: false,
              isEdited: false,
              successMessage:
                "The template is saved. Please keep editing the template or Click the close(x) button in the top right corner of the screen",
            },
            function () {
              const timer = setTimeout(() => {
                // this.props.callbackFromParents(e);
                //console.log("Redirecting...");
              }, 3000);
            }
          );
        } else {
          this.setState({
            errorMessage: response.data
              ? response.data.Result
              : response.message,
            isSaving: false,
          });
        }
        //console.log(response.data.Status);
      });
    });
  };

  _handleImageRemove = () => {
    this.props.removeHeaderImage()
    this.setState({
      tempLogo: null
    })
  }

  // ---- Sections (bands layout, docs/bands-spec.md) -------------------------------
  //
  // Users add sections, a page border, a detail line, wrapping, "grows with
  // its content" or "hide when empty" to any template. The first of these
  // quietly turns the template into the bands format (nothing moves on the
  // page); once none are left it quietly goes back to the four sections.

  _sectionLabel = (band) => {
    if (!band) return "";
    if (band.section === "head") return "Header";
    if (band.section === "items") return "Items";
    if (band.section === "total") return "Total";
    if (band.section === "foot") return "Footer";
    return band.name || "Section";
  };

  _isAddedSection = (section) => !["props", "head", "items", "total", "foot"].includes(section);

  // Runs `then` once the template is in the bands format, converting it first
  // if needed. `then` reads this.props when it runs, after the conversion.
  _ensureBands = (then) => {
    // A conversion already under way (props not updated yet): converting
    // again would move total/footer content twice, so just wait for it.
    if (this._convertingToBands) {
      if (then) setTimeout(then, 0);
      return;
    }
    if (this._isBandsMode()) {
      if (then) then();
      return;
    }
    this._convertingToBands = true;
    const result = convertToBands(this.props.properties);
    this.props.updateTotal(result.total);
    this.props.updateFoot(result.foot);
    this.props.updateBands(result.bands);
    this.props.updateProp(result.prop);
    this.setState({ isEdited: true });
    setTimeout(() => {
      this._convertingToBands = false;
      if (then) then();
    }, 0);
  };

  // Goes back to the four sections when nothing needs the bands format any more.
  _maybeRevertToSections = () => {
    setTimeout(() => {
      if (!this._isBandsMode() || this._convertingToBands) return;
      const result = convertToSections(this.props.properties);
      if (!result) return;
      const { head, body, total, foot } = result.heights;
      this.props.updateHead(result.head);
      this.props.updateTotal(result.total);
      this.props.updateFoot(result.foot);
      this.props.setSectionHeight(head, body, total, foot);
      this.props.updateBands([]);
      this.props.updatePageFrame(null);
      this.props.updateProp(result.prop);
      const sum = head + body + total + foot;
      this.setState((state) => ({
        splitSizes: [head / sum, body / sum, total / sum, foot / sum],
        selectedSection: this._isAddedSection(state.selectedSection) ? INVOICE_SECTIONS.PROPS : state.selectedSection,
      }));
    }, 0);
  };

  _setBands = (bands) => {
    this.props.updateBands(bands);
    this.setState({ isEdited: true });
  };

  _updateBand = (id, patch) => {
    this._setBands(this._getBands().map((band) => (band.id === id ? { ...band, ...patch } : band)));
  };

  _addSection = ({ name, after, rule, height }) => {
    this.setState({ showAddSection: false });
    this._ensureBands(() => {
      const bands = this._getBands();
      const band = { ...applySectionRule(createBand(SECTION_RULES[rule].type, bands), rule), name, height };
      const afterIndex = bands.findIndex((b) => b.id === after);
      const index = afterIndex >= 0 ? afterIndex + 1 : bands.length;
      this.props.updateSection(band.section, createBandSection());
      this._setBands([...bands.slice(0, index), band, ...bands.slice(index)]);
      this.setState({ selectedSection: band.section });
    });
  };

  _removeSection = (section) => {
    const band = this._getBands().find((b) => b.section === section);
    if (!band || !this._isAddedSection(section)) return;
    if (!window.confirm(`Remove the "${this._sectionLabel(band)}" section and everything in it?`)) return;
    this._setBands(this._getBands().filter((b) => b.section !== section));
    this.setState({ selectedSection: INVOICE_SECTIONS.PROPS });
    this._maybeRevertToSections();
  };

  _setSectionGrows = (section, grows) => {
    if (!grows) {
      const band = this._getBands().find((b) => b.section === section);
      if (band) this._updateBand(band.id, { canGrow: false });
      this._maybeRevertToSections();
      return;
    }
    this._ensureBands(() => {
      const band = this._getBands().find((b) => b.section === section);
      if (band) this._updateBand(band.id, { canGrow: true });
    });
  };

  _setPageFrame = (pageFrame) => {
    if (!pageFrame) {
      this.props.updatePageFrame(null);
      this._maybeRevertToSections();
      return;
    }
    this._ensureBands(() => this.props.updatePageFrame(pageFrame));
    this.setState({ isEdited: true });
  };

  _setDetailRow = (detailRow) => {
    const apply = () => {
      const items = this._getBands().find((b) => b.type === BAND_TYPES.ITEMS);
      if (items) this._updateBand(items.id, { detailRow });
    };
    if (detailRow) this._ensureBands(apply);
    else {
      apply();
      this._maybeRevertToSections();
    }
  };

  // Follow the element on the left or right (docs/bands-spec.md §5.2a). An
  // element follows one side at most, so turning one on turns the other off.
  _setFollowSide = (side, on) => {
    const field = "follow" + side;
    const other = side === "Left" ? "followRight" : "followLeft";
    if (on) {
      this._ensureBands(() => this._applyToSelection(
        (ref) => ref.path === "elements" || ref.path === "companyProps",
        (el) => {
          const next = { ...el, [field]: true };
          delete next[other];
          return next;
        }
      ));
    } else {
      this._setBandsElementFlag(field, false);
    }
  };

  // Item row height in px; empty or 0 is automatic. Like column wrapping it
  // needs the bands format (docs/bands-spec.md §6.3).
  _setRowHeight = (value) => {
    const height = getSetRowHeight({ rowHeight: value });
    const apply = () => {
      const items = this.props.properties.items;
      const itemRow = { ...items.layout.itemRow };
      if (height) itemRow.rowHeight = height;
      else delete itemRow.rowHeight;
      this.props.updateItems({ ...items, layout: { ...items.layout, itemRow } });
      this.setState({ isEdited: true });
    };
    if (height) this._ensureBands(apply);
    else {
      apply();
      this._maybeRevertToSections();
    }
  };

  _setColumnWrap = (key, wrap) => {
    const apply = () => {
      const items = this.props.properties.items;
      const column = items.items[key];
      if (!column) return;
      const next = { ...column };
      if (wrap) next.wrap = true;
      else delete next.wrap;
      this.props.updateItems({ ...items, items: { ...items.items, [key]: next } });
      this.setState({ isEdited: true });
    };
    if (wrap) this._ensureBands(apply);
    else {
      apply();
      this._maybeRevertToSections();
    }
  };

  // "Hide when empty" / "Stretch with content" on the selected elements.
  _setBandsElementFlag = (field, on) => {
    if (on) this._ensureBands(() => this._setSelectedElementField(field, true));
    else {
      this._setSelectedElementField(field, undefined);
      this._maybeRevertToSections();
    }
  };

  // Top of a section's tab; null when sections can't be added here.
  _renderSectionSettings = (section) => {
    if (!this._isBandsMode()) {
      return BANDS_ENABLED ? <SectionSettings band={null} onGrowsChange={(grows) => this._setSectionGrows(section, grows)} /> : null;
    }
    const bands = this._getBands();
    const index = bands.findIndex((b) => b.section === section);
    if (index < 0) return null;
    const band = bands[index];
    return (
      <SectionSettings
        band={band}
        region={getSectionRegion(bands, index)}
        isCustom={this._isAddedSection(section)}
        canMoveUp={index > 0}
        canMoveDown={index < bands.length - 1}
        onChange={(patch) => this._updateBand(band.id, patch)}
        onRuleChange={(rule) => this._setBands(this._getBands().map((b) => (b.id === band.id ? applySectionRule(b, rule) : b)))}
        onGrowsChange={(grows) => this._setSectionGrows(section, grows)}
        onMove={(delta) => this._setBands(moveBand(this._getBands(), band.id, delta))}
        onRemove={() => this._removeSection(section)}
      />
    );
  };

  // Detail line settings at the top of the Items tab.
  _renderItemsSettings = () => {
    if (!this._isBandsMode() && !BANDS_ENABLED) return null;
    const items = this._isBandsMode() ? this._getBands().find((b) => b.type === BAND_TYPES.ITEMS) : null;
    return (
      <div className="section-settings border-bottom pb-3 mb-3">
        <DetailRowSettings detailRow={items?.detailRow} itemFields={this._getItemFields()} onChange={this._setDetailRow} />
      </div>
    );
  };

  // Drag a band's bottom edge to change its height.
  _bandResizeStart = (e, bandId) => {
    e.preventDefault();
    e.stopPropagation();
    const band = this._getBands().find((b) => b.id === bandId);
    if (!band) return;
    const startY = e.clientY;
    const startHeight = band.height;
    const maxHeight = getPageLayout(this.props.properties).content.height;

    const onMove = (ev) => {
      const height = Math.min(maxHeight, Math.max(10, Math.round(startHeight + ev.clientY - startY)));
      this.props.updateBands(this._getBands().map((b) => (b.id === bandId ? { ...b, height } : b)));
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      this.setState({ isEdited: true });
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  _renderPageFrame = ({ frame, pageFrame }) => (
    <div
      className="page-frame"
      style={{
        position: "absolute",
        top: frame.top,
        left: frame.left,
        width: frame.width,
        height: frame.height,
        right: "auto",
        bottom: "auto",
        pointerEvents: "none",
        boxSizing: "border-box",
        // Per side, like a shape's border (borderSides overrides).
        ...getShapeBorderStyle(pageFrame, null),
        borderRadius: pageFrame.borderRadius,
        zIndex: 0,
      }}
    />
  );

  // The page in bands mode: frame, page number and the sections top to bottom
  // inside the content area. Each edits like the usual sections; the one whose
  // tab is open is outlined.
  _renderBandsCanvas = () => {
    const { properties } = this.props;
    const layout = getPageLayout(properties);
    const { content } = layout;
    const bands = this._getBands();
    const columns = Object.keys(properties.items.items).map((k) => properties.items.items[k]).filter((d) => d && d.width !== undefined);
    const pageNumber = getPageNumberSettings(properties.prop);

    const describe = (band, index) => {
      const rule = SECTION_RULES[getSectionRule(band, getSectionRegion(bands, index))];
      return `${this._sectionLabel(band)} · ${rule ? rule.label.toLowerCase() : ""}${band.canGrow ? " · grows" : ""}`;
    };

    return (
      <>
        {layout.pageFrame && this._renderPageFrame(layout)}

        {pageNumber.show && (
          <div
            className="page-number-marker"
            role="button"
            tabIndex={0}
            title="Page number (printed on every page). Click to change it in Properties."
            style={{ ...getBandsPageNumberStyle(properties.prop, properties.foot?.font, content, layout.page), zIndex: 2 }}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={this._openPageNumberSettings}
          >
            {formatPageNumber(pageNumber.format, 1, "N")}
          </div>
        )}

        <div
          className="content-container bands-canvas"
          style={{ position: "absolute", top: content.top, left: content.left, width: content.width, right: "auto", bottom: "auto", zIndex: 1 }}
        >
          <div id="templateContainer">
            {bands.map((band, index) => {
              const isActive = band.section === this.state.selectedSection;

              if (band.type === BAND_TYPES.ITEMS) {
                return (
                  <div
                    key={band.id}
                    className={"content canves-body canves-band" + (isActive ? " is-active-band" : "")}
                    data-band-id={band.id}
                    style={{ position: "relative" }}
                  >
                    <div className="canves-content-children" style={{ position: "relative" }}>
                      {this._renderBodyElements(columns, BANDS_CANVAS_ROWS, band.detailRow, { bandsMode: true })}
                    </div>
                    <span className="info">Items · continue across pages</span>
                  </div>
                );
              }

              const section = band.section;
              const sectionContent = properties[section];
              if (!sectionContent) return null;
              return (
                <div
                  key={band.id}
                  className={"content canves-band" + (section === "head" ? " canves-header" : "") + (isActive ? " is-active-band" : "")}
                  data-canvas-section={section}
                  data-band-id={band.id}
                  style={{
                    position: "relative",
                    height: band.height,
                    lineHeight: BAND_LINE_HEIGHT,
                    backgroundColor: sectionContent.background?.showColor ? sectionContent.background.color : "transparent",
                  }}
                >
                  <div className="canves-content-children" style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}>
                    <div>
                      {this._renderColumnGuides(section)}
                      {this._renderShapes(section)}
                      {this._renderQRCodes(section)}
                      {this._renderUploadedImages(section)}
                      {section === "head" && this._renderCompanyElements()}
                      {this._renderElements(section)}
                      {section === "head" && this._renderImage("head")}
                      {section === "head" && this._renderDocumentTitle()}
                      {section === "total" && this._renderVatSummary()}
                    </div>
                  </div>
                  <span className="info">{describe(band, index)}</span>
                  <span
                    className="slider band-slider"
                    title="Drag to change the section's height"
                    onMouseDown={(e) => this._bandResizeStart(e, band.id)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </>
    );
  };

  // Fields an item row has, for the detail line's field list.
  _getItemFields = () => {
    const definition = this.props.properties.items?.defenition;
    const properties = definition && this.state.attributes?.[definition]?.Properties;
    const fields = new Set(Object.keys(properties || {}));
    Object.keys(this.props.properties.items?.items || {}).forEach((key) => fields.add(key));
    return [...fields].filter((field) => field !== "CustomArray").sort();
  };

  // A "current date & time" element (spec §8.3): the PDF fills it with the
  // date and time it is printed, formatted with `format.pattern` in
  // `timeZone` (the designer's, so it prints as they see it here).
  _addDateTime = (section, pattern) => {
    const content = this.props.properties[section];
    if (!content) return;
    const elements = content.elements || {};
    let name = CURRENT_DATE_TIME_PATH;
    for (let n = 2; elements[name.replace(/\./g, "")]; n++) name = `${CURRENT_DATE_TIME_PATH}-${n}`;

    const element = {
      name,
      text: `{${CURRENT_DATE_TIME_FIELD}}`,
      data: CURRENT_DATE_TIME_FIELD,
      id: sha256(`${section}-${name}-${Date.now()}`),
      format: { type: "date", pattern },
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      style: { position: "absolute", top: "8px", left: "8px", zIndex: 1, whiteSpace: "nowrap" },
    };
    // The new-element logic then moves it to a free spot and selects it.
    this._updateSection(section, { ...content, elements: { ...elements, [name.replace(/\./g, "")]: element } });
    this.setState({ isEdited: true });
  };

  _renderDateTimeTool = (section) => (
    BANDS_ENABLED || this._isBandsMode() ? <DateTimeTool onAdd={(pattern) => this._addDateTime(section, pattern)} /> : null
  );

  // ---- Column totals (bands spec §8.6) ----

  // Items-table columns a total can be added for: number, currency and
  // percentage columns, plus the quantity columns and any the item list's
  // definition types as a number.
  _getTotalableColumns = () => {
    const items = this.props.properties.items || {};
    const types = this.state.attributes?.[items.defenition]?.Properties || {};
    return Object.keys(items.items || {})
      .filter((key) => {
        const column = items.items[key];
        if (!column) return false;
        return isNumericColumnFormat(getColumnFormat(column)) ||
          QUANTITY_COLUMNS.includes(key) ||
          /int|float|double|decimal|number|numeric|currency|money/i.test(String(types[key] || ""));
      })
      .map((key) => ({ key, header: items.items[key].header }));
  };

  // Totals go after the table: the Total and Footer sections, and in bands
  // mode any section below the items band.
  _canSectionHaveTotals = (section) => {
    if (!this._isBandsMode()) return section === "total" || section === "foot";
    const bands = this._getBands();
    const itemsIndex = bands.findIndex((band) => band.type === BAND_TYPES.ITEMS);
    const index = bands.findIndex((band) => band.section === section);
    return index > itemsIndex && itemsIndex >= 0;
  };

  // Adds a totals element for `columnKey`. Quantity columns are split by unit
  // type; the label is "Total <header>: " for unsplit totals and nothing for
  // split ones. The column's number format comes along.
  _addColumnTotal = (section, columnKey) => {
    const content = this.props.properties[section];
    const items = this.props.properties.items || {};
    const column = items.items?.[columnKey];
    if (!content || !column) return;
    const elements = content.elements || {};
    const base = `${COLUMN_TOTAL_PATH}-${String(columnKey).replace(/[^\w-]+/g, "_")}`;
    let name = base;
    for (let n = 2; elements[name.replace(/\./g, "")]; n++) name = `${base}-${n}`;

    const splitByUnit = QUANTITY_COLUMNS.includes(columnKey);
    const format = getColumnFormat(column);
    const element = {
      name,
      text: splitByUnit ? `{${COLUMN_TOTAL_FIELD}}` : `Total ${column.header || columnKey}: {${COLUMN_TOTAL_FIELD}}`,
      data: COLUMN_TOTAL_FIELD,
      id: sha256(`${section}-${name}-${Date.now()}`),
      columnTotal: {
        column: columnKey,
        splitByUnit,
        unitField: UNIT_TYPE_FIELDS[items.defenition] || UNIT_TYPE_FIELDS.EposSalesFieldsDefintion,
        unitLayout: UNIT_LAYOUTS.UNIT_FIRST,
        separator: ", ",
      },
      ...(isNumericColumnFormat(format) ? { format: { ...format } } : {}),
      style: { position: "absolute", top: "8px", left: "8px", zIndex: 1, whiteSpace: "nowrap" },
    };
    // The new-element logic then moves it to a free spot and selects it.
    this._updateSection(section, { ...content, elements: { ...elements, [name.replace(/\./g, "")]: element } });
    this.setState({ isEdited: true });
  };

  _updateSelectedColumnTotal = (patch) => {
    this._applyToSelection(
      (ref) => ref.path === "elements" && this._getElementDataByRef(ref)?.data === COLUMN_TOTAL_FIELD,
      (el) => ({ ...el, columnTotal: { ...el.columnTotal, ...patch } })
    );
  };

  // Tools at the top of a section's panel.
  _renderSectionTools = (section) => (
    <>
      {this._renderDateTimeTool(section)}
      {this._canSectionHaveTotals(section) && (
        <ColumnTotalTool columns={this._getTotalableColumns()} onAdd={(key) => this._addColumnTotal(section, key)} />
      )}
      <CalculationTool
        selectedCount={this._getCalculationStartRefs(section).length}
        onAdd={() => this._addCalculation(section)}
      />
    </>
  );

  // ---- Calculations (docs/bands-spec.md §8.3b) ----

  // Selected values in `section` a new calculation starts with.
  _getCalculationStartRefs = (section) => this._getSelectionRefs()
    .filter((ref) => ref.section === section && ref.path === "elements" && this._calculationLabel(this._getElementDataByRef(ref)) !== null);

  // What an element is called in a calculation; null for elements that
  // can't be one of its values (the current date and time).
  _calculationLabel = (data) => {
    if (!data || data.data === CURRENT_DATE_TIME_FIELD) return null;
    if (data.data === CALCULATION_FIELD) return calculationName(data);
    if (data.data === COLUMN_TOTAL_FIELD) {
      const column = this.props.properties.items?.items?.[data.columnTotal?.column];
      return "Total of " + (column?.header || data.columnTotal?.column || "a column");
    }
    if (this._isCustomTextElement(data)) {
      const line = String(data.text || "").split("\n")[0].trim();
      return `"${line.length > 24 ? line.slice(0, 23) + "…" : line}"`;
    }
    return this._fieldWords(data.data || String(data.name || "").split(".").pop());
  };

  // The values a calculation in `section` can use: its section's elements
  // with a number in them (custom text without one is left out), not itself.
  _calculationOptions = (section, selfId) => Object.values(this.props.properties[section]?.elements || {})
    .filter((el) => el && el.id !== selfId && this._calculationLabel(el) !== null &&
      !(this._isCustomTextElement(el) && readNumber(el.text) === null))
    .map((el) => ({ id: el.id, label: this._calculationLabel(el) }));

  _calculationLabelOf = (section) => (id) => {
    const el = Object.values(this.props.properties[section]?.elements || {}).find((e) => e && e.id === id);
    return el ? this._calculationLabel(el) : "(removed)";
  };

  _describeCalculation = (element, section) => {
    const terms = element?.calculation?.terms || [];
    return terms.length ? describeTerms(terms, this._calculationLabelOf(section)) : "";
  };

  _addCalculation = (section) => {
    const content = this.props.properties[section];
    if (!content) return;
    const elements = content.elements || {};
    let name = CALCULATION_PATH;
    for (let n = 2; elements[name.replace(/\./g, "")]; n++) name = `${CALCULATION_PATH}-${n}`;
    const terms = this._getCalculationStartRefs(section).map((ref) => ({ op: CALCULATION_OPS.ADD, element: ref.id }));
    const element = {
      name,
      text: `{${CALCULATION_FIELD}}`,
      data: CALCULATION_FIELD,
      id: sha256(`${section}-${name}-${Date.now()}`),
      calculation: { terms },
      format: { ...TEXT_FORMAT_PRESETS.number2.format },
      style: { position: "absolute", top: "8px", left: "8px", zIndex: 1, whiteSpace: "nowrap" },
    };
    // The new-element logic then moves it to a free spot and selects it.
    this._updateSection(section, { ...content, elements: { ...elements, [name.replace(/\./g, "")]: element } });
    this.setState({ isEdited: true });
  };

  _setPrimaryCalculationTerms = (terms) => {
    const ref = this._getPrimaryRef();
    if (!ref || this._getElementDataByRef(ref)?.data !== CALCULATION_FIELD) return;
    this._updateRefs([ref], (el) => ({ ...el, calculation: { ...(el.calculation || {}), terms } }));
    this.setState({ isEdited: true });
  };

  _renderCalculationSection = () => {
    if (this._isMultiSelection()) return null;
    const ref = this._getPrimaryRef();
    const data = ref && this._getElementDataByRef(ref);
    if (!data || data.data !== CALCULATION_FIELD) return null;
    const labelOf = this._calculationLabelOf(ref.section);
    return (
      <div className="properties-panel-section">
        <div className="properties-panel-section-title">Calculation</div>
        <CalculationEditor
          terms={data.calculation?.terms}
          options={this._calculationOptions(ref.section, data.id)}
          labelOf={labelOf}
          onChange={this._setPrimaryCalculationTerms}
        />
        <div className="text-muted small mt-2">
          Values with nothing in them count as 0. Use Format above for decimals or a currency.
        </div>
      </div>
    );
  };

  // Props every section's content panel gets: its settings and tools, and in
  // bands mode the band's size for placing new elements.
  _getSectionPanelProps = (section) => {
    if (!this._isBandsMode()) return { sectionSettings: this._renderSectionSettings(section), extraTools: this._renderSectionTools(section) };
    const band = this._getBands().find((b) => b.section === section);
    const layout = getPageLayout(this.props.properties);
    return {
      bandsMode: true,
      bandBounds: band ? { width: layout.content.width, height: band.height || 100 } : null,
      sectionSettings: this._renderSectionSettings(section),
      extraTools: this._renderSectionTools(section),
    };
  };

  // Tab of a section added by the user.
  _renderAddedSectionTab = (section) => (
    this.state.attributes ? (
      <BandContentPanel
        key={section}
        {...this.props}
        {...this._getSectionPanelProps(section)}
        sectionKey={section}
        panelTitle={this._sectionLabel(this._getBands().find((b) => b.section === section))}
        attributes={this.state.attributes}
        pageProp={this.props.properties.prop}
        // The editor's own callbackFromParents closes the editor; the panel
        // calls this on mount to report its content.
        callbackFromParents={(obj) => this._changeProprtyProp(section, obj)}
        showToolTips={(obj) => this._showToolTips(obj)}
        onElementSelected={this._selectElementFromChild}
        manuallyPositionedElements={this.state.manuallyPositionedElements}
        onElementMoved={(elementId) => {
          const newSet = new Set(this.state.manuallyPositionedElements);
          newSet.add(elementId);
          this.setState({ manuallyPositionedElements: newSet });
        }}
      />
    ) : null
  );

  renderMenu() {
    const arr = this.state.selectedSection.toString().toLowerCase();
    // Properties, then one tab per section in page order (with added
    // sections in bands mode), then "Add section".
    const bands = this._isBandsMode() ? this._getBands() : null;
    const tabs = bands
      ? [INVOICE_SECTIONS.PROPS, ...bands.map((band) => band.section)]
      : Object.values(INVOICE_SECTIONS);
    const labelOf = (section) => {
      const band = bands && bands.find((b) => b.section === section);
      return band && this._isAddedSection(section) ? this._sectionLabel(band) : section;
    };
    var elements = tabs.map((e, k) => {
      e = e.toString();
      return (
        <li
          key={`li1key_${k}`}
          className="nav-item"
          onClick={() => this._setSelectedSection(e)}
        >
          <a className={"nav-link" + (arr === e ? " active" : "")}>
            {(() => {
              switch (e) {
                case INVOICE_SECTIONS.PROPS:
                  return <FontAwesomeIcon icon="border-all" />;

                case INVOICE_SECTIONS.HEAD:
                  return <FontAwesomeIcon icon="angle-up" />;

                case INVOICE_SECTIONS.ITEMS:
                  return <FontAwesomeIcon icon="align-justify" />;

                case INVOICE_SECTIONS.TOTAL:
                  return <FontAwesomeIcon icon="file-alt" />;

                case INVOICE_SECTIONS.FOOT:
                  return <FontAwesomeIcon icon="angle-down" />;

                default:
                  return <FontAwesomeIcon icon="layer-group" />;
              }
            })()}
            <span className="nav-label" title={labelOf(e)}>{labelOf(e)}</span>
          </a>
        </li>
      );
    });

    if (BANDS_ENABLED) {
      elements.push(
        <li key="li1key_add" className="nav-item" onClick={() => this.setState({ showAddSection: true })}>
          <a className="nav-link" title="Add a section to the page">
            <FontAwesomeIcon icon="plus" />
            <span>Add section</span>
          </a>
        </li>
      );
    }

    return elements;
  }

  _renderAddSectionDialog = () => {
    const bands = this._getBands();
    return (
      <AddSectionDialog
        show={!!this.state.showAddSection}
        sections={bands.map((band) => ({ id: band.id, type: band.type, label: this._sectionLabel(band) }))}
        onAdd={this._addSection}
        onHide={() => this.setState({ showAddSection: false })}
      />
    );
  };

  _getButtonActiveState = (buttonObj) => {
    const { activeStyles } = this.state;

    if (buttonObj.property === "fontWeight" && buttonObj.value === "bold") {
      return activeStyles.bold;
    }
    if (buttonObj.property === "fontStyle" && buttonObj.value === "italic") {
      return activeStyles.italic;
    }
    if (buttonObj.property === "textDecoration") {
      if (buttonObj.value === "underline") return activeStyles.underline;
      if (buttonObj.value === "line-through") return activeStyles.strikethrough;
    }
    if (buttonObj.property === "textTransform") {
      if (buttonObj.value === "capitalize") return activeStyles.capitalize;
      if (buttonObj.value === "uppercase") return activeStyles.uppercase;
    }
    if (buttonObj.property === "textAlign") {
      if (buttonObj.value === "left") return activeStyles.alignStart;
      if (buttonObj.value === "center") return activeStyles.alignCenter;
      if (buttonObj.value === "right") return activeStyles.alignEnd;
    }
    if (buttonObj.property === "listStyleType") {
      if (buttonObj.value === "disc") return activeStyles.listBullet;
      if (buttonObj.value === "decimal") return activeStyles.listNumbered;
    }
    if (buttonObj.isHeading) {
      const element = this.props.selectedElement.element;
      if (!element || !element.style) return false;

      const headingStyles = {
        h1: { fontWeight: "bold", fontSize: "24pt" },
        h2: { fontWeight: "bold", fontSize: "20pt" },
        h3: { fontWeight: "bold", fontSize: "16pt" }
      };

      const headingStyle = headingStyles[buttonObj.value];
      if (!headingStyle) return false;

      return element.style.fontSize === headingStyle.fontSize &&
        element.style.fontWeight === headingStyle.fontWeight;
    }
    return false;
  };

  render() {
    return (
      <>
        <div
          className="fullscreen-bg"
          onMouseUp={(e) => {
            // Ends a move or resize. Only then: Firefox sends a mouseup from
            // a dropdown's list when an option is picked, before its change
            // event, and re-rendering at that moment puts the old value back.
            this._resizeRaw = undefined;
            this._setSnapIndicators([]);
            if (!this.state.selectedElementResizeOn && !this.state.selectedElementMoveOn) return;
            this.setState({
              selectedElementResizeOn: false,
              selectedElementMoveOn: false
            })
          }}
          onMouseMove={(e) => this._moveMouseMove(e)}
        >
          <div className="column nav-column bg-primary">
            <ul className="nav navbar-nav flex-column">{this.renderMenu()}</ul>
          </div>
          <div
            className="column nav-options-column"
            onMouseOver={(e) => this._onLeftPanelHover(e, true)}
            onMouseOut={(e) => this._onLeftPanelHover(e, false)}
          >
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.PROPS
                  ? ""
                  : "d-none"
              }
            >
              <Properties
                {...this.props}
                layoutSettings={(BANDS_ENABLED || this._isBandsMode()) && (
                  <PageBorderSettings pageFrame={this.props.properties.pageFrame} onChange={this._setPageFrame} />
                )}
                callbackFromParents={(obj) => {
                  this._changeProprtyProp("prop", obj);
                }}
                showToolTips={(obj) => {
                  this._showToolTips(obj);
                }}
              />
            </div>
            {this._isAddedSection(this.state.selectedSection) && this.props.properties[this.state.selectedSection] && (
              <div>{this._renderAddedSectionTab(this.state.selectedSection)}</div>
            )}
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.HEAD
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Head
                  {...this.props}
                  {...this._getSectionPanelProps("head")}
                  attributes={this.state.attributes}
                  properties={this.props.properties.head}
                  pageProp={this.props.properties.prop}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("head", obj);
                  }}
                  showToolTips={(obj) => {
                    this._showToolTips(obj);
                  }}
                  onElementSelected={this._selectElementFromChild}
                  handleImageRemove={this._handleImageRemove}
                  updateTempLogo={(tempimg) => this.setState({ tempLogo: tempimg })}
                  manuallyPositionedElements={this.state.manuallyPositionedElements}
                  onAutoReorganize={() => {
                    this._autoReorganizeElements();
                  }}
                  onElementMoved={(elementId) => {
                    const newSet = new Set(this.state.manuallyPositionedElements);
                    newSet.add(elementId);
                    this.setState({ manuallyPositionedElements: newSet });
                  }}
                />
              )}
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.ITEMS
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Items
                  {...this.props}
                  sectionSettings={this._renderItemsSettings()}
                  onWrapChange={BANDS_ENABLED || this._isBandsMode() ? this._setColumnWrap : undefined}
                  onRowHeightChange={BANDS_ENABLED || this._isBandsMode() ? this._setRowHeight : undefined}
                  attributes={this.state.attributes}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("items", obj);
                  }}
                  showToolTips={(obj) => {
                    this._showToolTips(obj);
                  }}
                />
              )}
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.TOTAL
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Total
                  {...this.props}
                  {...this._getSectionPanelProps("total")}
                  onElementSelected={this._selectElementFromChild}
                  attributes={this.state.attributes}
                  pageProp={this.props.properties.prop}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("total", obj);
                  }}
                  manuallyPositionedElements={this.state.manuallyPositionedElements}
                  onAutoReorganize={() => {
                    this._autoReorganizeTotalElements();
                  }}
                  onElementMoved={(elementId) => {
                    const newSet = new Set(this.state.manuallyPositionedElements);
                    newSet.add(elementId);
                    this.setState({ manuallyPositionedElements: newSet });
                  }}
                />
              )}
            </div>
            <div
              className={
                this.state.selectedSection == INVOICE_SECTIONS.FOOT
                  ? ""
                  : "d-none"
              }
            >
              {this.state.attributes && (
                <Foot
                  {...this.props}
                  {...this._getSectionPanelProps("foot")}
                  attributes={this.state.attributes}
                  pageProp={this.props.properties.prop}
                  callbackFromParents={(obj) => {
                    this._changeProprtyProp("foot", obj);
                  }}
                  showToolTips={(obj) => {
                    this._showToolTips(obj);
                  }}
                  onElementSelected={this._selectElementFromChild}
                  manuallyPositionedElements={this.state.manuallyPositionedElements}
                  onAutoReorganize={() => {
                    this._autoReorganizeFootElements();
                  }}
                  onElementMoved={(elementId) => {
                    const newSet = new Set(this.state.manuallyPositionedElements);
                    newSet.add(elementId);
                    this.setState({ manuallyPositionedElements: newSet });
                  }}
                />
              )}
            </div>
          </div>
          <div className={"column nav-editor border-0 " + (this.state.propertiesPanelCollapsed ? "properties-collapsed" : "properties-open")}>
            <div className="new-template">
              <div className="browser">
                <div className="browser_wrapper">
                  <div className="address-bar border-bottom d-flex">
                    <div className="address-bar_dots mr-auto">
                      <span className="dot-1"></span>
                      <span className="dot-2"></span>
                      <span className="dot-3"></span>
                    </div>
                    <div className="ms-auto d-flex align-items-center">
                      <Form className="me-auto">
                        <ul className="address-bar_menu">
                          <li key="chkshowPageGridLines">
                            <Form.Group controlId="chkshowPageGridLines">
                              <Form.Check
                                onChange={(e) => {
                                  this.setState({
                                    showPageGridLines: e.target.checked,
                                  });
                                }}
                                checked={this.state.showPageGridLines}
                                label="Show page grid-lines"
                              />
                            </Form.Group>
                          </li>
                          <li key="chkshowGridLines">
                            <Form.Group controlId="">
                              <Form.Check
                                onChange={(e) => {
                                  this.setState({
                                    showGridLines: e.target.checked,
                                  });
                                }}
                                checked={this.state.showGridLines}
                                name={"showGridLines"}
                                label="Show grid-lines"
                              />
                            </Form.Group>
                          </li>
                          <li key="chkshowPointer">
                            <Form.Group controlId="chkshowPointer">
                              <Form.Check
                                onChange={(e) => {
                                  this.setState({
                                    showPointer: e.target.checked,
                                  });
                                }}
                                checked={this.state.showPointer}
                                label="Show pointer"
                              />
                            </Form.Group>
                          </li>
                        </ul>
                      </Form>
                      <a
                        className="ms-auto p-3"
                        onClick={(e) => this._closeWindow(e)}
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon icon="times" />
                      </a>
                    </div>
                  </div>
                  <div
                    className="canves-wrapper"
                    onMouseMove={(e) => this._slideMouseMove(e)}
                    onMouseDownCapture={this._rememberCanvasSection}
                    ref={(ref) => (this.canvesWrapper = ref)}
                  >
                    <div
                      className="canves"
                      style={this.props.properties.prop.orientation === "portrait" ? { width: '210mm', height: '297mm' } : { width: '297mm', height: '210mm' }}
                      ref={(ref) => (this.canves = ref)}
                    ></div>
                    <Ruler
                      width={this.state.wrapper.width}
                      height={this.state.wrapper.height}
                      showPageGridLines={this.state.showPageGridLines}
                      showGridLines={this.state.showGridLines}
                      showPointer={this.state.showPointer}
                      setMeasureSpec={(e) => this._setMeasureSpec(e)}
                      orientation={this.props.properties.prop.orientation}
                      paperSize={this.props.properties.prop.paperSize}
                    >
                      <div className="canves-content-wrapper">
                        <div
                          className="canves-content"
                          style={{
                            backgroundColor: this.props.properties.prop
                              .background.showColor
                              ? this.props.properties.prop.background.color
                              : "transparent",
                            width: this.props.properties.prop.orientation === "portrait" ? '210mm' : '297mm',
                            height: this.props.properties.prop.orientation === "portrait" ? '297mm' : '210mm',
                            position: 'relative',
                          }}
                        >
                          {this.props.properties.prop.background.showImage && this.props.properties.prop.background.image && (
                            <div
                              className="background-image-layer"
                              style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundImage: `url(${this.props.properties.prop.background.image})`,
                                backgroundSize: this.props.properties.prop.background.imageSize
                                  ? `${this.props.properties.prop.background.imageSize}%`
                                  : 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                opacity: this.props.properties.prop.background.opacity || 1,
                                zIndex: 0,
                              }}
                            />
                          )}

                          {/* Equal-spacing and page-centre guides while moving. */}
                          {this._renderSnapIndicators()}
                          {this._isBandsMode() ? this._renderBandsCanvas() : (<>
                          {/* Where the page number prints; click to open its settings. */}
                          {getPageNumberSettings(this.props.properties.prop).show && (
                            <div
                              className="page-number-marker"
                              role="button"
                              tabIndex={0}
                              title="Page number (printed on every page). Click to change it in Properties."
                              style={{ ...getPageNumberStyle(this.props.properties.prop, this.props.properties.foot?.font), zIndex: 2 }}
                              onMouseDown={(e) => e.stopPropagation()}
                              onClick={this._openPageNumberSettings}
                              onKeyDown={(e) => {
                                if (e.key === "Enter" || e.key === " ") {
                                  e.preventDefault();
                                  this._openPageNumberSettings();
                                }
                              }}
                            >
                              {formatPageNumber(getPageNumberSettings(this.props.properties.prop).format, 1, "N")}
                            </div>
                          )}

                          <div
                            className="content-container"
                            style={{
                              position: 'relative',
                              zIndex: 1,
                            }}
                          >
                            <div id="templateContainer">
                              <div className="simple-vertical">
                                <Split
                                  className="split-vertical"
                                  style={this.props.properties.prop.orientation === "portrait" ? { height: '297mm' } : { height: '210mm' }}
                                  direction="vertical"
                                  sizes={this.state.splitSizes}
                                  onSetSizes={this._handleSplitSize}
                                >
                                  <div
                                    className="content canves-header "
                                    data-canvas-section="head"
                                    style={{
                                      height: '100%',
                                      backgroundColor: this.props.properties.head
                                        .background.showColor
                                        ? this.props.properties.head.background.color
                                        : "transparent",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                      style={{
                                        marginTop:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.top *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        marginLeft:
                                          this.props.properties.prop.margin ?
                                            this.props.properties.prop.margin.left *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                            "px",
                                        marginRight:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.right *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        borderBottom: 0,
                                      }}
                                    >
                                      <div>
                                        {this._renderShapes("head")}
                                        {this._renderQRCodes("head")}
                                        {this._renderUploadedImages("head")}
                                        {this._renderCompanyElements()}
                                        {this._renderElements("head")}
                                        {this._renderImage("head")}
                                        {this._renderDocumentTitle()}
                                      </div>
                                    </div>
                                    <span className="info">Header</span>
                                    <span
                                      onMouseDown={(e) =>
                                        this._slideMouseDown(e, "head")
                                      }
                                      onMouseUp={(e) => this._slideMouseUp(e)}
                                      className="slider"
                                    ></span>
                                  </div>

                                  {/** end head **/}

                                  <div
                                    className="content canves-body"
                                    style={{
                                      height: this.props.heights.body + "%",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                      style={{
                                        marginLeft:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.left *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        marginRight:
                                          this.props.properties.prop.margin ? this.props.properties.prop.margin.right *
                                            this.state.measureSpec.in : this.state.measureSpec.in +
                                          "px",
                                        overflow: "hidden",
                                        borderTop: 0,
                                        borderBottom: 0,
                                      }}
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          right: 0,
                                          bottom: 0,
                                          marginLeft: this.props.properties.prop.margin.left + 'in',
                                          marginRight: this.props.properties.prop.margin.right + 'in'
                                        }}
                                      >
                                        {this._renderBodyElements(Object.keys(this.props.properties.items.items).map(t => this.props.properties.items.items[t]).filter(d => d && d.width !== undefined))}
                                      </div>
                                    </div>
                                    <span className="info">Body</span>
                                    <span
                                      onMouseDown={(e) =>
                                        this._slideMouseDown(e, "body")
                                      }
                                      onMouseUp={(e) => this._slideMouseUp(e)}
                                      className="slider"
                                    ></span>
                                  </div>
                                  {/** end body **/}

                                  <div
                                    className="content canves-total"
                                    data-canvas-section="total"
                                    style={{
                                      // height: this.props.heights.total + "%",
                                      height: '100%',
                                      backgroundColor: this.props.properties.total
                                        .background.showColor
                                        ? this.props.properties.total.background.color
                                        : "transparent",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: 0,
                                          bottom: 0,
                                        }}
                                      >
                                        {this._renderElements("total")}
                                        {this._renderVatSummary()}
                                        {this._renderShapes("total")}
                                        {this._renderQRCodes("total")}
                                        {this._renderUploadedImages("total")}
                                      </div>
                                    </div>
                                    <span className="info">Totals</span>
                                    <span
                                      onMouseDown={(e) =>
                                        this._slideMouseDown(e, "total")
                                      }
                                      onMouseUp={(e) => this._slideMouseUp(e)}
                                      className="slider"
                                    ></span>
                                  </div>
                                  {/** end total **/}

                                  <div
                                    className="content canves-footer"
                                    data-canvas-section="foot"
                                    style={{
                                      // height: this.props.heights.foot + "%",
                                      height: "100%",
                                      backgroundColor: this.props.properties.foot
                                        .background.showColor
                                        ? this.props.properties.foot.background.color
                                        : "transparent",
                                    }}
                                  >
                                    <div
                                      className="canves-content-children"
                                    >
                                      <div
                                        style={{
                                          position: "absolute",
                                        }}
                                      >
                                        {this._renderElements("foot")}
                                        {this._renderShapes("foot")}
                                        {this._renderQRCodes("foot")}
                                        {this._renderUploadedImages("foot")}
                                      </div>
                                    </div>
                                    <span className="info">Footer</span>
                                  </div>
                                </Split>
                              </div>
                              {/** end foot **/}
                            </div>
                          </div>
                          </>)}
                        </div>
                      </div>
                    </Ruler>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right-hand properties panel for the selected element(s). */}
          <div className={"column nav-properties-column" + (this.state.propertiesPanelCollapsed ? " is-collapsed" : "")}>
            {this.state.propertiesPanelCollapsed ? (
              <button
                type="button"
                className={"properties-panel-expand" + (this.state.selectedElementName !== "" ? " has-selection" : "")}
                title={this.state.selectedElementName !== "" ? "Show properties of the selected element" : "Show element properties"}
                onClick={() => this._setPropertiesPanelCollapsed(false)}
              >
                <FontAwesomeIcon icon="angle-double-left" />
                <span>Properties</span>
              </button>
            ) : (
              <>
                <div className="column-header properties-panel-header">
                  <span className="font-large">Element Properties</span>
                  <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                    <button
                      type="button"
                      className="btn btn-link text-dark p-0"
                      title="Keyboard shortcuts (?)"
                      aria-label="Keyboard shortcuts"
                      onClick={() => this.setState({ showShortcuts: true })}
                    >
                      <FontAwesomeIcon icon="question-circle" />
                    </button>
                    <button
                      type="button"
                      className="btn btn-link text-dark p-0"
                      title="Hide panel"
                      onClick={() => this._setPropertiesPanelCollapsed(true)}
                    >
                      <FontAwesomeIcon icon="angle-double-right" />
                    </button>
                  </div>
                </div>
                <div className="column-body properties-panel">
                  {this.state.selectedElementName === "" ? (
                    <div className="properties-panel-empty">
                      <FontAwesomeIcon icon="mouse-pointer" />
                      <p>Select an element on the canvas to edit it.</p>
                      <small>Ctrl or Shift + click to select several.</small>
                      {this.state.lastDeleted && (
                        <div className="properties-panel-undo mt-3">
                          <span>
                            Deleted {this.state.lastDeleted.length} element{this.state.lastDeleted.length === 1 ? "" : "s"}.
                          </span>
                          <button
                            type="button"
                            className="btn btn-sm btn-link p-0 ms-2"
                            title="Undo (Ctrl+Z)"
                            onClick={this._undoDelete}
                          >
                            Undo
                          </button>
                        </div>
                      )}
                      {this.state.copiedElementCount > 0 && (
                        <div className="mt-3">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            title="Paste (Ctrl+V). Click an empty spot in a section first to paste there."
                            onClick={() => this._pasteElements()}
                          >
                            <FontAwesomeIcon icon="paste" className="me-1" />
                            Paste {this.state.copiedElementCount} element{this.state.copiedElementCount === 1 ? "" : "s"}
                            {this._getPasteTargetSection() ? ` into ${SECTION_LABELS[this._getPasteTargetSection()]}` : ""}
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="properties-panel-summary">
                        {this._getSelectionSummary()}
                      </div>

                      {(this._canSelectedElementHaveFontColor() || this._isMultiSelection()) && (
                        <div className="properties-panel-section">
                          <div className="properties-panel-section-title">Text</div>
                          <div className="toolbar-buttons">
                              {this.toolbarGroups.map((group, groupIndex) => (
                                <div className="toolbar-group" key={`tg-${groupIndex}`}>
                                  {group.map((key) => {
                                    const obj = this.editIcons[key];
                                    if (!obj) return null;
                                    const isActive = this._getButtonActiveState(obj);
                                    return (
                                      <button
                                        key={key}
                                        type="button"
                                        className={"toolbar-btn" + (isActive ? " active" : "")}
                                        title={obj.title}
                                        aria-pressed={obj.isToggle ? !!isActive : undefined}
                                        onClick={() => {
                                          this._handleStyleUpdate(
                                            obj.property,
                                            obj.value,
                                            obj.isIncrement,
                                            obj.isHeading,
                                            obj.isToggle,
                                            obj.offValue,
                                            obj.isList
                                          );
                                        }}
                                      >
                                        {obj.label
                                          ? <span className="toolbar-btn-label" aria-hidden="true">{obj.label}</span>
                                          : <i className={"bi bi-" + obj.icon}></i>}
                                      </button>
                                    );
                                  })}
                                </div>
                              ))}
                          </div>
                        </div>
                      )}

                      <div className="properties-panel-section">
                          <div className="properties-panel-section-title">Arrange</div>
                          <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                            {this._renderActionRow({
                              icon: "copy",
                              label: "Copy",
                              keys: ["Mod", "C"],
                              disabled: this._getCopyableRefs().length === 0,
                              onClick: () => this._copySelection(),
                            })}
                            {this._renderActionRow({
                              icon: "paste",
                              label: this.state.copiedElementCount && this._getPasteTargetSection()
                                ? `Paste into ${SECTION_LABELS[this._getPasteTargetSection()]}`
                                : "Paste",
                              keys: ["Mod", "V"],
                              disabled: !this.state.copiedElementCount,
                              title: this.state.copiedElementCount
                                ? `Paste into ${SECTION_LABELS[this._getPasteTargetSection()] || "section"}. Click an empty spot in another section first to paste there`
                                : "Nothing copied yet",
                              onClick: () => this._pasteElements(),
                            })}
                            {this._renderActionRow({
                              icon: "clone",
                              label: "Duplicate",
                              keys: ["Mod", "D"],
                              disabled: this._getDuplicableRefs().length === 0,
                              onClick: () => this._duplicateSelection(),
                            })}
                            {this._canGroupSelection() && this._renderActionRow({
                              icon: "object-group",
                              label: "Group",
                              keys: ["Mod", "G"],
                              title: `Group ${this._getSelectionRefs().length} elements`,
                              onClick: () => this._groupSelection(),
                            })}
                            {this._canUngroupSelection() && this._renderActionRow({
                              icon: "object-ungroup",
                              label: "Ungroup",
                              keys: ["Mod", "Shift", "G"],
                              onClick: () => this._ungroupSelection(),
                            })}
                            {ARRANGE_ACTIONS.map(({ action, icon, label, keys }) => (
                              <React.Fragment key={action}>
                                {this._renderActionRow({
                                  icon,
                                  label,
                                  keys,
                                  disabled: !this._getArrangedOrder(action),
                                  title: label + ". Greyed out when nothing overlaps it on that side",
                                  onClick: () => this._arrangeSelection(action),
                                })}
                              </React.Fragment>
                            ))}
                            {this._renderActionRow({
                              icon: "trash-alt",
                              label: "Delete",
                              keys: ["Del"],
                              danger: true,
                              onClick: () => this._deleteSelection(),
                            })}
                          </div>
                        </div>

                      {this._selectedElementHasToolbarFields() && (
                        <div className="properties-panel-section">
                          <div className="properties-panel-section-title">Settings</div>
                          <div className="toolbar-fields">
                                {/* Every field has the same width and height (see
                                    .toolbar-field / .toolbar-input); toggles go last. */}
                                {this._getSelectedTextElement() && (() => {
                                  const element = this._getSelectedTextElement();
                                  const isCustomText = this._isCustomTextElement(element);
                                  return (
                                    <div className="toolbar-field">
                                      <FieldLabel
                                        as="div"
                                        className="toolbar-field-label"
                                        id="element-text"
                                        text="Text"
                                        tip={isCustomText
                                          ? "Prints as written. Line breaks start new lines."
                                          : <>Keep the {"{field}"} placeholder: it&rsquo;s replaced with the value when printed. Text around it, like &ldquo;Tel: &rdquo;, prints as written.</>}
                                      />
                                      {isCustomText ? (
                                        <textarea
                                          className="form-control form-control-sm"
                                          rows={3}
                                          style={{ resize: "vertical" }}
                                          value={element.text || ""}
                                          onChange={(e) => this._handleSelectedTextChange(e.target.value)}
                                        />
                                      ) : (
                                        <input
                                          type="text"
                                          className="form-control form-control-sm toolbar-input"
                                          value={element.text || ""}
                                          onChange={(e) => this._handleSelectedTextChange(e.target.value)}
                                        />
                                      )}
                                    </div>
                                  );
                                })()}
                                {this._isSelectedElementShape() && (
                                  <div className="toolbar-field compact-colour-field">
                                    <div className="toolbar-field-label">
                                      {this._isSelectedElementLine() ? "Line Colour" : "Fill Colour"}
                                    </div>
                                    <ColorPicker
                                      color={this._getSelectedShapeColor(
                                        this._isSelectedElementLine() ? "borderColor" : "fillColor",
                                        this._isSelectedElementLine() ? "color" : "fillColor"
                                      )}
                                      callbackFromParents={(e) => this._handleShapeColorUpdate(
                                        this._isSelectedElementLine() ? "borderColor" : "fillColor",
                                        e.hex
                                      )}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementShape() && !this._isSelectedElementLine() && (
                                  <div className="toolbar-field toolbar-field-sides">
                                    <div className="toolbar-field-label">Border</div>
                                    <div className="toolbar-segmented" role="radiogroup" aria-label="Border side">
                                      {[
                                        { value: "all", label: "All" },
                                        { value: "top", label: "Top" },
                                        { value: "right", label: "Right" },
                                        { value: "bottom", label: "Bottom" },
                                        { value: "left", label: "Left" },
                                      ].map((opt) => (
                                        <button
                                          key={opt.value}
                                          type="button"
                                          role="radio"
                                          aria-checked={this.state.shapeBorderSide === opt.value}
                                          className={this.state.shapeBorderSide === opt.value ? "active" : ""}
                                          title={opt.value === "all" ? "Edit all sides together" : `Edit the ${opt.label.toLowerCase()} border only`}
                                          onClick={() => this.setState({ shapeBorderSide: opt.value })}
                                        >
                                          {opt.label}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                {this._isSelectedElementShape() && !this._isSelectedElementLine() && (
                                  <div className="toolbar-field compact-colour-field">
                                    <div className="toolbar-field-label">
                                      Border Colour{this.state.shapeBorderSide !== "all" ? ` (${this.state.shapeBorderSide})` : ""}
                                    </div>
                                    <ColorPicker
                                      color={this._getSelectedShapeBorder()?.color}
                                      callbackFromParents={(e) => this._handleShapeBorderUpdate("color", e.hex)}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementShape() && !this._isSelectedElementLine() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">
                                      Border Thickness (px){this.state.shapeBorderSide !== "all" ? ` (${this.state.shapeBorderSide})` : ""}
                                    </div>
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control form-control-sm toolbar-input"
                                      value={this._getSelectedShapeBorder()?.width ?? ""}
                                      onChange={(e) => {
                                        const width = parseFloat(e.target.value);
                                        if (!isNaN(width) && width >= 0) this._handleShapeBorderUpdate("width", width);
                                      }}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementShape() && (
                                  <div className="toolbar-field toolbar-field-sides">
                                    <div className="toolbar-field-label">
                                      {this._isSelectedElementLine()
                                        ? "Line Style"
                                        : `Border Style${this.state.shapeBorderSide !== "all" ? ` (${this.state.shapeBorderSide})` : ""}`}
                                    </div>
                                    <div className="toolbar-segmented" role="radiogroup" aria-label="Border style">
                                      {SHAPE_BORDER_STYLES.map((opt) => (
                                        <button
                                          key={opt.value}
                                          type="button"
                                          role="radio"
                                          aria-checked={this._getSelectedShapeBorderStyle() === opt.value}
                                          className={this._getSelectedShapeBorderStyle() === opt.value ? "active" : ""}
                                          title={opt.label}
                                          onClick={() => this._handleShapeBorderStyleUpdate(opt.value)}
                                        >
                                          <span className={"border-style-swatch is-" + opt.value} aria-hidden="true" />
                                          {opt.label}
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                {this._isSelectedElementBox() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Corner Radius (px)</div>
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control form-control-sm toolbar-input"
                                      value={this._getSelectedShapeRadius()}
                                      onChange={(e) => this._handleShapeRadiusUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementBox() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label" title="Space inside the box's border that elements snap to. It doesn't change how the box prints.">
                                      Padding (px)
                                    </div>
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control form-control-sm toolbar-input"
                                      value={this._getSelectedShapePadding()}
                                      onChange={(e) => this._handleShapePaddingUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._canSelectedElementHaveFontColor() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Font</div>
                                    <select
                                      className="form-select form-select-sm toolbar-input"
                                      value={this._getSelectedElementFontFamily()}
                                      style={{ fontFamily: this._getSelectedElementFontFamily() || this._getSelectedSectionFontFamily() }}
                                      onChange={(e) => this._handleFontFamilyUpdate(e.target.value)}
                                    >
                                      <option value="" style={{ fontFamily: this._getSelectedSectionFontFamily() }}>
                                        Section default ({this._getSelectedSectionFontFamily()})
                                      </option>
                                      {FONT_FAMILIES.map((font) => (
                                        <option key={font} value={font} style={{ fontFamily: font }}>{font}</option>
                                      ))}
                                    </select>
                                  </div>
                                )}
                                {this._canSelectedElementHaveFontColor() && (
                                  <div className="toolbar-field compact-colour-field">
                                    <div className="toolbar-field-label">Font Colour</div>
                                    <ColorPicker
                                      color={this._getSelectedElementFontColor()}
                                      callbackFromParents={(e) => this._handleFontColorUpdate(e.hex)}
                                    />
                                  </div>
                                )}
                                {this._canSelectedElementHaveFontColor() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Font Size (pt)</div>
                                    <input
                                      type="number"
                                      min="1"
                                      className="form-control form-control-sm toolbar-input"
                                      placeholder="pt"
                                      value={this._getSelectedElementFontSize() ?? ""}
                                      onChange={(e) => this._handleFontSizeUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._canSelectedElementHaveFontColor() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label" title="Space between the lines of multi-line text, as a multiple of the font size. Empty = default.">Line Spacing</div>
                                    <input
                                      type="number"
                                      min={LINE_HEIGHT_MIN}
                                      max={LINE_HEIGHT_MAX}
                                      step="0.1"
                                      className="form-control form-control-sm toolbar-input"
                                      placeholder="Default"
                                      key={`line-height-${this.state.selectedElementName}`}
                                      defaultValue={this._getSelectedLineHeight()}
                                      onChange={(e) => this._handleLineHeightUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._selectedElementHasList() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">List Spacing (px)</div>
                                    <input
                                      type="number"
                                      min="0"
                                      step="1"
                                      className="form-control form-control-sm toolbar-input"
                                      title="Space between the bullet or number and the text"
                                      value={getListSpacing(this._getPrimaryElementData())}
                                      onChange={(e) => this._handleListSpacingUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementLine() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Width (px)</div>
                                    <input
                                      type="number"
                                      min="1"
                                      className="form-control form-control-sm toolbar-input"
                                      placeholder="px"
                                      value={this._getSelectedElementLineWidth()}
                                      onChange={(e) => this._handleLineWidthUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementLine() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Thickness (px)</div>
                                    <input
                                      type="number"
                                      min="1"
                                      max={LINE_THICKNESS_MAX}
                                      className="form-control form-control-sm toolbar-input"
                                      placeholder="px"
                                      value={this._getSelectedElementLineThickness()}
                                      onChange={(e) => this._handleLineThicknessUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._isSelectedElementLine() && (
                                  <div className="toolbar-field">
                                    <FieldLabel
                                      as="div"
                                      className="toolbar-field-label"
                                      id="line-angle"
                                      text="Angle (°)"
                                      tip="Turns the line around its start (its left end), clockwise: 90 points straight down, -90 straight up. Drag the handle at its end to make it longer."
                                    />
                                    <NumberValue value={this._getSelectedLineAngle()} onChange={this._setSelectedLineAngle} />
                                    <div className="toolbar-segmented mt-1">
                                      {[0, 45, 90, -45, -90].map((a) => (
                                        <button
                                          key={a}
                                          type="button"
                                          className={this._getSelectedLineAngle() === a ? "active" : ""}
                                          onClick={() => this._setSelectedLineAngle(a)}
                                        >
                                          {a}°
                                        </button>
                                      ))}
                                    </div>
                                  </div>
                                )}
                                {this._isSelectedElementGenerateModeQRCode() && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">QR Content</div>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm toolbar-input"
                                      placeholder="URL or text"
                                      value={this._getSelectedElementQRValue()}
                                      onChange={(e) => this._handleQRValueUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._getSelectedElementLink() !== null && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Link URL</div>
                                    <input
                                      type="text"
                                      className="form-control form-control-sm toolbar-input"
                                      placeholder="https://example.com"
                                      value={this._getSelectedElementLink()}
                                      onChange={(e) => this._handleLinkUpdate(e.target.value)}
                                    />
                                  </div>
                                )}
                                {this._canSelectedElementHaveCurrency() && (
                                  <div className="toolbar-field-row">
                                  {!this.props.hidesPricing && <div className="toolbar-field toolbar-field-switch">
                                    <div className="toolbar-field-label">Currency</div>
                                    <div className="form-check form-switch toolbar-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toolbarCurrencySwitch"
                                        checked={this._getSelectedElementCurrency()}
                                        onChange={(e) => this._handleCurrencyToggle(e.target.checked)}
                                      />
                                      <label className="form-check-label" htmlFor="toolbarCurrencySwitch">
                                        {this._getSelectedElementCurrency() ? "On" : "Off"}
                                      </label>
                                    </div>
                                  </div>}
                                  <div className="toolbar-field toolbar-field-switch">
                                    <div className="toolbar-field-label">Badge</div>
                                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                      <div className="form-check form-switch toolbar-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          id="toolbarBadgeSwitch"
                                          checked={getBadgeSettings(this._getSelectedBadgeElement()).enabled}
                                          onChange={(e) => this._handleBadgeToggle(e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor="toolbarBadgeSwitch">
                                          {getBadgeSettings(this._getSelectedBadgeElement()).enabled ? "On" : "Off"}
                                        </label>
                                      </div>
                                      {!this._isMultiSelection() && (
                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-secondary py-0 px-1"
                                          title="Badge style and colour rules"
                                          onClick={() => this.setState({ showBadgeSettings: true })}
                                        >
                                          <FontAwesomeIcon icon="palette" />
                                          {getBadgeSettings(this._getSelectedBadgeElement()).rules.length > 0 && (
                                            <span className="ms-1 small">{getBadgeSettings(this._getSelectedBadgeElement()).rules.length}</span>
                                          )}
                                        </button>
                                      )}
                                    </div>
                                  </div>
                                  </div>
                                )}
                                {this._getSelectedBadgeElement()?.data === CURRENT_DATE_TIME_FIELD && !this._isMultiSelection() && (
                                  <div className="toolbar-field" style={{ width: "200px" }}>
                                    <div className="toolbar-field-label">Date &amp; time format</div>
                                    <DateTimePatternField
                                      compact
                                      pattern={this._getSelectedBadgeElement().format?.pattern || ""}
                                      onChange={(pattern) => this._setSelectedElementField("format", { type: "date", pattern })}
                                    />
                                  </div>
                                )}
                                {this._getSelectedBadgeElement()?.data === COLUMN_TOTAL_FIELD && !this._isMultiSelection() && (() => {
                                  const config = this._getSelectedBadgeElement().columnTotal || {};
                                  const columns = this._getTotalableColumns();
                                  const missing = config.column && !columns.some((c) => c.key === config.column);
                                  return (
                                    <>
                                      <div className="toolbar-field">
                                        <div className="toolbar-field-label">Total of</div>
                                        <select
                                          className="form-select form-select-sm toolbar-input"
                                          title={missing ? "This column is no longer in the table; the total still prints from the item rows." : "The items-table column this totals"}
                                          value={config.column || ""}
                                          onChange={(e) => this._updateSelectedColumnTotal({ column: e.target.value })}
                                        >
                                          {missing && <option value={config.column}>{config.column} (not in the table)</option>}
                                          {columns.map((c) => <option key={c.key} value={c.key}>{c.header || c.key}</option>)}
                                        </select>
                                      </div>
                                      <div className="toolbar-field toolbar-field-switch">
                                        <div className="toolbar-field-label" title="Total each unit type separately, e.g. BOX: 10, EA: 1">Split by unit type</div>
                                        <div className="form-check form-switch toolbar-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            role="switch"
                                            id="toolbarSplitByUnitSwitch"
                                            checked={!!config.splitByUnit}
                                            onChange={(e) => this._updateSelectedColumnTotal({ splitByUnit: e.target.checked })}
                                          />
                                          <label className="form-check-label" htmlFor="toolbarSplitByUnitSwitch">{config.splitByUnit ? "On" : "Off"}</label>
                                        </div>
                                      </div>
                                      {config.splitByUnit && (
                                        <>
                                          <div className="toolbar-field">
                                            <div className="toolbar-field-label">Show as</div>
                                            <select
                                              className="form-select form-select-sm toolbar-input"
                                              value={config.unitLayout || UNIT_LAYOUTS.UNIT_FIRST}
                                              onChange={(e) => this._updateSelectedColumnTotal({ unitLayout: e.target.value })}
                                            >
                                              <option value={UNIT_LAYOUTS.UNIT_FIRST}>BOX: 10, EA: 1</option>
                                              <option value={UNIT_LAYOUTS.NUMBER_FIRST}>10 BOX, 1 EA</option>
                                            </select>
                                          </div>
                                          <div className="toolbar-field">
                                            <div className="toolbar-field-label">Between unit types</div>
                                            <select
                                              className="form-select form-select-sm toolbar-input"
                                              value={config.separator === "\n" ? "line" : "comma"}
                                              onChange={(e) => this._updateSelectedColumnTotal({ separator: e.target.value === "line" ? "\n" : ", " })}
                                            >
                                              <option value="comma">Comma</option>
                                              <option value="line">New line</option>
                                            </select>
                                          </div>
                                        </>
                                      )}
                                    </>
                                  );
                                })()}
                                {this._canSelectedElementHaveCurrency() && !this._isMultiSelection() && this._getSelectedBadgeElement()?.data !== CURRENT_DATE_TIME_FIELD && (
                                  <div className="toolbar-field">
                                    <div className="toolbar-field-label">Format</div>
                                    <select
                                      className="form-select form-select-sm toolbar-input"
                                      title="How the value prints (numbers and ISO dates only)"
                                      value={this._getSelectedFormatPreset()}
                                      onChange={(e) => {
                                        if (e.target.value !== "custom") this._setSelectedElementField("format", TEXT_FORMAT_PRESETS[e.target.value]?.format);
                                      }}
                                    >
                                      {Object.entries(TEXT_FORMAT_PRESETS)
                                        // No currency on documents without prices (collection notes).
                                        .filter(([key, preset]) => !(this.props.hidesPricing && preset.format?.type === "currency") || key === this._getSelectedFormatPreset())
                                        .map(([key, preset]) => (
                                          <option key={key} value={key}>{preset.label}</option>
                                        ))}
                                      {this._getSelectedFormatPreset() === "custom" && (
                                        <option value="custom">
                                          {this._getSelectedBadgeElement()?.data === COLUMN_TOTAL_FIELD ? "Same as the column" : "Custom"}
                                        </option>
                                      )}
                                    </select>
                                  </div>
                                )}
                                {this._canSelectedElementHaveCurrency() && (
                                  <div className="toolbar-field toolbar-field-switch">
                                    <FieldLabel
                                      as="div"
                                      className="toolbar-field-label"
                                      id="wrap-text"
                                      text="Wrap text"
                                      tip={<>On: a line longer than the box continues on the next line. Off: each line stays on one line however long, e.g. a long company name. Line breaks you type always start a new line.</>}
                                    />
                                    <div className="form-check form-switch toolbar-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toolbarWrapTextSwitch"
                                        checked={this._isTextWrapped(this._getSelectedBadgeElement())}
                                        onChange={(e) => this._setSelectedTextWrap(e.target.checked)}
                                      />
                                      <label className="form-check-label" htmlFor="toolbarWrapTextSwitch">
                                        {this._isTextWrapped(this._getSelectedBadgeElement()) ? "On" : "Off"}
                                      </label>
                                    </div>
                                  </div>
                                )}
                                {(BANDS_ENABLED || this._isBandsMode()) && this._canSelectedElementHaveCurrency() && (
                                  <div className="toolbar-field toolbar-field-switch">
                                    <FieldLabel
                                      as="div"
                                      className="toolbar-field-label"
                                      id="hide-when-empty"
                                      text="Hide when empty"
                                      tip={<>Drops each line whose {"{fields}"} all have no value, including its label text (&ldquo;Tel: {"{ContactNumber}"}&rdquo; goes when there&rsquo;s no number). If no lines are left, the element is removed and, in a band that grows, what&rsquo;s below moves up. Lines without fields always print, so this does nothing on plain text.</>}
                                    />
                                    <div className="form-check form-switch toolbar-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toolbarCollapseSwitch"
                                        checked={!!this._getSelectedBadgeElement()?.collapseEmpty}
                                        onChange={(e) => this._setBandsElementFlag("collapseEmpty", e.target.checked)}
                                      />
                                      <label className="form-check-label" htmlFor="toolbarCollapseSwitch">
                                        {this._getSelectedBadgeElement()?.collapseEmpty ? "On" : "Off"}
                                      </label>
                                    </div>
                                  </div>
                                )}
                                {(BANDS_ENABLED || this._isBandsMode()) && this._canSelectedElementHaveCurrency() && [
                                  {
                                    side: "Left",
                                    tip: <>When printed, moves sideways so the gap to the element on its left stays as designed, however long that element&rsquo;s value turns out. Example: turn it on for {"{AddressLine2}"} placed after {"{AddressLine1},"} so they print as &ldquo;Flat 2, 5 Park Road&rdquo;, not with the space the long placeholder took up. If the element on the left is empty and hidden, this one takes its place.</>,
                                  },
                                  {
                                    side: "Right",
                                    tip: <>When printed, moves sideways so the gap to the element on its right stays as designed, however long that element&rsquo;s value turns out. Example: turn it on for a &ldquo;Net Total:&rdquo; label placed before a right-aligned {"{NetTotal}"}, so the label stays next to the amount whether it prints as &ldquo;&pound;9.50&rdquo; or &ldquo;&pound;12,480.00&rdquo;. If the element on the right is empty and hidden, this one takes its place.</>,
                                  },
                                ].map(({ side, tip }) => {
                                  const field = "follow" + side;
                                  const on = !!this._getPrimaryElementData()?.[field];
                                  return (
                                    <div className="toolbar-field toolbar-field-switch" key={field}>
                                      <FieldLabel
                                        as="div"
                                        className="toolbar-field-label"
                                        id={"follow-" + side.toLowerCase()}
                                        text={"Follow the element on its " + side.toLowerCase()}
                                        tip={tip}
                                      />
                                      <div className="form-check form-switch toolbar-switch">
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          role="switch"
                                          id={"toolbarFollow" + side + "Switch"}
                                          checked={on}
                                          onChange={(e) => this._setFollowSide(side, e.target.checked)}
                                        />
                                        <label className="form-check-label" htmlFor={"toolbarFollow" + side + "Switch"}>
                                          {on ? "On" : "Off"}
                                        </label>
                                      </div>
                                    </div>
                                  );
                                })}
                                {(BANDS_ENABLED || this._isBandsMode()) && this._canSelectedElementKeepInRow() && (
                                  <div className="toolbar-field toolbar-field-switch">
                                    <FieldLabel
                                      as="div"
                                      className="toolbar-field-label"
                                      id="keep-in-row"
                                      text="Keep in row"
                                      tip={<>In a band that grows, moves down with the elements beside it, so it stays on their line when something above them gets taller. Example: turn it on for a phone number next to an email that sits under an address, or for a line, box, image or QR code beside that row. Turn it on for one side of the row only; marked elements don&rsquo;t follow each other.</>}
                                    />
                                    <div className="form-check form-switch toolbar-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toolbarKeepInRowSwitch"
                                        checked={!!this._getPrimaryElementData()?.keepInRow}
                                        onChange={(e) => this._setBandsElementFlag("keepInRow", e.target.checked)}
                                      />
                                      <label className="form-check-label" htmlFor="toolbarKeepInRowSwitch">
                                        {this._getPrimaryElementData()?.keepInRow ? "On" : "Off"}
                                      </label>
                                    </div>
                                  </div>
                                )}
                                {(BANDS_ENABLED || this._isBandsMode()) && this._isSelectedElementBox() && (
                                  <div className="toolbar-field toolbar-field-switch">
                                    <div className="toolbar-field-label" title="In a band that grows, the box grows or shrinks with what's inside it.">Stretch with content</div>
                                    <div className="form-check form-switch toolbar-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toolbarStretchSwitch"
                                        checked={!!this._getPrimaryElementData()?.stretchWithContent}
                                        onChange={(e) => this._setBandsElementFlag("stretchWithContent", e.target.checked)}
                                      />
                                      <label className="form-check-label" htmlFor="toolbarStretchSwitch">
                                        {this._getPrimaryElementData()?.stretchWithContent ? "On" : "Off"}
                                      </label>
                                    </div>
                                  </div>
                                )}
                                {(BANDS_ENABLED || this._isBandsMode()) && this._isSelectedElementBox() && (
                                  <div className="toolbar-field toolbar-field-switch">
                                    <FieldLabel
                                      as="div"
                                      className="toolbar-field-label"
                                      id="match-row"
                                      text="Match boxes beside it"
                                      tip={<>In a band that grows, keeps this box level with the boxes beside it: same top, and as tall as the tallest of them. Example: an invoice details box beside a customer box that stretches with a long address. Turn it on for every box in the row to keep them all the same height, whichever one grows.</>}
                                    />
                                    <div className="form-check form-switch toolbar-switch">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="toolbarMatchRowSwitch"
                                        checked={!!this._getPrimaryElementData()?.matchRow}
                                        onChange={(e) => this._setBandsElementFlag("matchRow", e.target.checked)}
                                      />
                                      <label className="form-check-label" htmlFor="toolbarMatchRowSwitch">
                                        {this._getPrimaryElementData()?.matchRow ? "On" : "Off"}
                                      </label>
                                    </div>
                                  </div>
                                )}
                          </div>
                        </div>
                      )}

                      {this._renderCalculationSection()}

                      {this._renderVisibilitySection()}
                    </>
                  )}
                </div>
              </>
            )}
          </div>

          {this._renderShortcutsModal()}
          {this._renderBadgeSettingsModal()}
          {this._renderAddSectionDialog()}

          {this.state.showToolTips && (
            <div
              style={{
                position: "absolute",
                top: "50px",
                bottom: 0,
                right: 0,
                transition: "right .2s ease-in-out",
                width: "450px",
                zIndex: 1000001,
                backgroundColor: "#fff",
                boxShadow: "-2px 5px 10px 1px rgb(214, 214, 214)",
              }}
            >
              <div
                className="flyout-header pagetip-header "
                style={{
                  borderBottom: "1px solid #eee",
                  top: 0,
                  left: 0,
                  right: 0,
                  position: "absolute",
                }}
              >
                <div
                  className="section notification-header"
                  style={{
                    padding: "14px 20px",
                    borderBottom: 0,
                    display: "flex",
                  }}
                >
                  <h5 className="me-auto mb-0">
                    <span
                      className="font-large align-middle"
                      style={{ margin: "12px 0px", display: "block" }}
                    >
                      Page Tips
                    </span>
                  </h5>
                  <a
                    style={{ marginTop: "10px", marginRight: "8px" }}
                    className="ms-auto text-muted"
                    onClick={(e) => {
                      this.setState({ showToolTips: false });
                    }}
                  >
                    <FontAwesomeIcon icon="times" />
                  </a>
                </div>
              </div>
              <div
                className="flyout-body sidebar-body "
                style={{
                  top: "66px",
                  bottom: 0,
                  overflowY: "scroll",
                  backgroundColor: "#FFFFFFFF",
                  paddingBottom: "50px",
                  left: 0,
                  right: 0,
                  position: "absolute",
                }}
              >
                <div id="ember2262" className="ember-view">
                  <div id="ember2263" className="ember-view"></div>
                  <div className="sub-section">
                    <div id="ember2264" className="faq-search ember-view">
                      <div className="search-field">
                        <div className="input-group btn-group ">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text"
                              style={{ height: "32px" }}
                            >
                              <FontAwesomeIcon icon="search" />
                            </span>
                          </div>
                          <input
                            placeholder="Search Help Resources"
                            id="ember2265"
                            className="form-control ember-text-field ember-view"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>
                    <ul className="faq-list font-small ml-n2">
                      <div id="ember2266" className="ember-view">
                        <div className="loading text-center ">
                          <div className="load-circle1"></div>
                          <div className="load-circle2"></div>
                          <div className="load-circle3"></div>
                          <div className="load-circle4"></div>
                          <div className="load-circle5"></div>
                        </div>
                      </div>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div
            className="fill list-header topgrad bg-light border-top"
            style={{
              left: "60px",
              width: "340px",
              bottom: "0px",
              position: "absolute",
              zIndex: 100000002,
              padding: "10px",
            }}
          >
            <div className="list-filter d-flex" style={{ alignItems: "center", gap: "3px" }}>
              <InvoicePreview
                properties={this.props.properties}
                heights={this.props.heights}
              />
              <button
                className="btn btn-sm btn-outline-secondary"
                type="button"
                title="Copy this template's whole layout"
                onClick={() => this._copyLayout()}
              >
                <FontAwesomeIcon icon="copy" />
              </button>
              <button
                className="btn btn-sm btn-outline-secondary"
                type="button"
                title={this.state.hasCopiedLayout ? "Paste a copied layout into this template" : "Copy a layout first to enable pasting"}
                disabled={!this.state.hasCopiedLayout}
                onClick={() => this._openPasteConfirm()}
              >
                <FontAwesomeIcon icon="paste" />
              </button>
              <button
                className="btn btn-sm btn-primary ember-view me-auto"
                type="submit"
                style={{ width: "64px" }}
                onClick={(e) => this._saveTemplate(e)}
              >
                {this.state.isSaving ? (
                  <FontAwesomeIcon
                    icon="spinner"
                    color="white"
                    className="rotate"
                  />
                ) : (
                  <>Save</>
                )}
              </button>
              <button
                className="btn btn-sm btn-link ms-auto"
                style={{ width: "50px", padding: "4px 0" }}
                onClick={(e) => this._closeWindow(e)}
              >
                Close
              </button>
            </div>
          </div>
        </div>

        <Modal
          show={this.state.showAlert}
          onHide={(e) => {
            this.setState({ showAlert: false });
          }}
          style={{ zIndex: 10600, backgroundColor: "#484848b3" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>The data is modified and not saved</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={(e) => {
                this.setState({ showAlert: false }, function () {
                  this._confirmClose(e);
                });
              }}
            >
              Close Window
            </Button>
            <Button
              variant="primary"
              onClick={(e) => {
                this._saveTemplate();
              }}
            >
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showPasteConfirm}
          onHide={this._cancelPasteLayout}
          style={{ zIndex: 10600, backgroundColor: "#484848b3" }}
        >
          <Modal.Header closeButton>
            <Modal.Title>Paste Layout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            This will replace this template's current Head, Items, Total, Foot and page settings with the copied layout. This can't be undone. Continue?
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this._cancelPasteLayout}>
              Cancel
            </Button>
            <Button variant="primary" onClick={this._confirmPasteLayout}>
              Paste Layout
            </Button>
          </Modal.Footer>
        </Modal>

        <Toast
          show={
            this.state.successMessage !== "" || this.state.errorMessage !== ""
          }
          onClose={() => {
            this.setState({
              successMessage: "",
              errorMessage: "",
            });
          }}
        >
          <Toast.Header
            className={
              (this.state.errorMessage === "" ? "bg-success" : "bg-danger") +
              " text-white"
            }
          >
            <strong className="me-auto">
              {this.state.errorMessage === "" ? "Hooray!" : "Oooops!!!"}
            </strong>
            <small className="pe-2">
              {formatDate(new Date(), "dddd h:mmtt d MMM yyyy")}
            </small>
          </Toast.Header>
          <Toast.Body>
            {this.state.errorMessage === "" ? (
              <>{this.state.successMessage}</>
            ) : (
              <>{this.state.errorMessage}</>
            )}
          </Toast.Body>
        </Toast>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const template = state.template;
  // Content of added bands, under their own keys like the four sections.
  const bandSections = {};
  (template.bands || []).forEach((band) => {
    if (band?.section && template[band.section] && !(band.section in bandSections)) {
      bandSections[band.section] = template[band.section];
    }
  });
  return {
    properties: {
      ...bandSections,
      prop: template.prop,
      head: template.head,
      items: template.items,
      total: template.total,
      foot: template.foot,
      bands: template.bands,
      pageFrame: template.pageFrame,
      heights: template.heights,
    },
    selectedElement: template.selectedElement,
    hidesPricing: hidesPricing(state.current.selectedTemplateType),
    heights: template.heights,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProp: (e) => dispatch(updateProp(e)),
    updateHead: (e) => dispatch(updateHead(e)),
    updateItems: (e) => dispatch(updateItems(e)),
    updateTotal: (e) => dispatch(updateTotal(e)),
    updateFoot: (e) => dispatch(updateFoot(e)),
    setSelectedElement: (section, path, index, element) =>
      dispatch(setSelectedElement(section, path, index, element)),
    moveElement: (top, left) => dispatch(moveElement(top, left)),
    resizeElement: (height, width) => dispatch(resizeElement(height, width)),
    setSectionHeight: (head, body, total, foot) =>
      dispatch(setSectionHeight(head, body, total, foot)),
    removeHeaderImage: () => dispatch(removeHeaderImage()),
    updateHeaderLogo: (logo) => dispatch(updateHeaderLogo(logo)),
    updateSplitSizes: (data) => dispatch(updateSplitSizes(data)),
    updateElementStyle: (property, value) => dispatch(updateElementStyle(property, value)),
    updateSection: (section, content) => dispatch(updateSection(section, content)),
    updateBands: (bands) => dispatch(updateBands(bands)),
    updatePageFrame: (pageFrame) => dispatch(updatePageFrame(pageFrame)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NewTemplate);

function SaveConfirmModel(props) {
  //console.log(props);

  return props.show ? (
    <Modal
      {...props}
      style={{ zIndex: 10600, backgroundColor: "#484848b3" }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Centered Modal</h4>
        <p>
          Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
          dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
          consectetur ac, vestibulum at eros.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
}
